import { LocalStorageCacher, IndexedDbCacher } from '@ca.vmedia.tv/cacher';
import { ContentType, RelatedChannelType, OnDemandRequestType, VodType, ContentGenreType, RelatedType, MediaImageTypes, ShowTypes, Api } from '@ca.vmedia.tv/swagger-api';
export { ContentType, GenreType, Language as LangPopularWords, RegistrationStatus, ShowTypes, Status, TvQualifier, VodType } from '@ca.vmedia.tv/swagger-api';
import { OnTvType, Api as Api$1 } from '@ca.vmedia.tv/swagger-v3-api';
import dayjs from 'dayjs';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Api as Api$2 } from '@ca.vmedia.tv/npas-api';
import { ApiOkta } from '@ca.vmedia.tv/okta-api';

class DomainSettings {
    sessionId;
    imagesUrlTemplate;
    isRiverTV;
    isVmediaTV;
    imagesWorkaroundUrlTemplate;
    constructor() {
        this.sessionId = null;
        this.imagesUrlTemplate = "";
        this.imagesWorkaroundUrlTemplate = "";
        this.isRiverTV = undefined;
    }
}

var VodContentType;
(function (VodContentType) {
    VodContentType[VodContentType["NewSeries"] = 1] = "NewSeries";
    VodContentType[VodContentType["NewMovies"] = 2] = "NewMovies";
    VodContentType[VodContentType["RecommendedSeries"] = 3] = "RecommendedSeries";
    VodContentType[VodContentType["RecommendedMovies"] = 4] = "RecommendedMovies";
    VodContentType[VodContentType["GenreSubitems"] = 5] = "GenreSubitems";
    VodContentType[VodContentType["MostPopularVod"] = 6] = "MostPopularVod";
    VodContentType[VodContentType["ContinueWatching"] = 7] = "ContinueWatching";
    VodContentType[VodContentType["RecentlyOnDemand"] = 8] = "RecentlyOnDemand";
    VodContentType[VodContentType["WatchAgain"] = 9] = "WatchAgain";
    VodContentType[VodContentType["AllMovies"] = 10] = "AllMovies";
    VodContentType[VodContentType["AllShows"] = 11] = "AllShows";
})(VodContentType || (VodContentType = {}));

/**
 * Genre entity.
 */
class Genre {
    id;
    name;
    childrenIds;
    genreType;
    parentId;
    vodType;
    orderNumber;
    images;
    image;
    content;
    type;
    /**
     * Entity constructor.
     *
     * @param {GenreId | null} id Genre identifier.
     * @param {string | null} name Genre name.
     * @param {ReadonlyArray<GenreId> | null} childrenIds A list of subgenres of this genre.
     * @param {ContentGenreType | null} genreType Genre type.
     * @param {GenreId | null} parentId Identifier of the parent genre if exists.
     * @param {VodType | null} vodType VOD type.
     * @param {number | null} orderNumber Order number in the enum of genre type.
     * @param {Array<MediaImage> | null} images Images related to genre.
     * @param {string | null} image Image related to genre.
     * @param {OnDemandContent | null} content Content related to genre.
     * @param {GenreType | null} type genre types premium/basic
     */
    constructor(
    /**
     * Genre identifier.
     */
    id = null, 
    /**
     * Genre name.
     */
    name = null, 
    /**
     * A list of subgenres of this genre.
     */
    childrenIds = null, 
    /**
     * Genre type.
     */
    genreType = null, 
    /**
     * Identifier of the parent genre if exists.
     */
    parentId = null, 
    /**
     * VOD type.
     */
    vodType = null, 
    /**
     * Order number in the enum of genre type.
     */
    orderNumber = null, 
    /**
     * Images related to genre.
     */
    images = null, 
    /**
     * Image related to genre.
     */
    image = null, content = null, 
    /**
     * genre types premium/basic
     *
     * 1 = Basic
     * 2 = Premium
     */
    type = null) {
        this.id = id;
        this.name = name;
        this.childrenIds = childrenIds;
        this.genreType = genreType;
        this.parentId = parentId;
        this.vodType = vodType;
        this.orderNumber = orderNumber;
        this.images = images;
        this.image = image;
        this.content = content;
        this.type = type;
    }
}

/**
 * Model of item padding.
 */
class ItemPaging {
    itemsOnPage;
    pageNumber;
    totalItems;
    totalPages;
    /**
     * Entity constructor.
     *
     * @param {number | null} itemsOnPage The number of items to display on a page.
     * @param {number | null} pageNumber Requested page number.
     * @param {number | null} totalItems Total number of items.
     * @param {number | null} totalPages Total number of pages.
     */
    constructor(
    /**
     * The number of items to display on a page.
     */
    itemsOnPage = null, 
    /**
     * Requested page number.
     */
    pageNumber = null, 
    /**
     * Total number of items.
     */
    totalItems = null, 
    /**
     * Total number of pages.
     */
    totalPages = null) {
        this.itemsOnPage = itemsOnPage;
        this.pageNumber = pageNumber;
        this.totalItems = totalItems;
        this.totalPages = totalPages;
    }
}

/**
 * Model of key value.
 */
class KeyValue {
    description;
    key;
    value;
    /**
     * Entity constructor.
     *
     * @param {string | null} description The text describing a configuration setting.
     * @param {string | null} key A string used as a key to define a specific settings value.
     * @param {string | null} value A value of a specific setting.
     */
    constructor(
    /**
     * The text describing a configuration setting.
     */
    description = null, 
    /**
     * A string used as a key to define a specific settings value.
     */
    key = null, 
    /**
     * A value of a specific setting.
     */
    value = null) {
        this.description = description;
        this.key = key;
        this.value = value;
    }
}

/**
 * Media image entity.
 */
class MediaImage {
    id;
    type;
    /**
     * Entity constructor.
     *
     * @param {MediaImageId | null} id Media image identifier.
     * @param {MediaImageTypes | null} type Media image type.
     */
    constructor(
    /**
     * Media image identifier.
     */
    id = null, 
    /**
     * Media image type.
     */
    type = null) {
        this.id = id;
        this.type = type;
    }
}

/**
 * Model of on demand content.
 */
class OnDemandContent {
    items;
    requestType;
    contentType;
    filter;
    paging;
    /**
     * Entity constructor.
     *
     * @param {ReadonlyArray<OnDemandItem> | null} items On-demand items collection.
     * @param {OnDemandRequestType | null} requestType Defines search range for the content.
     * @param {ContentType | null} contentType Request type of items.
     * @param {ContentFilter | null} filter A ContentFilter object for search parameters.
     * @param {ItemPaging | null} paging Paging specification of the search result set.
     */
    constructor(
    /**
     * On-demand items collection.
     */
    items = null, 
    /**
     * Defines search range for the content.
     */
    requestType = null, 
    /**
     * Request type of items.
     */
    contentType = null, 
    /**
     * A ContentFilter object for search parameters.
     */
    filter = null, 
    /**
     * Paging specification of the search result set.
     */
    paging = null) {
        this.items = items;
        this.requestType = requestType;
        this.contentType = contentType;
        this.filter = filter;
        this.paging = paging;
    }
}

/**
 * Model of on demand content.
 */
class OnDemandData {
    items;
    type;
    paging;
    /**
     * Entity constructor.
     *
     * @param {OnDemandItem[] | null} items On-demand items collection.
     * @param {VodContentType | null} type Defines the type of the content.
     * @param {ItemPaging | null} paging Paging specification of the search result set.
     */
    constructor(
    /**
     * On-demand items collection.
     */
    items = null, 
    /**
     * Defines the type of the content.
     */
    type = null, 
    /**
     * Paging specification of the search result set.
     */
    paging = null) {
        this.items = items;
        this.type = type;
        this.paging = paging;
    }
}

/**
 * Model of channels list.
 */
class Channels {
    items;
    total;
    /**
     * Entity constructor.
     *
     * @param {ReadonlyArray<Channel> | null} items Stored channel items collection.
     */
    constructor(
    /**
     * Stored channel items collection.
     */
    items = null, total) {
        this.items = items;
        this.total = total;
    }
}

/**
 * Model of the channel.
 */
class Channel {
    id;
    orderNum;
    readyForDvr;
    accessNum;
    isDescriptiveAudio;
    callSign;
    trickModeRestriction;
    isRestartAvailable;
    dvrWindow;
    isVCloud;
    name;
    advisory;
    description;
    bookmarked;
    images;
    image;
    contentGenres;
    /**
     * Entity constructor.
     *
     * @param {ChannelId | null} id Channel identifier.
     * @param {number | null} orderNum Current channel position in the channels list.
     * @param {boolean | null} readyForDvr The flag indicating if the channel is available for DVR service.
     * @param {number | null} accessNum Channel access number.
     * @param {boolean | null} isDescriptiveAudio Determines if descriptive audio is enabled for the channel.
     * @param {string | null} callSign Call sign of the programming service.
     * @param {TrickModeRestriction | null} trickModeRestriction Trick mode restriction.
     * @param {boolean | null} isRestartAvailable Allows to restart watching TvGuide item from the beginning.
     * @param {number | null} dvrWindow Length of the TV archive in hours.
     * @param {boolean | null} isVCloud The flag indication if the channel is available for recording in VCloud.
     * @param {string | null} name Name of the content item.
     * @param {Advisory | null} advisory Content advisory, such as restricted content.
     * @param {string | null} description Item's description.
     * @param {boolean | null} bookmarked The flag indicating that the item is marked as a favorite by a user.
     * @param {Array<MediaImage> | null} images Array of media images related to the item
     * @param {Array<number> | null} contentGenres Array of genres related to the item
     */
    constructor(
    /**
     * Channel identifier.
     */
    id = null, 
    /**
     * Current channel position in the channels list.
     */
    orderNum = null, 
    /**
     * The flag indicating if the channel is available for DVR service.
     */
    readyForDvr = null, 
    /**
     * Channel access number.
     */
    accessNum = null, 
    /**
     * Determines if descriptive audio is enabled for the channel.
     */
    isDescriptiveAudio = null, 
    /**
     * Call sign of the programming service.
     */
    callSign = null, 
    /**
     * Trick mode restriction.
     */
    trickModeRestriction = null, 
    /**
     * Allows to restart watching TvGuide item from the beginning.
     */
    isRestartAvailable = null, 
    /**
     * Length of the TV archive in hours.
     */
    dvrWindow = null, 
    /**
     * The flag indication if the channel is available for recording in VCloud.
     */
    isVCloud = null, 
    /**
     * Name of the content item.
     */
    name = null, 
    /**
     * Content advisory, such as restricted content.
     */
    advisory = null, 
    /**
     * Item's description.
     */
    description = null, 
    /**
     * The flag indicating that the item is marked as a favorite by a user.
     */
    bookmarked = null, 
    /**
     * Array of media images related to the item.
     */
    images = null, 
    /**
     * Channel icon url.
     */
    image = null, contentGenres = null) {
        this.id = id;
        this.orderNum = orderNum;
        this.readyForDvr = readyForDvr;
        this.accessNum = accessNum;
        this.isDescriptiveAudio = isDescriptiveAudio;
        this.callSign = callSign;
        this.trickModeRestriction = trickModeRestriction;
        this.isRestartAvailable = isRestartAvailable;
        this.dvrWindow = dvrWindow;
        this.isVCloud = isVCloud;
        this.name = name;
        this.advisory = advisory;
        this.description = description;
        this.bookmarked = bookmarked;
        this.images = images;
        this.image = image;
        this.contentGenres = contentGenres;
    }
}

class TypesUtils {
    static parseDate(dateString) {
        if (dateString.length > 9) {
            const timeStr = dateString.substring(6, dateString.length - 2);
            return parseInt(timeStr);
        }
        return 0;
    }
}

/**
 * Model of the recent channel.
 */
class RecentChannel {
    channelsIds;
    /**
     * Entity constructor.
     *
     * @param {ReadonlyArray<ChannelId> | null} channelsIds Array of the channels watched by a user recently.
     */
    constructor(
    /**
     * Array of the channels watched by a user recently.
     */
    channelsIds = null) {
        this.channelsIds = channelsIds;
    }
}

/**
 * Authorization error.
 */
class AuthorizationError extends Error {
    /**
     * Error constructor.
     */
    constructor() {
        super("Client isn't authorized");
    }
}

const GuideConstants = {
    CACHE_TTL: 24 * 60 * 60 * 1000, // 24 hours
    ZERO_LENGTH: 0,
    PROGRAMS_PAGE_SIZE: 2, // 2 hours
    DAYS_BEFORE: 7,
    DAYS_AFTER: 7,
    VCLOUD_AVAILABLE_TIME_IN_MIN: 12 // 12 minutes
};

/**
 * The base class for ProgramGuideItem and OnDemandItem.
 */
class PlayItem {
    id;
    name;
    shortName;
    recentAirTime;
    lengthInS;
    contentType;
    image;
    description;
    length;
    seriesName;
    seasonNumber;
    showType;
    seriesDescription;
    seasonDescription;
    shortDescription;
    episodeNum;
    containerId;
    isContainer;
    advisory;
    bookmarked;
    itemDate;
    images;
    channelImage;
    startTime;
    isRestartAvailable;
    contentGenres;
    topGenreId;
    TrailerVideoId;
    IsLiveSportEvent;
    /**
     * Entity constructor.
     *
     * @param {number | null} id Item unique identifier.
     * @param {string | null} name Name of the content item.
     * @param {string | null} shortName The short name of the item.
     * @param {Schedule | null} recentAirTime Information about the most recent air time of the program on the selected channel.
     * @param {number | null} lengthInS Program run time in seconds.
     * @param {string | null} image Image related to the item
     * @param {ContentType | null} contentType Type of the item's content.
     * @param {number | null} length Program run time in seconds.
     * @param {string | null} seriesName Season name for episodes. Omitted for Standalone.
     * @param {number | null} seasonNumber Season number for episodes. Omitted for standalone.
     * @param {string | null} showType The showing type of the VOD item.
     * @param {string | null} seriesDescription The short description about series' content.
     * @param {string | null} seasonDescription The short description about season's content.
     * @param {string | null} shortDescription The short description of the item.
     * @param {number | null} episodeNum Episode number.
     * @param {number | null} containerId Identifier of a container.
     * @param {boolean | null} isContainer The flag indicating if the item is a container element.
     * @param {Advisory | null} advisory Content advisory, such as restricted content.
     * @param {string | null} description Item's description.
     * @param {boolean | null} bookmarked The flag indicating that the item is marked as a favorite by a user.
     * @param {string | null} itemDate Date associated with the item.
     * @param {Array<MediaImage> | null} images Array of media images related to the item.
     * @param {number | null} topGenreId Item's genre id.
     * @param {string | null} TrailerVideoId ID of youtube trailer.
     * @param {boolean | undefined | null} IsLiveSportEvent The flag indicating if the item is a live sport event.
     */
    constructor(id = null, name = null, shortName = null, recentAirTime = null, lengthInS = null, contentType = null, image = null, description = null, length = null, seriesName = null, seasonNumber = null, showType = null, seriesDescription = null, seasonDescription = null, shortDescription = null, episodeNum = null, containerId = null, isContainer = null, advisory = null, bookmarked = null, itemDate = null, images = null, channelImage = null, startTime = null, isRestartAvailable = null, contentGenres = null, topGenreId = null, TrailerVideoId = null, IsLiveSportEvent = null) {
        this.id = id;
        this.name = name;
        this.shortName = shortName;
        this.recentAirTime = recentAirTime;
        this.lengthInS = lengthInS;
        this.contentType = contentType;
        this.image = image;
        this.description = description;
        this.length = length;
        this.seriesName = seriesName;
        this.seasonNumber = seasonNumber;
        this.showType = showType;
        this.seriesDescription = seriesDescription;
        this.seasonDescription = seasonDescription;
        this.shortDescription = shortDescription;
        this.episodeNum = episodeNum;
        this.containerId = containerId;
        this.isContainer = isContainer;
        this.advisory = advisory;
        this.bookmarked = bookmarked;
        this.itemDate = itemDate;
        this.images = images;
        this.channelImage = channelImage;
        this.startTime = startTime;
        this.isRestartAvailable = isRestartAvailable;
        this.contentGenres = contentGenres;
        this.topGenreId = topGenreId;
        this.TrailerVideoId = TrailerVideoId;
        this.IsLiveSportEvent = IsLiveSportEvent;
    }
    static isPast(item) {
        if (!item) {
            return false;
        }
        const startTime = item.recentAirTime?.startTime;
        const now = new Date().getTime();
        if (startTime && item.lengthInS) {
            return (startTime + item.lengthInS * 1000 < now);
        }
        return false;
    }
    static isFuture(item) {
        if (!item) {
            return false;
        }
        const startTime = item.recentAirTime?.startTime;
        if (startTime) {
            return (startTime > new Date().getTime());
        }
        return false;
    }
    static isLive(item) {
        if (!item) {
            return false;
        }
        const startTime = item.recentAirTime?.startTime;
        const now = new Date().getTime();
        if (startTime && item.lengthInS) {
            return (startTime <= now && now < startTime + item.lengthInS * 1000);
        }
        return false;
    }
    static isVCloud(item, channel) {
        if (!item || !channel) {
            return false;
        }
        if (channel.isVCloud == true && channel.dvrWindow != null) {
            const startTimeMs = item.recentAirTime?.startTime;
            if (startTimeMs && item.lengthInS) {
                const now = new Date().getTime();
                const savedVcloudDelayInMin = JSON.parse(localStorage.getItem("cacher-VcloudDelay"));
                const vcloudDelayMin = savedVcloudDelayInMin && savedVcloudDelayInMin.payload ? Number(savedVcloudDelayInMin.payload) : GuideConstants.VCLOUD_AVAILABLE_TIME_IN_MIN;
                const startDVRWindowMs = now - (channel.dvrWindow * 60 * 60 * 1000);
                const endDVRWindowMs = now - (vcloudDelayMin * 60 * 1000);
                return (startDVRWindowMs < startTimeMs) && (startTimeMs + item.lengthInS * 1000) < endDVRWindowMs;
            }
        }
        return false;
    }
    static isSeries(item) {
        return item?.showType?.toLowerCase() == "series";
    }
    static isRestartAvailable(item, channel) {
        if (!item || !channel || this.isVCloud(item, channel)) {
            return false;
        }
        return Boolean(channel.isRestartAvailable && item.isRestartAvailable);
    }
    static calculateLength(item, nextItem) {
        // why generic PlayItem relies on Program specific prorerties (recentAirTime)?
        const nextStartTime = nextItem.recentAirTime?.startTime;
        const currentStartTime = item.recentAirTime?.startTime;
        if (nextStartTime !== null && currentStartTime !== null) {
            const period = nextStartTime - currentStartTime;
            if (period > 0) {
                return period / 1000;
            }
        }
        return item.lengthInS ?? GuideConstants.ZERO_LENGTH;
    }
    static isSheduleValid(item) {
        return (item.recentAirTime?.startTime !== null && item.lengthInS !== null);
    }
    // OnDemandItem can not possibly have start time
    // why this method is here then?
    // TODO: find a way to rid of static methods
    static getStartTime(item) {
        if (!item?.recentAirTime?.startTime) {
            return null;
        }
        return new Date(item.recentAirTime?.startTime);
    }
    // OnDemandItem can not possibly have finish time
    // why this method is here then?
    static getFinishTime(item) {
        if (!item?.recentAirTime?.startTime || !item.lengthInS) {
            return null;
        }
        return new Date(item.recentAirTime?.startTime + +item.lengthInS * 1000);
    }
}

/**
 * Model of on demand item.
 */
class OnDemandItem extends PlayItem {
    episodesCount;
    purchasedTillUTC;
    seriesName;
    seasonNumber;
    showType;
    vodType;
    topGenreId;
    seriesDescription;
    seasonDescription;
    shortDescription;
    episodeNum;
    containerId;
    isContainer;
    status;
    advisory;
    description;
    bookmarked;
    itemDate;
    images;
    image;
    contentGenres;
    TrailerVideoId;
    /**
     * Entity constructor.
     *
     * @param {ContentType | null} contentType Type of the item's content.
     * @param {number | null} id Item unique identifier.
     * @param {number | null} episodesCount Number of episodes/parts of a multipart program.
     * @param {number | null} length Program run time in seconds.
     * @param {string | null} purchasedTillUTC Date and time that the item is purchased for in UTC format.
     * @param {string | null} seriesName Season name for episodes. Omitted for Standalone.
     * @param {number | null} seasonNumber Season number for episodes. Omitted for standalone.
     * @param {string | null} showType The showing type of the VOD item.
     * @param {VodType | null} vodType The type of the VOD content.
     * @param {number | null} topGenreId Item's top genre identifier.
     * @param {string | null} seriesDescription The short description about series' content.
     * @param {string | null} seasonDescription The short description about season's content.
     * @param {string | null} shortName The short name of the item.
     * @param {string | null} shortDescription The short description of the item.
     * @param {string | null} name Name of the content item.
     * @param {number | null} episodeNum Episode number.
     * @param {number | null} containerId Identifier of a container.
     * @param {boolean | null} isContainer The flag indicating if the item is a container element.
     * @param {Status | null} status Status of the item availability for a client.
     * @param {Advisory | null} advisory Content advisory, such as restricted content.
     * @param {string | null} description Item's description.
     * @param {boolean | null} bookmarked The flag indicating that the item is marked as a favorite by a user.
     * @param {string | null} itemDate Date associated with the item.
     * @param {Array<MediaImage> | null} images Array of media images related to the item.
     * @param {number[] | null} contentGenres IDs of content genres.
     * @param {string | null} TrailerVideoId ID of youtube trailer.
     */
    constructor(
    /**
     * Type of the item's content.
     */
    contentType = null, 
    /**
     * Item unique identifier.
     */
    id = null, 
    /**
     * Number of episodes/parts of a multipart program.
     */
    episodesCount = null, 
    /**
     * Program run time in seconds.
     */
    length = null, 
    /**
     * Date and time that the item is purchased for in UTC format.
     */
    purchasedTillUTC = null, 
    /**
     * Season name for episodes. Omitted for Standalone.
     */
    seriesName = null, 
    /**
     * Season number for episodes. Omitted for standalone.
     */
    seasonNumber = null, 
    /**
     * The showing type of the VOD item.
     */
    showType = null, 
    /**
     * The type of the VOD content.
     */
    vodType = null, 
    /**
     * Item's top genre identifier.
     */
    topGenreId = null, 
    /**
     * The short description about series' content.
     */
    seriesDescription = null, 
    /**
     * The short description about season's content.
     */
    seasonDescription = null, 
    /**
     * The short name of the item.
     */
    shortName = null, 
    /**
     * The short description of the item.
     */
    shortDescription = null, 
    /**
     * Name of the content item.
     */
    name = null, 
    /**
     * Episode number.
     */
    episodeNum = null, 
    /**
     * Identifier of a container.
     */
    containerId = null, 
    /**
     * The flag indicating if the item is a container element.
     */
    isContainer = null, 
    /**
     * Status of the item availability for a client.
     */
    status = null, 
    /**
     * Content advisory, such as restricted content.
     */
    advisory = null, 
    /**
     * Item's description.
     */
    description = null, 
    /**
     * The flag indicating that the item is marked as a favorite by a user.
     */
    bookmarked = null, 
    /**
     * Date associated with the item.
     */
    itemDate = null, 
    /**
     * Array of media images related to the item.
     */
    images = null, 
    /**
     * Image related to the item.
     */
    image = null, 
    /**
     * IDs of content genres.
     */
    contentGenres = null, 
    /**
     * ID of youtube trailer.
     */
    TrailerVideoId = null) {
        super(id, name, shortName, null, length, contentType, image, description, length, seriesName, seasonNumber, showType, seriesDescription, seasonDescription, shortDescription, episodeNum, containerId, isContainer, advisory, bookmarked, itemDate, images);
        this.episodesCount = episodesCount;
        this.purchasedTillUTC = purchasedTillUTC;
        this.seriesName = seriesName;
        this.seasonNumber = seasonNumber;
        this.showType = showType;
        this.vodType = vodType;
        this.topGenreId = topGenreId;
        this.seriesDescription = seriesDescription;
        this.seasonDescription = seasonDescription;
        this.shortDescription = shortDescription;
        this.episodeNum = episodeNum;
        this.containerId = containerId;
        this.isContainer = isContainer;
        this.status = status;
        this.advisory = advisory;
        this.description = description;
        this.bookmarked = bookmarked;
        this.itemDate = itemDate;
        this.images = images;
        this.image = image;
        this.contentGenres = contentGenres;
        this.TrailerVideoId = TrailerVideoId;
    }
}

/**
 * Model of program guide item.
 */
class ProgramGuideItem extends PlayItem {
    isRestartAvailable;
    isLookBackAvailable;
    seriesName;
    seasonNumber;
    showType;
    seriesDescription;
    seasonDescription;
    shortDescription;
    episodeNum;
    containerId;
    isContainer;
    advisory;
    description;
    bookmarked;
    itemDate;
    images;
    type;
    subImage;
    streamPosition;
    startTime;
    schedules;
    showing;
    ProgramType;
    Qualifiers;
    providerProgramId;
    ContainerProviderProgramId;
    SeriesImages;
    IsRestricted;
    IsLiveSportEvent;
    episodesCount;
    startOffset;
    featured;
    daysAvailable;
    elementType;
    purchased;
    price;
    purchasedTillUTC;
    vodType;
    Watched;
    topGenreId;
    licensingWindowStart;
    licensingWindowEnd;
    DeepLinks;
    ReleaseDate;
    InternalGenreIds;
    AccessOptions;
    TrailerVideoId;
    Slug;
    availableFormats;
    contentGenres;
    suggestedItems;
    status;
    imageCount;
    children;
    rating;
    ImageIds;
    misc;
    id;
    /**
     * Entity constructor.
     *
     * @param {Schedule | null} recentAirTime Information about the most recent air time of the program on the selected channel.
     * @param {boolean | null} isRestartAvailable A flag indicating if it's possible to restart the item from the beginning.
     * @param {boolean | null} isLookBackAvailable A flag indicating if Lookback recording is available for the item.
     * @param {number | null} ProgramId Identifier of item program.
     * @param {number | null} length Program run time in minutes.
     * @param {string | null} SeriesName Season name for episodes. Omitted for Standalone.
     * @param {number | null} seasonNumber Season number for episodes. Omitted for standalone.
     * @param {string | null}
     * @param {string | null} showType The showing type of the VOD item ('Movie', 'Movies', 'Series', 'TV show').
     * @param {string | null} seriesDescription The short description about series' content.
     * @param {string | null} seasonDescription The short description about season's content.
     * @param {string | null} shortName The short name of the item.
     * @param {string | null} shortDescription The short description of the item.
     * @param {string | null} name Name of the content item.
     * @param {number | null} episodeNum Episode number.
     * @param {number | null} containerId Identifier of a container.
     * @param {boolean | null} isContainer The flag indicating if the item is a container element.
     * @param {Advisory | null} advisory Content advisory, such as restricted content.
     * @param {string | null} description Item's description.
     * @param {boolean | null} bookmarked The flag indicating that the item is marked as a favorite by a user.
     * @param {string | null} itemDate Date associated with the item.
     * @param {Array<MediaImage> | null} Images Array of media images related to the item.
     * @param {ReadonlyArray<numver> | null} ImageIds Array of media image ids related to the item.
     * @param {ContentType | null} type Item type.
     */
    constructor(
    /**
     * Information about the most recent air time of the program on the selected channel.
     */
    recentAirTime = null, 
    /**
     * A flag indicating if it's possible to restart the item from the beginning.
     */
    isRestartAvailable = null, 
    /**
     * A flag indicating if Lookback recording is available for the item.
     */
    isLookBackAvailable = null, 
    /**
     * Identifier of item program.
     */
    programId = null, 
    /**
     * Program run time in minutes.
     */
    length = null, 
    /**
     * Season name for episodes. Omitted for Standalone.
     */
    seriesName = null, 
    /**
     * Season number for episodes. Omitted for standalone.
     */
    seasonNumber = null, 
    /**
     * The showing type of the VOD item ('Movie', 'Movies', 'Series', 'TV show').
     */
    showType = null, 
    /**
     * The short description about series' content.
     */
    seriesDescription = null, 
    /**
     * The short description about season's content.
     */
    seasonDescription = null, 
    /**
     * The short name of the item.
     */
    shortName = null, 
    /**
     * The short description of the item.
     */
    shortDescription = null, 
    /**
     * Name of the content item.
     */
    name = null, 
    /**
     * Episode number.
     */
    episodeNum = null, 
    /**
     * Identifier of a container.
     */
    containerId = null, 
    /**
     * The flag indicating if the item is a container element.
     */
    isContainer = null, 
    /**
     * Content advisory, such as restricted content.
     */
    advisory = null, 
    /**
     * Item's description.
     */
    description = null, 
    /**
     * The flag indicating that the item is marked as a favorite by a user.
     */
    bookmarked = null, 
    /**
     * Date associated with the item.
     */
    itemDate = null, 
    /**
     * Array of media images related to the item.
     */
    images = null, 
    /**
     * Item type.
     */
    type = null, 
    /**
     * Image related to the item.
     */
    image = null, 
    /**
     * SubImage related to the item.
     */
    subImage = null, 
    /**
     * The progress position for vCloud programs.
     */
    streamPosition = null, 
    /**
     * The start time is programs.
     */
    startTime = null, 
    /** Other showing of this program (at different air time and/or channel). Works with ArcPlus only */
    schedules = null, 
    /** Other showings of the program on the same channel (i.e. news, episodes of the same sitcom). Works with ArcPlus only */
    showing = null, 
    /** Predefined list of possible program types */
    ProgramType = null, 
    /** Qualifiers */
    Qualifiers = null, 
    /** Program id from provider */
    providerProgramId = null, 
    /**
    * Container provider program id
    * MV**** for movie or SH**** for series
    */
    ContainerProviderProgramId = null, 
    /** Collection of images related to series */
    SeriesImages = null, 
    /** Is restricted by profile level */
    IsRestricted = null, 
    /** Is live by game date and air date */
    IsLiveSportEvent = null, 
    /**
    * Number of episodes/parts of a multipart program
    * @format int32
    */
    episodesCount = null, 
    /**
    * Reserved for future use
    * @format int32
    */
    startOffset = null, 
    /** A flag indicating that this item is promoted and recommended for viewing. */
    featured = null, 
    /**
     * Number of days the item is available (0 - just added; 1 - added yesterday; 2 - added
     * two days ago, etc.)
     * @format int32
     */
    daysAvailable = null, 
    /** Item type name (episode/part) for use with <see cref="P:Futhark.Gyfu.Contracts.Vod.OnDemandItem.episodesCount">episodesCount</see> in text label construction */
    elementType = null, 
    /** A flag indicating if the item is purchased or not */
    purchased = null, 
    /**
     * The price of the item
     * @format double
     */
    price = null, 
    /**
     * Date and time that the item is purchased for in UTC format
     * @format date-time
     */
    purchasedTillUTC = null, 
    /**
     * Scope of search of Video on demand types
     *
     * 0 = All
     * 1 = VOD
     * 2 = SVOD
     * 3 = PPV
     * 4 = CraveTV
     */
    vodType = null, 
    /** A flag indicating if the item is watched */
    Watched = null, 
    /**
     * Item's top genre ID
     * @format int32
     */
    topGenreId = null, 
    /**
     * The start of the license period
     * @format date-time
     */
    licensingWindowStart = null, 
    /**
     * The end of the license period
     * @format date-time
     */
    licensingWindowEnd = null, 
    /** Array of Deep Link data generated for the item */
    DeepLinks = null, 
    /**
     * Release date
     * @format date-time
     */
    ReleaseDate = null, 
    /** Internal genres ids */
    InternalGenreIds = null, 
    /**
     * Access options for vod items
     *
     * 1 = Free
     * 2 = Registration
     * 3 = Subscribe
     */
    AccessOptions = null, 
    /** Trailer Video id */
    TrailerVideoId = null, 
    /** slug */
    Slug = null, 
    /** IDs of available formats */
    availableFormats = null, 
    /** IDs of content genres */
    contentGenres = null, 
    /** IDs of suggested items */
    suggestedItems = null, 
    /**
     * Predefined list of possible subscription service statuses
     *
    * 1 = Available
    * 2 = Enabled
    * 3 = NA
    * 4 = PreviewAvailable
    */
    status = null, 
    /**
     * Quantity of images that relate to the item, such as posters, photos, thumbnails, etc
     * @format int32
     */
    imageCount = null, 
    /** Children list of the item */
    children = null, 
    /**
     * User's rating of the item
     * @format double
     */
    rating = null, 
    /** IDs of images related to the item */
    ImageIds = null, 
    /** Gets or sets the misc. */
    misc = null, 
    /** Item unique id */
    id = null) {
        // TODO: get rid of data inheritance, behavior should be inherited
        super(programId, name, shortName, recentAirTime, length ? (recentAirTime ? length * 60 : length) : null, type, image, description, length, seriesName, seasonNumber, showType, seriesDescription, seasonDescription, shortDescription, episodeNum, containerId, isContainer, advisory, bookmarked, itemDate, images, subImage, startTime);
        this.isRestartAvailable = isRestartAvailable;
        this.isLookBackAvailable = isLookBackAvailable;
        this.seriesName = seriesName;
        this.seasonNumber = seasonNumber;
        this.showType = showType;
        this.seriesDescription = seriesDescription;
        this.seasonDescription = seasonDescription;
        this.shortDescription = shortDescription;
        this.episodeNum = episodeNum;
        this.containerId = containerId;
        this.isContainer = isContainer;
        this.advisory = advisory;
        this.description = description;
        this.bookmarked = bookmarked;
        this.itemDate = itemDate;
        this.images = images;
        this.type = type;
        this.subImage = subImage;
        this.streamPosition = streamPosition;
        this.startTime = startTime;
        this.schedules = schedules;
        this.showing = showing;
        this.ProgramType = ProgramType;
        this.Qualifiers = Qualifiers;
        this.providerProgramId = providerProgramId;
        this.ContainerProviderProgramId = ContainerProviderProgramId;
        this.SeriesImages = SeriesImages;
        this.IsRestricted = IsRestricted;
        this.IsLiveSportEvent = IsLiveSportEvent;
        this.episodesCount = episodesCount;
        this.startOffset = startOffset;
        this.featured = featured;
        this.daysAvailable = daysAvailable;
        this.elementType = elementType;
        this.purchased = purchased;
        this.price = price;
        this.purchasedTillUTC = purchasedTillUTC;
        this.vodType = vodType;
        this.Watched = Watched;
        this.topGenreId = topGenreId;
        this.licensingWindowStart = licensingWindowStart;
        this.licensingWindowEnd = licensingWindowEnd;
        this.DeepLinks = DeepLinks;
        this.ReleaseDate = ReleaseDate;
        this.InternalGenreIds = InternalGenreIds;
        this.AccessOptions = AccessOptions;
        this.TrailerVideoId = TrailerVideoId;
        this.Slug = Slug;
        this.availableFormats = availableFormats;
        this.contentGenres = contentGenres;
        this.suggestedItems = suggestedItems;
        this.status = status;
        this.imageCount = imageCount;
        this.children = children;
        this.rating = rating;
        this.ImageIds = ImageIds;
        this.misc = misc;
        this.id = id;
    }
    static changeLength(that, newLengthInSec) {
        const item = new ProgramGuideItem(that.recentAirTime, that.isRestartAvailable, that.isLookBackAvailable, that.id, newLengthInSec / 60, that.seriesName, that.seasonNumber, that.showType, that.seriesDescription, that.seasonDescription, that.shortName, that.shortDescription, that.name, that.episodeNum, that.containerId, that.isContainer, that.advisory, that.description, that.bookmarked, that.itemDate, that.images, that.type, that.image, that.subImage, that.streamPosition, that.startTime);
        return item;
    }
}

/**
 * Abstract module class.
 */
class Module {
    /**
     * Convert AccessCredentials.
     *
     * @param {AccessCredentials} payload
     * @return {AccessCredentials}
     * @protected
     */
    convertAccessCredentials(payload) {
        return {
            sessionId: payload.sessionID ?? null,
            settings: payload.settings?.map((element) => this.convertKeyValue(element)) ?? null,
            StbMacAddress: payload.StbMacAddress ?? null,
            UserLogin: payload.UserLogin ?? null,
            UserEmail: payload.Email ?? null,
            UserPassword: payload.UserPassword ?? null,
            LoginCountry: payload.LoginCountry ?? null,
            UserSystemID: payload.UserSystemID ?? null,
            RefreshToken: payload.RefreshToken ?? null,
            IsOnNet: payload.IsOnNet ?? null
        };
    }
    /**
     * Convert AppSettings.
     *
     * @param {AppSettings} payload
     * @return {AppSettings}
     * @protected
     */
    convertAppSettings(payload) {
        return {
            appName: payload.appName ?? null,
            settings: payload.settings?.map((element) => this.convertKeyValue(element)) ?? null,
            siteId: payload.siteID ?? null
        };
    }
    /**
     * Convert Channel.
     *
     * @param {Channel} payload
     * @return {Channel}
     * @protected
     */
    convertChannel(payload) {
        return {
            accessNum: payload.accessNum ?? null,
            advisory: payload.advisory ?? null,
            bookmarked: payload.bookmarked ?? null,
            callSign: payload.CallSign ?? null,
            description: payload.description ?? null,
            dvrWindow: payload.DvrWindow ?? null,
            id: payload.id ?? null,
            images: payload.Images?.map((image) => this.convertMediaImage(image)) ?? null,
            isDescriptiveAudio: payload.IsDescriptiveAudio ?? null,
            isRestartAvailable: payload.IsRestartAvailable ?? null,
            isVCloud: payload.isVcloud ?? null,
            name: payload.name ?? null,
            orderNum: payload.orderNum ?? null,
            readyForDvr: payload.readyForDvr ?? null,
            trickModeRestriction: payload.trickModeRestriction ?? null,
            image: "",
            contentGenres: payload.contentGenres ?? null,
        };
    }
    /**
 * Convert RegisterTrialResponse.
 *
 * @param {ApiRegisterTrialResponse} payload
 * @return {RegisterTrialResponse}
 * @protected
 */
    convertRegisterTrialResponse(payload) {
        return {
            registrationStatus: payload.RegistrationStatus ?? null,
            session: payload.Session === undefined
                ? null
                : this.convertClientAppSettings(payload.Session),
        };
    }
    /**
     * Convert ClientAppSettings.
     *
     * @param {ClientAppSettings} payload
     * @return {ClientAppSettings}
     * @protected
     */
    convertClientAppSettings(payload) {
        return {
            appSettings: payload.appSettings === undefined
                ? null
                : this.convertAppSettings(payload.appSettings),
            clientCredentials: payload.clientCredentials === undefined
                ? null
                : this.convertAccessCredentials(payload.clientCredentials)
        };
    }
    /**
     * Convert OktaClientAppSettings.
     *
     * @param {ClientAppSettings} payload
     * @return {ClientAppSettings}
     * @protected
     */
    convertOktaClientAppSettings(payload) {
        return {
            refreshToken: payload.RefreshToken ?? null,
            appSettings: payload.appSettings === undefined
                ? null
                : this.convertAppSettings(payload.appSettings),
            clientCredentials: payload.clientCredentials === undefined
                ? null
                : this.convertAccessCredentials(payload.clientCredentials)
        };
    }
    /**
     * Convert ClientMessage.
     *
     * @param {ClientMessage} payload
     * @return {ClientMessage}
     * @protected
     */
    convertClientMessage(payload) {
        return {
            body: payload.body ?? null,
            expires: payload.expires ?? null,
            id: payload.id ?? null,
            isRead: payload.isRead ?? null,
            sent: payload.sent ?? null,
            subject: payload.subject ?? null,
            type: payload.Type ?? null
        };
    }
    /**
     * Convert ClientSettings.
     *
     * @param {ClientSettings} payload
     * @return {ClientSettings}
     * @protected
     */
    convertClientSettings(payload) {
        return {
            clientServices: payload.clientServices?.map((element) => this.convertClientSubscriptionService(element)) ?? null,
            language: payload.language ?? null,
            settings: payload.settings?.map((element) => this.convertKeyValue(element)) ?? null,
            streamPreference: payload.streamPreference === undefined
                ? null
                : this.convertStreamSettings(payload.streamPreference)
        };
    }
    /**
     * Convert ClientSubscriptionService.
     *
     * @param {ClientSubscriptionService} payload
     * @return {ClientSubscriptionService}
     * @protected
     */
    convertClientSubscriptionService(payload) {
        return {
            serviceContentType: payload.serviceContentType ?? null,
            serviceStatus: payload.serviceStatus ?? null
        };
    }
    /**
     * Convert ContentFilter.
     *
     * @param {ContentFilter} payload
     * @return {ContentFilter}
     * @protected
     */
    convertContentFilter(payload) {
        return {
            availableOnly: payload.availableOnly ?? null,
            contentType: payload.contentType ?? null,
            genre: payload.contentGenre === undefined
                ? null
                : this.convertGenre(payload.contentGenre),
            groupSeasons: payload.GroupSeasons ?? null,
            isContainerSearch: payload.IsContainerSearch ?? null,
            keyWord: payload.keyWord ?? null,
            orderBy: payload.orderBy ?? null,
            showType: payload.ShowType ?? null,
            visibleOnly: payload.visibleOnly ?? null
        };
    }
    /**
     * Convert Credit.
     *
     * @param {Credit} payload
     * @return {Credit}
     * @protected
     */
    convertCredit(payload) {
        return {
            characterName: payload.characterName ?? null,
            images: payload.Images?.map((image) => this.convertMediaImage(image)) ?? null,
            person: payload.person === undefined
                ? null
                : this.convertPerson(payload.person),
            role: payload.role === undefined
                ? null
                : this.convertRole(payload.role),
            image: null
        };
    }
    /**
     * Convert Mediography.
     *
     * @param {ApiMediography} payload
     * @return {MedioGraphy}
     * @protected
     */
    convertMedioGraphy(payload) {
        return {
            person: payload.Person === undefined
                ? null
                : this.convertPerson(payload.Person),
            personImage: payload.PersonImage === undefined
                ? null
                : this.convertMediaImage(payload.PersonImage),
            mediographySections: payload.MediographySections?.map((section) => this.convertMedioGraphySection(section)) ?? null,
        };
    }
    /**
     * Convert mediography.
     *
     * @param {ApiMediographySection} payload
     * @return {MedioGraphy}
     * @protected
     */
    convertMedioGraphySection(payload) {
        return {
            category: payload.Category === undefined
                ? null
                : this.convertMedioGraphyCategory(payload.Category),
            items: payload.Items?.map((item) => this.convertOnDemandItem(item)) ?? null
        };
    }
    /**
     * Convert mediography category
     *
     * @param {ApiMediographyCategory} payload
     * @return {MedioGraphyCategory}
     * @protected
     */
    convertMedioGraphyCategory(payload) {
        return {
            id: payload.Id ?? null,
            name: payload.Name ?? null
        };
    }
    /**
     * Convert DeviceSettings.
     *
     * @param {DeviceSettings} payload
     * @return {DeviceSettings}
     * @protected
     */
    convertDeviceSettings(payload) {
        return {
            hasTrial: payload.HasTrial ?? null,
            languageCode: payload.LanguageCode ?? null,
            settings: payload.Settings ?? null
        };
    }
    /**
     * Convert DRM.
     *
     * @param {Drm} payload
     * @return {Drm}
     * @protected
     */
    convertDrm(payload) {
        return {
            contentId: payload.ContentId ?? null,
            token: payload.Token ?? null,
            type: payload.Type ?? null
        };
    }
    /**
     * Convert Genre.
     *
     * @param {ContentGenre} payload
     * @return {Genre}
     * @protected
     */
    convertGenre(payload) {
        return {
            childrenIds: payload.childrenIDs ?? null,
            genreType: payload.genreType ?? null,
            id: payload.id ?? null,
            images: payload.images?.map((image) => this.convertMediaImage(image)) ?? null,
            name: payload.name ?? null,
            orderNumber: payload.orderNumber ?? null,
            parentId: payload.parentID ?? null,
            vodType: payload.vodType ?? null,
            image: null,
            content: null,
            type: payload.Type ?? null,
        };
    }
    /**
     * Convert ItemPaging.
     *
     * @param {ItemPaging} payload
     * @return {ItemPaging}
     * @protected
     */
    convertItemPaging(payload) {
        return {
            itemsOnPage: payload.itemsOnPage ?? null,
            pageNumber: payload.pageNumber ?? null,
            totalItems: payload.totalItems ?? null,
            totalPages: payload.totalPages ?? null
        };
    }
    /**
     * Convert KeyValue.
     *
     * @param {KeyValue} payload
     * @return {KeyValue}
     * @protected
     */
    convertKeyValue(payload) {
        return {
            description: payload.description ?? null,
            key: payload.key ?? null,
            value: payload.value ?? null
        };
    }
    /**
     * Convert MediaImage.
     *
     * @param {MediaImage} payload
     * @return {MediaImage}
     * @protected
     */
    convertMediaImage(payload) {
        return {
            id: payload.Id ?? null,
            type: payload.Type ?? null
        };
    }
    /**
     * Convert DeepLink.
     *
     * @param {DeepLinkVod} payload
     * @return {DeepLinkVod}
     * @protected
     */
    convertDeepLink(payload) {
        return {
            contentId: payload.ContentId ?? null,
            level: payload.Level ?? null,
            provider: payload.Provider ?? null
        };
    }
    /**
     * Convert Alert Retrieve.
     *
     * @param {UserAlert[]} payload
     * @return {UserAlert[]}
     * @protected
     */
    convertAlertRetrieve(payload) {
        return payload.map((value) => this.convertAlertRetrieveItem(value)) ?? null;
    }
    /**
     * Convert ProgramGuideItem.
     *
     * @param {ProgramGuideItem} payload
     * @return {ProgramGuideItem}
     * @protected
     */
    convertAlertRetrieveItem(payload) {
        return {
            id: payload.Id === undefined ? null : payload.Id,
            infoId: payload.InfoId === undefined ? null : payload.InfoId,
            updated: payload.Updated === undefined ? null : payload.Updated,
            expiration: payload.Expiration === undefined ? null : payload.Expiration,
            caption: payload.Caption === undefined ? null : payload.Caption,
            text: payload.Text === undefined ? null : payload.Text,
            auxMessage: payload.AuxMessage === undefined ? null : payload.AuxMessage,
            messageSoundUrl: payload.MessageSoundUrl === undefined ? null : payload.MessageSoundUrl,
            backgroundColor: payload.BackgroundColor === undefined ? null : payload.BackgroundColor,
            textColor: payload.TextColor === undefined ? null : payload.TextColor,
            textSize: payload.TextSize === undefined ? null : payload.TextSize,
            signalSoundUrl: payload.SignalSoundUrl === undefined ? null : payload.SignalSoundUrl,
            severity: payload.Severity === undefined ? null : payload.Severity
        };
    }
    /**
     * Convert MediaStream.
     *
     * @param {MediaStream} payload
     * @return {MediaStream}
     * @protected
     */
    convertMediaStream(payload) {
        return {
            drm: payload.Drm === undefined ? null : this.convertDrm(payload.Drm),
            mediaFormatId: payload.MediaFormatID ?? null,
            trickModeRestriction: payload.TrickModeRestriction ?? null,
            url: payload.URL ?? null,
            dar: payload.DAR ?? null,
        };
    }
    /**
     * Convert OnDemandContent.
     *
     * @param {OnDemandContent} payload
     * @return {OnDemandContent}
     * @protected
     */
    convertOnDemandContent(payload) {
        return {
            contentType: payload.type ?? null,
            filter: payload.filter === undefined
                ? null
                : this.convertContentFilter(payload.filter),
            items: payload.items?.map((element) => this.convertOnDemandItem(element)) ?? null,
            paging: payload.paging === undefined
                ? null
                : this.convertItemPaging(payload.paging),
            requestType: payload.requestType ?? null
        };
    }
    /**
     * Convert OnDemandItem.
     *
     * @param {OnDemandItem} payload
     * @return {OnDemandItem}
     * @protected
     */
    convertOnDemandItem(payload) {
        return new OnDemandItem(payload.contentType ?? null, payload.id ?? null, payload.episodesCount ?? null, payload.length ?? null, payload.purchasedTillUTC ?? null, payload.SeriesName ?? null, payload.SeasonNumber ?? null, payload.ShowType ?? null, payload.vodType ?? null, payload.topGenreId ?? null, payload.seriesDescription ?? null, payload.seasonDescription ?? null, payload.shortName ?? null, payload.shortDescription ?? null, payload.name ?? null, payload.episodeNum ?? null, payload.containerID ?? null, payload.isContainer ?? null, payload.status ?? null, payload.advisory ?? null, payload.description ?? null, payload.bookmarked ?? null, payload.item_date ?? null, payload.Images?.map((image) => this.convertMediaImage(image)) ?? null, null, payload.contentGenres ?? null, payload.TrailerVideoId ?? null);
    }
    /**
     * Convert Person.
     *
     * @param {Person} payload
     * @return {Person}
     * @protected
     */
    convertPerson(payload) {
        return {
            id: payload?.id ?? null,
            name: payload?.name ?? null,
            birthPlace: payload?.BirthPlace ?? null,
            birthDate: payload?.BirthDate ?? null,
            deathDate: payload?.DeathDate ?? null,
            image: null
        };
    }
    /**
     * Convert ProgramGuide.
     *
     * @param {ProgramGuide} payload
     * @return {ProgramGuide}
     * @protected
     */
    convertProgramGuide(payload) {
        return {
            filter: payload.filter === undefined
                ? null
                : this.convertContentFilter(payload.filter),
            items: payload.items?.map((value) => this.convertProgramGuideItem(value)) ?? null,
            paging: payload.paging === undefined
                ? null
                : this.convertItemPaging(payload.paging)
        };
    }
    /**
     * Convert ProgramGuideItem.
     *
     * @param {ProgramGuideItem} payload
     * @return {ProgramGuideItem}
     * @protected
     */
    convertProgramGuideItem(payload) {
        return new ProgramGuideItem(payload.recentAirTime === undefined
            ? null
            : this.convertSchedule(payload.recentAirTime), payload.isRestartAvailable ?? null, payload.isLookbackAvailable ?? null, payload.ProgramId ?? null, payload.length ?? null, payload.SeriesName ?? null, payload.SeasonNumber ?? null, payload.ShowType ?? null, payload.seriesDescription ?? null, payload.seasonDescription ?? null, payload.shortName ?? null, payload.shortDescription ?? null, payload.name ?? null, payload.episodeNum ?? null, payload.containerID ?? null, payload.isContainer ?? null, payload.advisory ?? null, payload.description ?? null, payload.bookmarked ?? null, payload.item_date ?? null, payload.Images?.map((image) => this.convertMediaImage(image)) ?? null, payload.contentType ?? null, null, null, 0, payload.startTime ?? null, payload.schedules ?? null, payload.showing ?? null, payload.ProgramType ?? null, payload.Qualifiers ?? null, payload.providerProgramId ?? null, payload.ContainerProviderProgramId ?? null, payload.SeriesImages?.map((image) => this.convertMediaImage(image)) ?? null, payload.IsRestricted ?? null, payload?.IsLiveSportEvent, payload.episodesCount ?? null, payload.startOffset ?? null, payload.featured ?? null, payload.daysAvailable ?? null, payload.elementType ?? null, payload.purchased ?? null, payload.price ?? null, payload.purchasedTillUTC ?? null, payload.vodType ?? null, payload.Watched ?? null, payload.topGenreId ?? null, payload.licensingWindowStart ?? null, payload.licensingWindowEnd ?? null, payload.DeepLinks?.map((link) => this.convertDeepLink(link)) ?? null, payload.ReleaseDate ?? null, payload.InternalGenreIds ?? null, payload.AccessOptions ?? null, payload.TrailerVideoId ?? null, payload.Slug ?? null, payload.availableFormats ?? null, payload.contentGenres ?? null, payload.suggestedItems ?? null, payload.status ?? null, payload.imageCount ?? null, payload.children ?? null, payload.rating ?? null, payload.ImageIds ?? null, payload.misc?.map((item) => this.convertKeyValue(item)) ?? null, payload.id ?? null);
    }
    /**
 * Convert FavoriteChannels.
 *
 * @param {FavoriteChannels} payload
 * @return {FavoriteChannels}
 * @protected
 */
    convertFavoriteChannels(payload) {
        return {
            items: payload.items?.map((value) => this.convertProtoItem(value)) ?? null,
            paging: payload.paging === undefined
                ? null
                : this.convertItemPaging(payload.paging)
        };
    }
    /**
     * Convert ProtoItem.
     *
     * @param {ProtoItem} payload
     * @return {ProtoItem}
     * @protected
     */
    convertProtoItem(payload) {
        return {
            contentType: payload.contentType ?? null,
            id: payload.id ?? null
        };
    }
    /**
     * Convert Role.
     *
     * @param {Role} payload
     * @return {Role}
     * @protected
     */
    convertRole(payload) {
        return {
            id: payload?.id ?? null,
            name: payload?.name ?? null
        };
    }
    /**
     * Convert Schedule.
     *
     * @param {Schedule} payload
     * @return {Schedule}
     * @protected
     */
    convertSchedule(payload) {
        //TODO: intermediate solution to save channel images in recentAirTime
        const app = window.useNuxtApp();
        const ChannelsStoreModule = app.$pinia._s.get("Channels");
        const currentChannel = ChannelsStoreModule.getNotAvailableChannels.find((item) => item.id === payload.channelID);
        return {
            archived: payload.archived ?? null,
            channelId: payload.channelID ?? null,
            id: payload.id ?? null,
            startTime: payload.startTime ? TypesUtils.parseDate(payload.startTime) : null,
            imagesChannel: currentChannel?.images ?? null,
        };
    }
    /**
     * Convert StreamSettings.
     *
     * @param {StreamSettings} payload
     * @return {StreamSettings}
     * @protected
     */
    convertStreamSettings(payload) {
        return {
            shiftTimeZoneName: payload.shiftTimeZoneName ?? null
        };
    }
    convertOktaDevice(payload) {
        return {
            deviceCode: payload.device_code ?? null,
            expiresIn: payload.expires_in ?? null,
            interval: payload.interval ?? null,
            userCode: payload.user_code ?? null,
            verificationUri: payload.verification_uri ?? null,
            verificationUriComplete: payload.verification_uri_complete ?? null,
        };
    }
    convertOktaToken(payload) {
        return {
            tokenType: payload.token_type,
            expiresIn: payload.expires_in,
            accessToken: payload.access_token,
            scope: payload.scope,
            refreshToken: payload.refresh_token,
            idToken: payload.id_token,
        };
    }
    convertVerificationCode(payload) {
        return {
            verificationCode: payload.VerificationCode ?? null,
            deviceId: payload.DeviceId ?? null,
            activeTillDate: payload.ActiveTillDate ?? null,
            activationUrl: payload.ActivationUrl ?? null,
        };
    }
    convertTrends(payload) {
        return {
            filter: null,
            items: payload.map((value) => this.convertProgramGuideItem(value)) ?? null,
            paging: null
        };
    }
    convertDateTimeSimpleResponse(payload) {
        return {
            result: payload.Result ?? null,
            message: payload.Message ?? null
        };
    }
}

/**
 * Client's channels module.
 */
class ChannelsClientModule extends Module {
    api;
    domainsSettings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api
     * @param {string} sessionId
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Session identifier.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.domainsSettings = domainsSettings;
    }
    /**
     * Get a list of channels.
     *
     * @param {boolean} availableOnly Channel availability flag.
     * @param {number} itemsCount The count of the items to load
     * @param {number} pageNumber The page number to load
     * @param {Genre} genre Genre entity.
     * @return {Promise<Channels>}
     */
    async getChannels(availableOnly, itemsCount, pageNumber, genre, IsOoh) {
        let contentGenre = undefined;
        if (genre !== undefined) {
            contentGenre = {
                childrenIDs: genre.childrenIds?.concat() ?? undefined,
                genreType: genre.genreType ?? undefined,
                id: genre.id ?? undefined,
                images: genre.images?.map(({ id, type }) => ({
                    Id: id ?? undefined,
                    Type: type ?? undefined
                })) ?? undefined,
                name: genre.name ?? undefined,
                orderNumber: genre.orderNumber ?? undefined,
                parentID: genre.parentId ?? undefined,
                vodType: genre.vodType ?? undefined
            };
        }
        const { data } = await this.api.api.channelClientCreate({
            request: {
                type: ContentType.LiveTV,
                filter: {
                    availableOnly,
                    contentGenre,
                    IsOoh
                },
                paging: {
                    itemsOnPage: itemsCount,
                    pageNumber: pageNumber,
                    totalItems: undefined,
                    totalPages: undefined
                }
            },
            sessionID: this.domainsSettings.sessionId
        });
        return {
            items: (data.items ?? []).map((channel) => this.convertChannel(channel)),
            total: data.paging?.totalItems ?? null
        };
    }
    /**
     * Get recent channels.
     *
     * @return {Promise<RecentChannel>}
     */
    async getRecentChannels() {
        const { data } = await this.api.api.channelRecentCreate({
            sessionID: this.domainsSettings.sessionId
        });
        return { channelsIds: data.channelIds ?? null };
    }
    /**
     * Get the list of VCloud channels.
     *
     * @return {Promise<Record<ChannelId, boolean>>}
     */
    async getVCloudChannels() {
        const { data } = await this.api.api.contentRecordchannelsCreate({
            sessionID: this.domainsSettings.sessionId
        });
        return data.reduce((result, element) => {
            if (element.key && element.value) {
                const id = parseInt(element.key, 10);
                result[id] = element.value === "1";
            }
            return result;
        }, {});
    }
    /**
     * Change the list of VCloud channels.
     *
     * @param {Record<ChannelId, boolean>} channels Channels identifiers.
     * @return {Promise<ReadonlyArray<KeyValue>>}
     */
    async setVCloudChannels(channels) {
        const keyValue = [];
        for (const id in channels) {
            keyValue.push({
                key: String(id),
                value: String(channels[id])
            });
        }
        const { data } = await this.api.api.contentRecordchannelsCreate({
            channels: keyValue,
            sessionID: this.domainsSettings.sessionId
        });
        return data.map((element) => this.convertKeyValue(element));
    }
    /**
     * Get client related channels.
     * @param {number} programID Id of the current item, for which related items are being searched. ScheduleId, if Showtimes type.
     * @param {boolean} availableOnly If true, return only channels available to client.
     * @return {Promise<Channels>}
     */
    async getShowtimesChannels(programID, availableOnly = true) {
        const { data } = await this.api.api.channelClientrelatedCreate({
            sessionID: this.domainsSettings.sessionId,
            request: {
                Type: RelatedChannelType.Showtimes,
                Id: programID,
                AvailableOnly: availableOnly
            }
        });
        return {
            items: (data.items ?? []).map((channel) => this.convertChannel(channel)),
            total: data.paging?.totalItems ?? null
        };
    }
}

/**
 * Guest's channels module.
 */
class ChannelsGuestModule extends Module {
    api;
    siteId;
    applicationName;
    language;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {number} siteId Site identifier.
     * @param {string} applicationName Application identifier.
     * @param {string} language Language identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Site identifier.
     *
     * @private
     */
    siteId, 
    /**
     * Application identifier.
     *
     * @private
     */
    applicationName, 
    /**
     * Language identifier.
     *
     * @private
     */
    language) {
        super();
        this.api = api;
        this.siteId = siteId;
        this.applicationName = applicationName;
        this.language = language;
    }
    /**
     * Get a list of channels.
     *
     * @param {boolean} availableOnly Channel availability flag.
     * @param {number} itemsCount The count of the items to load
     * @param {number} pageNumber The page number to load
     * @param {Genre} genre Genre entity.
     * @param {boolean | null} IsOoh Shows if the user is in our network
     * @return {Promise<Channels>}
     */
    async getChannels(availableOnly, itemsCount, pageNumber, genre, IsOoh) {
        const { data } = await this.api.api.channelAppCreate({
            appName: this.applicationName,
            request: {
                filter: {
                    availableOnly,
                    contentGenre: genre === undefined
                        ? undefined
                        : {
                            childrenIDs: genre.childrenIds?.concat() ?? undefined,
                            genreType: genre.genreType ?? undefined,
                            id: genre.id ?? undefined,
                            images: genre.images?.map(({ id, type }) => ({
                                Id: id ?? undefined,
                                Type: type ?? undefined
                            })) ?? undefined,
                            name: genre.name ?? undefined,
                            orderNumber: genre.orderNumber ?? undefined,
                            parentID: genre.parentId ?? undefined,
                            vodType: genre.vodType ?? undefined
                        },
                    IsOoh
                },
                paging: {
                    itemsOnPage: itemsCount,
                    pageNumber: pageNumber
                },
                type: 4
            },
            sLang: this.language,
            siteId: this.siteId
        });
        return {
            items: (data.items ?? []).map((channel) => this.convertChannel(channel)),
            total: data.paging?.totalItems ?? null
        };
    }
    /**
     * Get client related channels.
     * @param {number} programID Id of the current item, for which related items are being searched. ScheduleId, if Showtimes type.
     * @param {boolean} availableOnly If true, return only channels available to client.
     * @return {Promise<Channels>}
     */
    async getShowtimesChannels(programID, availableOnly = true) {
        const { data } = await this.api.api.channelApprelatedCreate({
            request: {
                Type: RelatedChannelType.Showtimes,
                Id: programID,
                AvailableOnly: availableOnly
            },
            siteId: this.siteId,
            appName: this.applicationName,
            sLang: this.language
        });
        return {
            items: (data.items ?? []).map((channel) => this.convertChannel(channel)),
            total: data.paging?.totalItems ?? null
        };
    }
}

/**
 * Channels repository.
 */
class ChannelsRepository {
    domainsSettings;
    /**
     * Client's module.
     *
     * @type {ChannelsClientModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Guest's module.
     *
     * @type {ChannelsGuestModuleInterface}
     * @private
     */
    guestModule;
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string} language
     * @param {string | null} sessionId
     */
    constructor(api, siteId, applicationName, language, domainsSettings) {
        this.domainsSettings = domainsSettings;
        this.guestModule = new ChannelsGuestModule(api, siteId, applicationName, language);
        this.clientModule = new ChannelsClientModule(api, domainsSettings);
    }
    /**
     * Get a list of channels.
     *
     * @param {boolean} availableOnly Channel availability flag.
     * @param {number} itemsCount The count of the items to load
     * @param {number} pageNumber The page number to load
     * @param {Genre} genre Genre entity.
     * @return {Promise<Channels>}
     */
    async getChannels(availableOnly, itemsCount, pageNumber, genre, isOoh) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return await this.clientModule.getChannels(availableOnly, itemsCount, pageNumber, genre, isOoh);
        }
        else {
            return await this.guestModule.getChannels(availableOnly, itemsCount, pageNumber, genre, isOoh);
        }
    }
    /**
     * Get recent channels.
     *
     * @return {Promise<RecentChannel>}
     */
    async getRecentChannels() {
        if (typeof this.domainsSettings.sessionId !== "string") {
            const channels = await this.guestModule.getChannels(true, 10, 1);
            if (channels.items !== null) {
                const ids = channels.items.map(c => c.id);
                if (ids) {
                    return new RecentChannel(ids);
                }
            }
        }
        return this.clientModule.getRecentChannels();
    }
    /**
     * Get the list of VCloud channels.
     *
     * @return {Promise<Record<ChannelId, boolean>>}
     */
    async getVCloudChannels() {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.getVCloudChannels();
    }
    /**
     * Change the list of VCloud channels.
     *
     * @param {Record<ChannelId, boolean>} channels Channels identifiers.
     * @return {Promise<ReadonlyArray<KeyValue>>}
     */
    async setVCloudChannels(channels) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.setVCloudChannels(channels);
    }
    /**
     * Get client related channels.
     * @param {number} programID Id of the current item, for which related items are being searched. ScheduleId, if Showtimes type.
     * @param {boolean} availableOnly If true, return only channels available to client.
     * @return {Promise<Channels>}
     */
    async getShowtimesChannels(programID, availableOnly = true) {
        if (this.domainsSettings.sessionId) {
            return await this.clientModule.getShowtimesChannels(programID, availableOnly);
        }
        return await this.guestModule.getShowtimesChannels(programID, availableOnly);
    }
}

/**
 * Client's client module.
 */
class ClientClientModule extends Module {
    api;
    deviceInformation;
    siteId;
    applicationName;
    domainsSettings;
    settings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {DeviceInformation} deviceInformation Device information.
     * @param {number} siteId Site identifier.
     * @param {string} applicationName Application identifier.
     * @param {string} sessionId Session identifier.
     * @param {ReadonlyArray<KeyValue>} settings Account settings.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Device information.
     */
    deviceInformation, 
    /**
     * Site identifier.
     *
     * @private
     */
    siteId, 
    /**
     * Application identifier.
     *
     * @private
     */
    applicationName, 
    /**
     * Session identifier.
     *
     * @private
     */
    domainsSettings, 
    /**
     * Account settings.
     *
     * @private
     */
    settings) {
        super();
        this.api = api;
        this.deviceInformation = deviceInformation;
        this.siteId = siteId;
        this.applicationName = applicationName;
        this.domainsSettings = domainsSettings;
        this.settings = settings;
    }
    /**
     * Get device settings.
     *
     * @return {Promise<DeviceSettings>}
     */
    async getDeviceSettings() {
        const { data } = await this.api.api.clientDevicesettingsCreate({
            appName: this.applicationName,
        });
        return this.convertDeviceSettings(data);
    }
    /**
     * Get messages.
     *
     * @return {Promise<ReadonlyArray<ClientMessage>>}
     */
    async getMessages() {
        const { data } = await this.api.api.clientMessagesGetCreate({
            sessionID: this.domainsSettings.sessionId
        });
        return data.map((message) => this.convertClientMessage(message));
    }
    /**
     * Get settings.
     *
     * @return {Promise<ClientSettings>}
     */
    async getSettings() {
        const { data } = await this.api.api.clientGetsettingsCreate({
            sessionID: this.domainsSettings.sessionId
        });
        return this.convertClientSettings(data);
    }
    /**
     * Login.
     *
     * @param {string} userName
     * @param {string} UserPassword
     * @return {Promise<ClientAppSettings>}
     */
    async login(userName, UserPassword) {
        const { data } = await this.api.api.clientLoginCreate({
            cc: {
                appSettings: {
                    appName: this.applicationName,
                    settings: this.settings.map((element) => ({
                        description: element.description ?? undefined,
                        key: element.key ?? undefined,
                        value: element.value ?? undefined
                    })),
                    siteID: this.siteId
                },
                clientCredentials: {
                    StbMacAddress: this.deviceInformation.macAddress ?? undefined,
                    UserLogin: userName,
                    UserPassword: UserPassword
                }
            },
            deviceInformation: {
                DeviceId: this.deviceInformation.deviceId ?? undefined,
                model: this.deviceInformation.model ?? undefined
            }
        });
        return this.convertClientAppSettings(data);
    }
    /**
     * Logout.
     *
     * @return {Promise<void>}
     */
    async logout() {
        await this.api.api.clientLogoutCreate({
            cc: {
                clientCredentials: {
                    sessionID: this.domainsSettings.sessionId
                }
            },
            deviceInformation: {}
        });
        this.domainsSettings.sessionId = null;
    }
    /**
     * Mark messages as read.
     *
     * @param {ReadonlyArray<number>} messageIds
     * @return {Promise<void>}
     */
    async markMessagesAsRead(messageIds) {
        await this.api.api.clientMessagesMarkreadCreate({
            messageIDs: messageIds.concat(),
            sessionID: this.domainsSettings.sessionId
        });
    }
    /**
     * Set settings.
     *
     * @param {ClientSettings} settings
     * @return {Promise<void>}
     */
    async setSettings(settings) {
        await this.api.api.clientSetsettingsCreate({
            cs: {
                clientServices: settings.clientServices?.map((element) => ({
                    serviceContentType: element.serviceContentType ?? undefined,
                    serviceStatus: element.serviceStatus ?? undefined
                })) ?? undefined,
                language: settings.language ?? undefined,
                settings: settings.settings?.map((element) => ({
                    description: element.description ?? undefined,
                    key: element.key ?? undefined,
                    value: element.value ?? undefined
                })) ?? undefined,
                streamPreference: settings.streamPreference === null
                    ? undefined
                    : {
                        shiftTimeZoneName: settings.streamPreference.shiftTimeZoneName ??
                            undefined
                    }
            },
            sessionID: this.domainsSettings.sessionId
        });
    }
    /**
     * No description
     *
     * @param {Readonly<string>} value
     * @return {Promise<DateTimeSimpleResponse>}
     */
    async setSettingsExternal(value) {
        const { data } = await this.api.api.clientSettingsExternalCreate({
            Value: value,
            sessionID: this.domainsSettings.sessionId
        });
        return this.convertDateTimeSimpleResponse(data);
    }
    /**
     * convertApiAppSettings.
     *
     * @param {ApiClientAppSettings} payload
     * @return {ClientAppSettings}
     */
    convertApiAppSettings(payload) {
        return this.convertClientAppSettings(payload);
    }
}

/**
 * Client's guest module.
 */
class ClientGuestModule extends Module {
    api;
    deviceInformation;
    siteId;
    applicationName;
    settings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {DeviceInformation} deviceInformation Device information.
     * @param {number} siteId Site identifier.
     * @param {string} applicationName Application identifier.
     * @param {ReadonlyArray<KeyValue>} settings Account settings.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Device information.
     */
    deviceInformation, 
    /**
     * Site identifier.
     *
     * @private
     */
    siteId, 
    /**
     * Application identifier.
     *
     * @private
     */
    applicationName, 
    /**
     * Account settings.
     *
     * @private
     */
    settings) {
        super();
        this.api = api;
        this.deviceInformation = deviceInformation;
        this.siteId = siteId;
        this.applicationName = applicationName;
        this.settings = settings;
    }
    /**
     * Get device settings.
     *
     * @return {Promise<DeviceSettings>}
     */
    async getDeviceSettings() {
        const { data } = await this.api.api.clientDevicesettingsCreate({
            appName: this.applicationName,
        });
        return this.convertDeviceSettings(data);
    }
    /**
     * verification code.
     *
     * @return {Promise<VerificationCode>}
     */
    async getVerificationCode() {
        const { data } = await this.api.api.clientVerificationCodeGetCreate({
            AppName: this.applicationName,
            SerialNumber: "12123123123131312312312",
            StbMacAddress: this.deviceInformation.macAddress,
        });
        return this.convertVerificationCode(data);
    }
    /**
     * Login with mac address.
     *
     * @return {Promise<ClientAppSettings>}
     */
    async loginWithMacAddress() {
        const { data } = await this.api.api.clientLoginCreate({
            cc: {
                appSettings: {
                    appName: this.applicationName,
                    settings: this.settings.map((element) => ({
                        description: element.description ?? undefined,
                        key: element.key ?? undefined,
                        value: element.value ?? undefined
                    })),
                    siteID: this.siteId
                },
                clientCredentials: {
                    StbMacAddress: this.deviceInformation.macAddress ?? undefined,
                }
            },
            deviceInformation: {
                DeviceId: this.deviceInformation.deviceId ?? undefined,
                model: this.deviceInformation.model ?? undefined
            }
        });
        return this.convertClientAppSettings(data);
    }
    /**
     * Register with mac address.
     *
     * @param {string} macAddress
     * @param {string} deviceId
     * @return {Promise<RegisterTrialResponse>}
     */
    async registerWithMacAddress(macAddress, deviceId) {
        const { data } = await this.api.api.riverRegisterCreate({
            "ApplicationName": this.applicationName,
            "AppVersion": "0.9.0",
            "Uadid": deviceId,
            "StbMacAddress": macAddress,
            "RegistrationType": 2
        });
        return this.convertRegisterTrialResponse(data);
    }
    /**
     * loginWithToken.
     *
     * @param {string} userName
     * @param {string} UserSystemID
     * @param {string} RefreshToken
     * @return {Promise<ClientAppSettings>}
     */
    async loginWithToken(userName, UserSystemID, RefreshToken) {
        const { data } = await this.api.api.clientLoginCreate({
            cc: {
                appSettings: {
                    appName: this.applicationName,
                    settings: this.settings.map((element) => ({
                        description: element.description ?? undefined,
                        key: element.key ?? undefined,
                        value: element.value ?? undefined
                    })),
                    siteID: this.siteId
                },
                clientCredentials: {
                    StbMacAddress: this.deviceInformation.macAddress ?? undefined,
                    UserLogin: userName,
                    UserSystemID: UserSystemID,
                    RefreshToken: RefreshToken,
                }
            },
            deviceInformation: {
                DeviceId: this.deviceInformation.deviceId ?? undefined,
                model: this.deviceInformation.model ?? undefined
            }
        });
        return this.convertClientAppSettings(data);
    }
    /**
     * Login.
     *
     * @param {string} userName
     * @param {string} UserPassword
     * @return {Promise<ClientAppSettings>}
     */
    async login(userName, UserPassword) {
        const { data } = await this.api.api.clientLoginCreate({
            cc: {
                appSettings: {
                    appName: this.applicationName,
                    settings: this.settings.map((element) => ({
                        description: element.description ?? undefined,
                        key: element.key ?? undefined,
                        value: element.value ?? undefined
                    })),
                    siteID: this.siteId
                },
                clientCredentials: {
                    StbMacAddress: this.deviceInformation.macAddress ?? undefined,
                    UserLogin: userName,
                    UserPassword: UserPassword
                }
            },
            deviceInformation: {
                DeviceId: this.deviceInformation.deviceId ?? undefined,
                model: this.deviceInformation.model ?? undefined
            }
        });
        return this.convertClientAppSettings(data);
    }
}

/**
 * Client repository.
 */
class ClientRepository {
    domainsSettings;
    /**
     * Client's module.
     *
     * @type {ClientClientModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Guest's module.
     *
     * @type {ClientGuestModuleInterface}
     * @private
     */
    guestModule;
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     * @param {DeviceInformation} deviceInformation
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string | null} sessionId
     * @param {ReadonlyArray<KeyValue>} settings
     */
    constructor(api, deviceInformation, siteId, applicationName, domainsSettings, settings) {
        this.domainsSettings = domainsSettings;
        this.guestModule = new ClientGuestModule(api, deviceInformation, siteId, applicationName, settings);
        this.clientModule = new ClientClientModule(api, deviceInformation, siteId, applicationName, domainsSettings, settings);
    }
    /**
     * Get device settings.
     *
     * @return {Promise<DeviceSettings>}
     */
    async getDeviceSettings() {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getDeviceSettings();
        }
        return this.guestModule.getDeviceSettings();
    }
    /**
     * Get messages
     *
     * @return {Promise<ReadonlyArray<ClientMessage>>}
     */
    async getMessages() {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.getMessages();
    }
    /**
     * Get settings.
     *
     * @return {Promise<ClientSettings>}
     */
    async getSettings() {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.getSettings();
    }
    /**
     * Register with mac address..
     *
     * @return {Promise<ClientAppSettings>}
     */
    async loginWithMacAddress() {
        return this.guestModule.loginWithMacAddress();
    }
    /**
     * Register with mac address..
     *
     * @param {string} macAddress
     * @param {string} deviceId
     * @return {Promise<RegisterTrialResponse>}
     */
    async registerWithMacAddress(macAddress, deviceId) {
        return this.guestModule.registerWithMacAddress(macAddress, deviceId);
    }
    /**
     * Get verification code..
     *

     * @return {Promise<VerificationCode>}
     */
    async getVerificationCode() {
        return this.guestModule.getVerificationCode();
    }
    /**
     * Login.
     *
     * @param {string} userName
     * @param {string} UserPassword
     * @return {Promise<ClientAppSettings>}
     */
    async login(userName, UserPassword) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.login(userName, UserPassword);
        }
        return this.guestModule.login(userName, UserPassword);
    }
    /**
     * loginWithToken.
     *
     * @param {string} userName
     * @param {string} UserSystemID
     * @param {string} RefreshToken
     * @return {Promise<ClientAppSettings>}
     */
    async loginWithToken(userName, UserSystemID, RefreshToken) {
        return this.guestModule.loginWithToken(userName, UserSystemID, RefreshToken);
    }
    /**
     * Logout.
     *
     * @return {Promise<void>}
     */
    async logout() {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.logout();
    }
    /**
     * Mark messages as read.
     *
     * @param {ReadonlyArray<number>} messageIds
     * @return {Promise<void>}
     */
    async markMessagesAsRead(messageIds) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.markMessagesAsRead(messageIds);
    }
    /**
     * Set settings.
     *
     * @param {ClientSettings} settings
     * @return {Promise<void>}
     */
    async setSettings(settings) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.setSettings(settings);
    }
    /**
     * No description
     *
     * @param {Readonly<string>} value
     * @return {Promise<DateTimeSimpleResponse>}
     */
    async setSettingsExternal(value) {
        return this.clientModule.setSettingsExternal(value);
    }
    /**
     * convertApiAppSettings.
     *
     * @param {ApiClientAppSettings} payload
     * @return {ClientAppSettings}
     */
    convertApiAppSettings(payload) {
        return this.clientModule.convertApiAppSettings(payload);
    }
}

/**
 * Guest's credits module.
 */
class CreditsGuestModule extends Module {
    api;
    siteId;
    applicationName;
    language;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {number} siteId Site identifier.
     * @param {string} applicationName Application identifier.
     * @param {string} language Language identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Site identifier.
     *
     * @private
     */
    siteId, 
    /**
     * Application identifier.
     *
     * @private
     */
    applicationName, 
    /**
     * Language identifier.
     *
     * @private
     */
    language) {
        super();
        this.api = api;
        this.siteId = siteId;
        this.applicationName = applicationName;
        this.language = language;
    }
    /**
     * Gets gracenote credits for the item for session based request.
     *
     * @param {number} id Item identifier.
     * @param {ContentType} contentType Content types.
     * @return {Promise<ReadonlyArray<Credit>>}
     */
    async getCredits(id, contentType) {
        const { data } = await this.api.api.creditAppCreate({
            appName: this.applicationName,
            request: {
                Item: { contentType, id }
            },
            sLang: this.language,
            siteId: this.siteId
        });
        return (data.credits ?? []).map((credit) => this.convertCredit(credit));
    }
    async searchCredits(keyword, pageSize, pageNumber) {
        const { data } = await this.api.api.creditSearchCreate({
            appName: this.applicationName,
            request: {
                Keyword: keyword,
                Paging: {
                    itemsOnPage: pageSize,
                    pageNumber: pageNumber
                }
            },
            sLang: this.language,
            siteId: this.siteId
        });
        const correctedData = data;
        const items = (correctedData.Credits ?? []).map((credit) => this.convertCredit(credit));
        const p = correctedData.Paging;
        const paging = new ItemPaging(p?.itemsOnPage ?? 0, p?.pageNumber ?? 0, p?.totalItems ?? 0, p?.totalPages ?? 0);
        return {
            items,
            paging
        };
    }
    /**
     * Gets person mediography
     *
     * @param {number} id Item identifier.
     * @param {ContentType} contentType Content types.
     * @return {Promise<MedioGraphy>}
     */
    async getMedioGraphy(id, contentType) {
        const { data } = await this.api.api.creditMediographyAppCreate({
            appName: this.applicationName,
            request: {
                Item: { contentType, id }
            },
            sLang: this.language,
            siteId: this.siteId
        });
        return this.convertMedioGraphy(data);
    }
    /**
     * Get persons for People also search row.
     *
     * @param {number} id Item identifier.
     * @param {ContentType} contentType Content types.
     * @return {Promise<ReadonlyArray<Credit>>}
     */
    async searchRelatedCredits(id, contentType) {
        const { data } = await this.api.api.creditPersonSearchRelatedCreate({
            appName: this.applicationName,
            request: {
                Item: { contentType, id }
            },
            sLang: this.language,
            siteId: this.siteId
        });
        return (data.credits ?? []).map((credit) => this.convertCredit(credit));
    }
}

/**
 * Client's credits module.
 */
class CreditsClientModule extends Module {
    api;
    domainsSettings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {DomainSettings} domainsSettings Session identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Session identifier.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.domainsSettings = domainsSettings;
    }
    /**
     * Gets person mediography
     *
     * @param {number} id Item identifier.
     * @param {ContentType} contentType Content types.
     * @return {Promise<MedioGraphy>}
     */
    async getMedioGraphy(id, contentType) {
        const { data } = await this.api.api.creditMediographyClientCreate({
            request: {
                Item: { contentType, id }
            },
            sessionID: this.domainsSettings.sessionId
        });
        return this.convertMedioGraphy(data);
    }
}

/**
 * Credits repository.
 */
class CreditsRepository {
    domainsSettings;
    idbCacher;
    /**
     * Client's module.
     *
     * @type {CreditsClientModule}
     * @private
     */
    clientModule;
    /**
     * Guest's module.
     *
     * @type {CreditsModuleInterface}
     * @private
     */
    guestModule;
    /**
     * Lifetime.
     *
     * @type {number}
     * @private
     */
    ttl = 12 * 60 * 60 * 1000; // 12 hours
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     * @param {IDBCacherInterface} cacher
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string} language
     */
    constructor(api, siteId, applicationName, language, domainsSettings, idbCacher) {
        this.domainsSettings = domainsSettings;
        this.idbCacher = idbCacher;
        this.guestModule = new CreditsGuestModule(api, siteId, applicationName, language);
        this.clientModule = new CreditsClientModule(api, domainsSettings);
    }
    /**
     * Gets gracenote credits for the item for session based request.
     *
     * @param {number} id Item identifier.
     * @param {ContentType} contentType Content types.
     * @return {Promise<ReadonlyArray<Credit>>}
     */
    async getCredits(id, contentType) {
        const key = `getCredits:${id}:${contentType}`;
        const cached = await this.idbCacher.get(key).catch((e) => {
            console.error(e);
            return null;
        });
        if (cached !== null) {
            return cached;
        }
        const result = await this.guestModule.getCredits(id, contentType);
        this.idbCacher.put(key, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    async searchCredits(keyword, pageSize, pageNumber) {
        return await this.guestModule.searchCredits(keyword, pageSize, pageNumber);
    }
    async getMedioGraphy(id, contentType) {
        const isClient = typeof this.domainsSettings.sessionId === "string";
        const key = isClient ? `getMedioGraphy:${id}:${contentType}:${this.domainsSettings.sessionId}` : `getMedioGraphy:${id}:${contentType}`;
        const cached = await this.idbCacher.get(key).catch((e) => {
            console.error(e);
            return null;
        });
        if (cached !== null) {
            return cached;
        }
        let result = null;
        if (isClient) {
            result = await this.clientModule.getMedioGraphy(id, contentType);
        }
        else {
            result = await this.guestModule.getMedioGraphy(id, contentType);
        }
        this.idbCacher.put(key, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get persons for People also search row.
     *
     * @param {number} id Item identifier.
     * @param {ContentType} contentType Content types.
     * @return {Promise<ReadonlyArray<Credit>>}
     */
    async searchRelatedCredits(id, contentType) {
        const key = `searchRelatedCredits:${id}:${contentType}`;
        const cached = await this.idbCacher.get(key).catch((e) => {
            console.error(e);
            return null;
        });
        if (cached !== null) {
            return cached;
        }
        const result = await this.guestModule.searchRelatedCredits(id, contentType);
        this.idbCacher.put(key, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
}

/**
 * Client's favorites module.
 */
class FavoritesClientModule extends Module {
    api;
    domainsSettings;
    /**
     * @type {string}
     * @private
     */
    FILTER_ORDER_BY = "release_date DESC";
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {string} sessionId Session identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Session identifier.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.domainsSettings = domainsSettings;
    }
    /**
     * Add item to favorites list.
     *
     * @param {ReadonlyArray<ProtoItem>} items
     * @return {Promise<ProtoItemId>}
     */
    async addToFavourites(items) {
        const { data } = await this.api.api.v2FavoritesAddCreate({
            items: items.map((item) => ({
                contentType: item.contentType ?? 0,
                id: item.id ?? 0
            })),
            sessionID: this.domainsSettings.sessionId
        });
        return data;
    }
    /**
     * Delete item to favorites list.
     *
     * @param {ReadonlyArray<ProtoItem>} items
     * @return {Promise<ProtoItemId>}
     */
    async deleteFromFavourites(items) {
        const { data } = await this.api.api.v2FavoritesDeleteCreate({
            items: items.map((item) => ({
                contentType: item.contentType ?? 0,
                id: item.id ?? 0
            })),
            sessionID: this.domainsSettings.sessionId
        });
        return data;
    }
    /**
     * Get a list of favorite channels.
     *
     * @return {Promise<FavoriteChannels>}
     */
    async getFavoritesChannels(pageNumber, pageSize) {
        const { data } = await this.api.api.v2FavoritesChannelsCreate({
            paging: {
                itemsOnPage: pageSize,
                pageNumber: pageNumber,
                totalItems: undefined,
                totalPages: undefined
            },
            sessionID: this.domainsSettings.sessionId,
            type: ContentType.LiveTV
        });
        return this.convertFavoriteChannels(data);
    }
    /**
     * Get a list of favorite.
     *
     * @param {number} pageNumber
     * @param {number} pageSize
     * @return {Promise<OnDemandContent>}
     */
    async getFavoritesOnDemand(pageNumber, pageSize) {
        const { data } = await this.api.api.v2FavoritesVodItemsCreate({
            sessionID: this.domainsSettings.sessionId,
            vodRequest: {
                filter: {
                    availableOnly: true,
                    contentType: ContentType.SVOD,
                    DontFetchDetails: false,
                    favoritesOnly: true,
                    GroupSeasons: true,
                    HasImagesOnly: false,
                    IsContainerSearch: true,
                    orderBy: this.FILTER_ORDER_BY,
                    showItems: true,
                    visibleOnly: true
                },
                paging: {
                    itemsOnPage: pageSize,
                    pageNumber: pageNumber,
                    totalItems: undefined,
                    totalPages: undefined
                },
                requestType: OnDemandRequestType.AllItems,
                type: ContentType.SVOD,
                utcTime: true,
                vodType: VodType.All
            }
        });
        return this.convertOnDemandContent(data);
    }
    /**
     * Get a list of favorite programs.
     *
     * @return {Promise<ProgramGuide>}
     */
    async getFavoritesPrograms(pageNumber, pageSize) {
        const { data } = await this.api.api.v2FavoritesProgramsCreate({
            paging: {
                itemsOnPage: pageSize,
                pageNumber: pageNumber,
                totalItems: undefined,
                totalPages: undefined
            },
            sessionID: this.domainsSettings.sessionId,
            type: ContentType.DVR
        });
        return this.convertProgramGuide(data);
    }
}

/**
 * Favorites repository.
 */
class FavoritesRepository {
    domainsSettings;
    /**
     * Client's module.
     *
     * @type {FavoritesModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     * @param {string | null} sessionId
     */
    constructor(api, domainsSettings) {
        this.domainsSettings = domainsSettings;
        this.clientModule = new FavoritesClientModule(api, domainsSettings);
    }
    /**
     * Add item to favorites list.
     *
     * @param {ReadonlyArray<ProtoItem>} items
     * @return {Promise<ProtoItemId>}
     */
    async addToFavourites(items) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.addToFavourites(items);
    }
    /**
     * Delete item to favorites list.
     *
     * @param {ReadonlyArray<ProtoItem>} items
     * @return {Promise<ProtoItemId>}
     */
    async deleteFromFavourites(items) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.deleteFromFavourites(items);
    }
    /**
     * Get a list of favorite channels.
     *
     * @return {Promise<ReadonlyArray<ProtoItem>>}
     */
    async getFavoritesChannels(pageNumber, pageSize) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.getFavoritesChannels(pageNumber, pageSize);
    }
    /**
     * Get a list of favorite.
     *
     * @param {number} pageNumber
     * @param {number} pageSize
     * @return {Promise<OnDemandContent>}
     */
    async getFavoritesOnDemand(pageNumber, pageSize) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.getFavoritesOnDemand(pageNumber, pageSize);
    }
    /**
     * Get a list of favorite programs.
     *
     * @return {Promise<ProgramGuide>}
     */
    async getFavoritesPrograms(pageNumber, pageSize) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.getFavoritesPrograms(pageNumber, pageSize);
    }
}

/**
 * Client's genres module.
 */
class GenresClientModule extends Module {
    api;
    domainsSettings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {DomainSettings} domainsSettings Domain configuration including session context.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Domain configuration including session context.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.domainsSettings = domainsSettings;
    }
    /**
     * Get a list of CraveTV genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getCraveTVGenres() {
        return this.getGenres(ContentGenreType.VodGenreType, VodType.CraveTV);
    }
    /**
     * Get a list of LiveTV genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getLiveTVGenres() {
        return this.getGenres(ContentGenreType.TvGenreType);
    }
    /**
     * Get a list of VSVOD genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getSVODGenres(hasCrave) {
        return this.getGenres(ContentGenreType.VodGenreType, VodType.SVOD, hasCrave);
    }
    /**
     * Get a list of VCloud genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getVCloudGenres() {
        return this.getGenres(ContentGenreType.ProgramGenreType);
    }
    /**
     * Get a list of internal genres.
     *
     * @return {Promise<Map<Readonly<Genre>, ReadonlyArray<Genre>>>}
     * @public
     */
    async getGenresInternal() {
        const { data } = await this.api.api.genresInternalVodClientCreate({
            AvailableOnly: true,
            sessionID: this.domainsSettings.sessionId
        });
        const genres = (data.genres ?? []).map((contentGenre) => this.convertGenre(contentGenre));
        return genres.reduce((result, genre) => {
            if (genre.parentId === null || genre.parentId === 0) {
                result.set(genre, genres.filter(({ parentId }) => genre.id === parentId));
            }
            return result;
        }, new Map());
    }
    /**
     * Get a list of genres.
     *
     * @param {ContentGenreType} type Genre's type.
     * @param {VodType | null} vodType VOD's type.
     * @return {Promise<Map<Readonly<Genre>, Array<Genre>>>}
     * @private
     */
    async getGenres(type, vodType, hasCrave) {
        const { data } = await this.api.api.genresClientCreate({
            sessionID: this.domainsSettings.sessionId,
            type,
            vodType
        });
        const genres = (data.genres ?? []).map((contentGenre) => this.convertGenre(contentGenre));
        if (this.domainsSettings.isVmediaTV && vodType === VodType.SVOD && hasCrave === true) {
            genres.unshift(new Genre(514, "Crave", null, 2, 0));
            const craveTvGenres = await this.getCraveTVGenres();
            craveTvGenres.forEach((subgenres, craveTvGenre) => {
                if (craveTvGenre.name !== 'remainder') {
                    craveTvGenre.parentId = 514;
                    genres.push(craveTvGenre);
                }
                subgenres.forEach((subgenre) => {
                    genres.push(subgenre);
                });
            });
        }
        let sortGenresIndex = new Set();
        let genresSort = genres.reduce((result, genre) => {
            if (genre.parentId === null || genre.parentId === 0) {
                result.set(genre, genres.filter(({ parentId, id }) => {
                    if (genre.id === parentId) {
                        sortGenresIndex.add(id);
                    }
                    return genre.id === parentId;
                }));
            }
            return result;
        }, new Map());
        // Catch-all for orphaned genres (genres with parents that aren't top-level)
        genresSort.set(new Genre(null, "remainder", null, null, 0), genres.filter(({ parentId, id }) => {
            return parentId !== 0 && !sortGenresIndex.has(id);
        }));
        return genresSort;
    }
}

/**
 * Guest's genres module.
 */
class GenresGuestModule extends Module {
    api;
    siteId;
    applicationName;
    language;
    domainsSettings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {number} siteId Site identifier.
     * @param {string} applicationName Application identifier.
     * @param {string} language Language identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Site identifier.
     *
     * @private
     */
    siteId, 
    /**
     * Application identifier.
     *
     * @private
     */
    applicationName, 
    /**
     * Language identifier.
     *
     * @private
     */
    language, 
    /**
     * Application settings.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.siteId = siteId;
        this.applicationName = applicationName;
        this.language = language;
        this.domainsSettings = domainsSettings;
    }
    /**
     * Get a list of CraveTV genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getCraveTVGenres() {
        return this.getGenres(ContentGenreType.VodGenreType, VodType.CraveTV);
    }
    /**
     * Get a list of LiveTV genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getLiveTVGenres() {
        return this.getGenres(ContentGenreType.TvGenreType);
    }
    /**
     * Get a list of VSVOD genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getSVODGenres(hasCrave) {
        return this.getGenres(ContentGenreType.VodGenreType, VodType.SVOD, hasCrave);
    }
    /**
     * Get a list of VCloud genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getVCloudGenres() {
        return this.getGenres(ContentGenreType.ProgramGenreType);
    }
    /**
     * Get a list of internal genres.
     *
     * @return {Promise<Map<Readonly<Genre>, ReadonlyArray<Genre>>>}
     * @public
     */
    async getGenresInternal() {
        let lang = 0;
        if (this.language === 'eng') {
            lang = 1;
        }
        else if (this.language === 'fr' || this.language === 'fra') {
            lang = 5;
        }
        const { data } = await this.api.api.genresInternalVodAppCreate({
            SiteId: this.siteId,
            AppName: this.applicationName,
            Language: lang,
        });
        const genres = (data.genres ?? []).map((contentGenre) => this.convertGenre(contentGenre));
        return genres.reduce((result, genre) => {
            if (genre.parentId === null || genre.parentId === 0) {
                result.set(genre, genres.filter(({ parentId }) => genre.id === parentId));
            }
            return result;
        }, new Map());
    }
    /**
     * Get a list of genres.
     *
     * @param {ContentGenreType} type Genre's type.
     * @param {VodType | null} vodType VOD's type.
     * @return {Promise<Map<Genre, Array<Genre>>>}
     * @private
     */
    async getGenres(type, vodType, hasCrave) {
        const { data } = await this.api.api.genresAppCreate({
            appName: this.applicationName,
            sLang: this.language,
            siteId: this.siteId,
            type,
            vodType
        });
        const genres = (data.genres ?? []).map((contentGenre) => this.convertGenre(contentGenre));
        if (this.domainsSettings.isVmediaTV && vodType === VodType.SVOD && hasCrave === true) {
            genres.unshift(new Genre(514, "Crave", null, 2, 0));
            const craveTvGenres = await this.getCraveTVGenres();
            craveTvGenres.forEach((subgenres, craveTvGenre) => {
                if (craveTvGenre.name !== 'remainder') {
                    craveTvGenre.parentId = 514;
                    genres.push(craveTvGenre);
                }
                subgenres.forEach((subgenre) => {
                    genres.push(subgenre);
                });
            });
        }
        let sortGenresIndex = new Set();
        let genresSort = genres.reduce((result, genre) => {
            if (genre.parentId === null || genre.parentId === 0) {
                result.set(genre, genres.filter(({ parentId, id }) => {
                    if (genre.id === parentId) {
                        sortGenresIndex.add(id);
                    }
                    return genre.id === parentId;
                }));
            }
            return result;
        }, new Map());
        //Adding genres of the third or more levels
        genresSort.set(new Genre(null, "remainder", null, null, 0), genres.filter(({ parentId, id }) => {
            return parentId !== 0 && !sortGenresIndex.has(id);
        }));
        return genresSort;
    }
}

/**
 * Genres repository.
 */
class GenresRepository {
    domainsSettings;
    /**
     * Client's module.
     *
     * @type {GenresModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Guest's module.
     *
     * @type {GenresModuleInterface}
     * @private
     */
    guestModule;
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string} language
     * @param {string | null} sessionId
     */
    constructor(api, siteId, applicationName, language, domainsSettings) {
        this.domainsSettings = domainsSettings;
        this.guestModule = new GenresGuestModule(api, siteId, applicationName, language, domainsSettings);
        this.clientModule = new GenresClientModule(api, domainsSettings);
    }
    /**
     * Get a list of CraveTV genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getCraveTVGenres() {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getCraveTVGenres();
        }
        return this.guestModule.getCraveTVGenres();
    }
    /**
     * Get a list of LiveTV genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getLiveTVGenres() {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getLiveTVGenres();
        }
        return this.guestModule.getLiveTVGenres();
    }
    /**
     * Get a list of internal SVOD genres.
     *
     * @return {Promise<Map<Readonly<Genre>, ReadonlyArray<Genre>>>}
     */
    getGenresInternal() {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getGenresInternal();
        }
        return this.guestModule.getGenresInternal();
    }
    /**
     * Get a list of SVOD genres.
     *
     * @return {Promise<Map<Readonly<Genre>, Array<Genre>>>}
     */
    async getSVODGenres(hasCrave) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getSVODGenres(hasCrave);
        }
        return this.guestModule.getSVODGenres(hasCrave);
    }
    /**
     * Get a list of VCloud genres.
     *
     * @return {Promise<Map<Genre, Array<Genre>>>}
     */
    async getVCloudGenres() {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getVCloudGenres();
        }
        return this.guestModule.getVCloudGenres();
    }
}

class ProgramsSegmentModel {
    channelId;
    date;
    programs;
    constructor(channelId, date, programs) {
        this.channelId = channelId;
        this.date = date;
        this.programs = programs;
    }
    static getEndDate(that) {
        const endDate = new Date(that.date);
        endDate.setHours(endDate.getHours() + GuideConstants.PROGRAMS_PAGE_SIZE);
        return endDate.getTime();
    }
    static getLastProgramGuideItem(that) {
        if (that.programs && that.programs.length > 0) {
            return that.programs[that.programs.length - 1];
        }
        else {
            return null;
        }
    }
    static getFirstProgramGuideItem(that) {
        if (that.programs && that.programs.length > 0) {
            return that.programs[0];
        }
        else {
            return null;
        }
    }
    static fixLengthsInside(that) {
        const fixedProgramsList = that
            .programs
            .filter((it) => PlayItem.isSheduleValid(it))
            .sort(it => it.recentAirTime.startTime);
        for (let i = 0; i < fixedProgramsList.length - 1; i++) {
            if (fixedProgramsList.length - 1 != i && PlayItem.getFinishTime(fixedProgramsList[i]) != PlayItem.getFinishTime(fixedProgramsList[i + 1])) {
                const newLengthInSec = PlayItem.calculateLength(fixedProgramsList[i], fixedProgramsList[i + 1]);
                fixedProgramsList[i] = ProgramGuideItem.changeLength(fixedProgramsList[i], newLengthInSec);
            }
        }
        that.programs = fixedProgramsList;
    }
    static updateLengthInLastProgramGuideItem(segment, newLength) {
        const hasNoPrograms = !segment.programs ||
            !Array.isArray(segment.programs) ||
            segment.programs.length === 0 ||
            newLength <= GuideConstants.ZERO_LENGTH;
        if (hasNoPrograms) {
            return;
        }
        const newLastItem = ProgramGuideItem.changeLength(segment.programs[segment.programs.length - 1], newLength);
        segment.programs[segment.programs.length - 1] = newLastItem;
    }
    static adjustItemsLengthBetweenSegments(firstSegment, secondSegment) {
        const firstItem = ProgramsSegmentModel.getLastProgramGuideItem(firstSegment);
        const secondItem = ProgramsSegmentModel.getFirstProgramGuideItem(secondSegment);
        if (firstItem && secondItem && PlayItem.getFinishTime(firstItem) != PlayItem.getStartTime(secondItem)) {
            const newLengthInSec = PlayItem.calculateLength(firstItem, secondItem);
            ProgramsSegmentModel.updateLengthInLastProgramGuideItem(firstSegment, newLengthInSec);
        }
    }
}

class DatePeriod {
    startTime;
    finishTime;
    constructor(startTime, finishTime) {
        this.startTime = startTime;
        this.finishTime = finishTime;
    }
}
class EPGCache {
    segments;
    constructor() {
        this.segments = [];
    }
    addChannel(segment) {
        const startDate = EPGCache.getRoundedDate(segment.date);
        segment.date = startDate.getTime();
        const cachedSegment = this.getChannelData(segment.channelId, segment.date);
        if (cachedSegment) {
            cachedSegment.programs = segment.programs;
        }
        else {
            const segmentData = {};
            segmentData[segment.date] = segment;
            this.segments[segment.channelId] = segmentData;
        }
    }
    getChannelData(channelId, date) {
        const startDate = EPGCache.getRoundedDate(date);
        const time = startDate.getTime();
        if (!!this.segments[channelId] && !!this.segments[channelId][time]) {
            return this.segments[channelId][time] ?? null;
        }
        return null;
    }
    getChannelsData(channelIds, date) {
        const startDate = EPGCache.getRoundedDate(date);
        const time = startDate.getTime();
        const result = [];
        for (const channelId of channelIds) {
            if (!!this.segments[channelId] && !!this.segments[channelId][time]) {
                const segment = this.segments[channelId][time];
                if (segment) {
                    result.push(segment);
                }
            }
        }
        return result;
    }
    static getSegmentBorder(timeInSegment) {
        const startTime = EPGCache.getRoundedDate(timeInSegment);
        const endTime = new Date(startTime.getTime());
        endTime.setHours(startTime.getHours() + GuideConstants.PROGRAMS_PAGE_SIZE);
        return new DatePeriod(startTime, endTime);
    }
    static getRoundedDate(dateTime) {
        const date = new Date(dateTime);
        const hour = ~~(date.getHours() / GuideConstants.PROGRAMS_PAGE_SIZE) * GuideConstants.PROGRAMS_PAGE_SIZE; // round to the least nearest segment hour
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, 0, 0, 0);
    }
    static getPreviousSegment(segment) {
        const prevDate = new Date(segment.date);
        prevDate.setHours(prevDate.getHours() - GuideConstants.PROGRAMS_PAGE_SIZE);
        return new ProgramsSegmentModel(segment.channelId, prevDate.getTime(), []);
    }
    static getNextSegment(segment) {
        return new ProgramsSegmentModel(segment.channelId, ProgramsSegmentModel.getEndDate(segment), []);
    }
}

/**
 * Serialize parameters for consistent cache keys.
 *
 * @param {Record<string, any>} params The parameters to serialize.
 * @return {string} The serialized parameters string.
 */
const serializeV3GuideParams = (params) => {
    // Fixed parameter order for consistent URLs and cache hits
    const paramOrder = ['AppName', 'ChannelIds', 'StartDate', 'EndDate', 'PageNumber', 'PageSize'];
    return paramOrder
        .filter(key => key in params)
        .map(key => {
        const value = params[key];
        return `${key}=${Array.isArray(value) ? value.join(',') : value}`;
    })
        .join('&');
};
/**
 * Sort ChannelIds in ascending order for consistent cache hits.
 *
 * @param {number[]} ChannelIds The channels to sort.
 * @return {number[]} The sorted channels.
 */
const sortChannelIdsByAscending = (ChannelIds) => {
    return [...ChannelIds].sort((a, b) => a - b);
};

/**
 * Client's guide module.
 */
class GuideClientModule extends Module {
    api;
    apiV3;
    domainsSettings;
    /**
     * @type {string}
     * @private
     */
    FILTER_ORDER_BY = "tv_date ASC";
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {ApiV3<unknown>} apiV3 API V3 client interface.
     * @param {string} sessionId Session identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * API V3 client interface.
     *
     * @private
     */
    apiV3, 
    /**
     * Session identifier.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.apiV3 = apiV3;
        this.domainsSettings = domainsSettings;
    }
    static aspDate(time) {
        return `/Date(${time})/`;
    }
    static getFrom() {
        const date = dayjs().subtract(GuideConstants.DAYS_BEFORE, "day").toDate();
        return this.aspDate(date.getTime());
    }
    static getTill() {
        const date = dayjs().add(GuideConstants.DAYS_AFTER, "day").toDate();
        return this.aspDate(date.getTime());
    }
    /**
     * Get guide.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Date} from
     * @param {Date} till
     * @param {Array<number>} channels
     * @return {Promise<ProgramGuide>}
     */
    async getGuide(pageSize, pageNumber, from, till, channels) {
        return this.getGuideV3Request(channels, dayjs(from).valueOf().toString(), dayjs(till).valueOf().toString(), pageNumber, pageSize);
    }
    /**
     * Get movies on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async getMoviesOnTV(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.MoviesOnTvLookback, pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get news on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async getNewsOnTv(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.NewsOnTvLookback, pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get show times.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {number} id
     * @return {Promise<ProgramGuide>}
     */
    async getShowTimes(pageSize, pageNumber, id, channelId) {
        return this.getRelatedGuideRequest(ContentType.DVR, RelatedType.Showing, pageSize, pageNumber, GuideClientModule.getFrom(), GuideClientModule.getTill(), id, channelId, 5, 5);
    }
    /**
     * Get sport in TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async getSportsOnTV(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.SportsOnTvLookback, pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get TV for kids.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async getTVForKids(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.KidsOnTvLookback, pageSize, pageNumber, ChannelIds);
    }
    /**
     * Basic guide request.
     *
     * @param {ContentType} type
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {string} from
     * @param {string} till
     * @param {OnDemandRequestType} requestType
     * @param {string} searchText
     * @return {Promise<ProgramGuide>}
     * @private
     */
    async getGuideRequest(type, pageSize, pageNumber, from, till, requestType, searchText) {
        const { data } = await this.api.api.guideClientCreate({
            request: {
                filter: {
                    contentType: type,
                    date: from,
                    dateTill: till,
                    HasImagesOnly: false,
                    IsContainerSearch: true,
                    keyWord: searchText,
                    orderBy: this.FILTER_ORDER_BY,
                    showItems: true
                },
                fromTime: from,
                json: 1,
                paging: {
                    itemsOnPage: pageSize,
                    pageNumber: pageNumber
                },
                requestType: requestType,
                tillTime: till,
                type: type,
                utcTime: true,
                UseUtcTime: true
            },
            sessionID: this.domainsSettings.sessionId,
        });
        return this.convertProgramGuide(data);
    }
    /**
     * New guide cached request.
     *
     * @param {Array<number>} ChannelIds
     * @param {string} StartDate
     * @param {string} EndDate
     * @param {number} PageNumber
     * @param {number} PageSize
     * @return {Promise<ProgramGuide>}
     * @private
     */
    async getGuideV3Request(ChannelIds, StartDate, EndDate, PageNumber, PageSize) {
        // Sort ChannelIds in ascending order for consistent cache hits
        const sortedChannelIds = sortChannelIdsByAscending(ChannelIds);
        const { data } = await this.apiV3.api.v3GuideClientList({
            ChannelIds: sortedChannelIds,
            StartDate,
            EndDate,
            PageNumber,
            PageSize,
        }, {
            headers: {
                "X-Session-ID": this.domainsSettings.sessionId,
            },
            paramsSerializer: {
                serialize: serializeV3GuideParams,
            },
        });
        return this.convertProgramGuide(data);
    }
    /**
     * Get OnTV content using V3 API for client mode.
     *
     * @param {OnTvType} OnTvType The OnTV type enum value
     * @param {number} PageSize The number of items per page
     * @param {number} PageNumber The page number to retrieve
     * @param {number[]} ChannelIds Array of channel IDs to filter
     * @return {Promise<ProgramGuide>}
     * @private
     */
    async getOnTVContentV3(OnTvType, PageSize, PageNumber, ChannelIds) {
        const sortedChannelIds = sortChannelIdsByAscending(ChannelIds);
        const { data } = await this.apiV3.api.v3GuideClientOntvDetail({
            type: OnTvType,
            ChannelIds: sortedChannelIds,
            PageNumber,
            PageSize,
        }, {
            headers: {
                "X-Session-ID": this.domainsSettings.sessionId,
            },
            paramsSerializer: {
                serialize: serializeV3GuideParams,
            },
        });
        return this.convertProgramGuide(data);
    }
    /**
     * Related guide request.
     *
     * @param {ContentType} type
     * @param {RelatedType} relatedType
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {string} from
     * @param {string} till
     * @param {number} programId
     * @return {Promise<ProgramGuide>}
     * @private
     */
    async getRelatedGuideRequest(type, relatedType, pageSize, pageNumber, from, till, programId, channelId, itemsBefore, itemsAfter) {
        const { data } = await this.api.api.guideClientrelatedCreate({
            request: {
                filter: {
                    contentType: type,
                    date: from,
                    dateTill: till,
                    HasImagesOnly: false,
                    IsContainerSearch: true,
                    orderBy: this.FILTER_ORDER_BY,
                    showItems: true
                },
                id: programId,
                ChannelId: channelId,
                paging: {
                    itemsOnPage: pageSize,
                    pageNumber: pageNumber
                },
                relatedType: relatedType,
                type: type,
                UseUtcTime: true,
                ItemsCountBefore: itemsBefore,
                ItemsCountAfter: itemsAfter,
            },
            sessionID: this.domainsSettings.sessionId
        });
        return this.convertProgramGuide(data);
    }
    async searchPrograms(filter, pageSize, pageNumber) {
        return this.getGuideRequest(ContentType.DVR, pageSize, pageNumber, GuideClientModule.aspDate(filter.dateFrom), GuideClientModule.aspDate(filter.dateTill), undefined, filter.searchText);
    }
    /**
     * Get all live programs by searchText.
     *
     * @param {GuideSearchFilter} filter
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async searchLivePrograms(filter, pageSize, pageNumber) {
        return this.getGuideRequest(ContentType.LiveTV, pageSize, pageNumber, GuideClientModule.aspDate(filter.dateFrom), GuideClientModule.aspDate(filter.dateTill), OnDemandRequestType.SearchByNameWithGrouping, filter.searchText);
    }
    /**
     * Get olympics on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async getOlympicsOnTv(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.OlympicsOnTvLookback, pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get Live Series on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async getLiveSeriesOnTv(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.SeriesOnTvExcludingKidsSportsNewsLookback, pageSize, pageNumber, ChannelIds);
    }
}

/**
 * Guest's guide module.
 */
class GuideGuestModule extends Module {
    api;
    apiV3;
    siteId;
    applicationName;
    language;
    /**
     * @type {string}
     * @private
     */
    FILTER_ORDER_BY = "tv_date ASC";
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {ApiV3<unknown>} apiV3 API V3 client interface.
     * @param {number} siteId Site identifier.
     * @param {string} applicationName Application identifier.
     * @param {string} language Language identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * API V3 client interface.
     *
     * @private
     */
    apiV3, 
    /**
     * Site identifier.
     *
     * @private
     */
    siteId, 
    /**
     * Application identifier.
     *
     * @private
     */
    applicationName, 
    /**
     * Language identifier.
     *
     * @private
     */
    language) {
        super();
        this.api = api;
        this.apiV3 = apiV3;
        this.siteId = siteId;
        this.applicationName = applicationName;
        this.language = language;
    }
    static aspDate(time) {
        return `/Date(${time})/`;
    }
    /**
     * Get from date.
     *
     * @return {string}
     * @private
     */
    static getFrom() {
        const date = dayjs().subtract(GuideConstants.DAYS_BEFORE, "day").toDate();
        return this.aspDate(date.getTime());
    }
    /**
     * Get till date.
     *
     * @return {string}
     * @private
     */
    static getTill() {
        const date = dayjs().add(GuideConstants.DAYS_AFTER, "day").toDate();
        return this.aspDate(date.getTime());
    }
    /**
     * Get guide.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Date} from
     * @param {Date} till
     * @param {ReadonlyArray<number>} channels
     * @return {Promise<ProgramGuide>}
     */
    async getGuide(pageSize, pageNumber, from, till, channels) {
        return this.getGuideV3Request(channels, dayjs(from).valueOf().toString(), dayjs(till).valueOf().toString(), pageNumber, pageSize);
    }
    /**
     * Get movies on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getMoviesOnTV(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.MoviesOnTvLookback, pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get news on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getNewsOnTv(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.NewsOnTvLookback, pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get show times.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {number} id
     * @return {Promise<ProgramGuide>}
     */
    async getShowTimes(pageSize, pageNumber, id, channelId) {
        return this.getRelatedGuideRequest(ContentType.DVR, RelatedType.Showing, pageSize, pageNumber, GuideGuestModule.getFrom(), GuideGuestModule.getTill(), id, channelId, 5, 5);
    }
    /**
     * Get sport in TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getSportsOnTV(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.SportsOnTvLookback, pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get TV for kids.
     *
     * @param {number} pageSize
     * @param {number} pageNumber,
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getTVForKids(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.KidsOnTvLookback, pageSize, pageNumber, ChannelIds);
    }
    /**
     * Basic guide request.
     *
     * @param {ContentType} type
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {string} from
     * @param {string} till
     * @param {OnDemandRequestType} requestType
     * @param {string} searchText
     * @return {Promise<ProgramGuide>}
     * @private
     */
    async getGuideRequest(type, pageSize, pageNumber, from, till, requestType, searchText) {
        const { data } = await this.api.api.guideAppCreate({
            appName: this.applicationName,
            request: {
                filter: {
                    contentType: type,
                    date: from,
                    dateTill: till,
                    HasImagesOnly: false,
                    IsContainerSearch: true,
                    keyWord: searchText,
                    orderBy: this.FILTER_ORDER_BY,
                    showItems: true
                },
                fromTime: from,
                json: 1,
                paging: {
                    itemsOnPage: pageSize,
                    pageNumber: pageNumber
                },
                requestType: requestType,
                tillTime: till,
                type: type,
                utcTime: true,
                UseUtcTime: true
            },
            sLang: this.language,
            siteId: this.siteId,
        });
        return this.convertProgramGuide(data);
    }
    /**
     * New guide cached request.
     *
     * @param {Array<number>} ChannelIds
     * @param {string} StartDate
     * @param {string} EndDate
     * @param {number} PageNumber
     * @param {number} PageSize
     * @return {Promise<ProgramGuide>}
     * @private
     */
    async getGuideV3Request(ChannelIds, StartDate, EndDate, PageNumber, PageSize) {
        // Sort ChannelIds in ascending order for consistent cache hits
        const sortedChannelIds = sortChannelIdsByAscending(ChannelIds);
        const { data } = await this.apiV3.api.v3GuideAppList({
            ChannelIds: sortedChannelIds,
            StartDate,
            EndDate,
            PageNumber,
            PageSize,
        }, {
            paramsSerializer: {
                serialize: serializeV3GuideParams,
            },
        });
        return this.convertProgramGuide(data);
    }
    /**
     * Get OnTV content using V3 API for guest mode.
     *
     * @param {OnTvType} OnTvType The OnTV type enum value
     * @param {number} PageSize The number of items per page
     * @param {number} PageNumber The page number to retrieve
     * @param {number[]} ChannelIds Array of channel IDs to filter
     * @return {Promise<ProgramGuide>}
     * @private
     */
    async getOnTVContentV3(OnTvType, PageSize, PageNumber, ChannelIds) {
        const sortedChannelIds = sortChannelIdsByAscending(ChannelIds);
        const { data } = await this.apiV3.api.v3GuideAppOntvDetail({
            type: OnTvType,
            ChannelIds: sortedChannelIds,
            PageNumber,
            PageSize,
            AppName: this.applicationName,
        }, {
            paramsSerializer: {
                serialize: serializeV3GuideParams,
            },
        });
        return this.convertProgramGuide(data);
    }
    /**
     * Related guide request.
     *
     * @param {ContentType} type
     * @param {RelatedType} relatedType
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {string} from
     * @param {string} till
     * @param {number} programId
     * @return {Promise<ProgramGuide>}
     * @private
     */
    async getRelatedGuideRequest(type, relatedType, pageSize, pageNumber, from, till, programId, channelId, itemsBefore, itemsAfter) {
        const { data } = await this.api.api.guideApprelatedCreate({
            appName: this.applicationName,
            request: {
                filter: {
                    contentType: type,
                    date: from,
                    dateTill: till,
                    HasImagesOnly: false,
                    IsContainerSearch: true,
                    orderBy: this.FILTER_ORDER_BY,
                    showItems: true
                },
                id: programId,
                ChannelId: channelId,
                paging: {
                    itemsOnPage: pageSize,
                    pageNumber: pageNumber
                },
                relatedType: relatedType,
                type: type,
                UseUtcTime: true,
                ItemsCountBefore: itemsBefore,
                ItemsCountAfter: itemsAfter,
            },
            sLang: this.language,
            siteId: this.siteId,
        });
        return this.convertProgramGuide(data);
    }
    async searchPrograms(filter, pageSize, pageNumber) {
        return this.getGuideRequest(ContentType.DVR, pageSize, pageNumber, GuideGuestModule.aspDate(filter.dateFrom), GuideGuestModule.aspDate(filter.dateTill), undefined, filter.searchText);
    }
    /**
     * Get all live programs by searchText.
     *
     * @param {GuideSearchFilter} filter
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async searchLivePrograms(filter, pageSize, pageNumber) {
        return this.getGuideRequest(ContentType.LiveTV, pageSize, pageNumber, GuideGuestModule.aspDate(filter.dateFrom), GuideGuestModule.aspDate(filter.dateTill), OnDemandRequestType.SearchByNameWithGrouping, filter.searchText);
    }
    /**
     * Get olympics on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getOlympicsOnTv(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.OlympicsOnTvLookback, pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get Live Series on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getLiveSeriesOnTv(pageSize, pageNumber, ChannelIds) {
        return this.getOnTVContentV3(OnTvType.SeriesOnTvExcludingKidsSportsNewsLookback, pageSize, pageNumber, ChannelIds);
    }
}

/**
 * Guides repository.
 */
class GuidesRepository {
    domainsSettings;
    /**
     * Client's module.
     *
     * @type {GuidesModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Guest's module.
     *
     * @type {GuidesModuleInterface}
     * @private
     */
    guestModule;
    /**
     * Lifetime.
     *
     * @type {number}
     * @private
     */
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     * @param {ApiV3<unknown>} apiV3
     * @param {CacherInterface} cacher
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string} language
     * @param {string | null} sessionId
     */
    constructor(api, apiV3, siteId, applicationName, language, domainsSettings) {
        this.domainsSettings = domainsSettings;
        this.guestModule = new GuideGuestModule(api, apiV3, siteId, applicationName, language);
        this.clientModule = new GuideClientModule(api, apiV3, domainsSettings);
    }
    /**
     * Get guide.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Date} from
     * @param {Date} till
     * @param {Array<number>} channels
     * @return {Promise<ProgramGuide>}
     */
    async getGuide(pageSize, pageNumber, from, till, channels) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return await this.clientModule.getGuide(pageSize, pageNumber, from, till, channels);
        }
        else {
            return await this.guestModule.getGuide(pageSize, pageNumber, from, till, channels);
        }
    }
    /**
     * Get movies on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async getMoviesOnTV(pageSize, pageNumber, ChannelIds) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getMoviesOnTV(pageSize, pageNumber, ChannelIds);
        }
        return this.guestModule.getMoviesOnTV(pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get news on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getNewsOnTv(pageSize, pageNumber, ChannelIds) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getNewsOnTv(pageSize, pageNumber, ChannelIds);
        }
        return this.guestModule.getNewsOnTv(pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get show times.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {number} id
     * @return {Promise<ProgramGuide>}
     */
    async getShowTimes(pageSize, pageNumber, id, channelId) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getShowTimes(pageSize, pageNumber, id, channelId);
        }
        return this.guestModule.getShowTimes(pageSize, pageNumber, id, channelId);
    }
    /**
     * Get sports on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getSportsOnTV(pageSize, pageNumber, ChannelIds) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getSportsOnTV(pageSize, pageNumber, ChannelIds);
        }
        return this.guestModule.getSportsOnTV(pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get TV for kids.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getTVForKids(pageSize, pageNumber, ChannelIds) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getTVForKids(pageSize, pageNumber, ChannelIds);
        }
        return this.guestModule.getTVForKids(pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get programs segment for the channel
     *
     * @param {number} channelId - The channel ID
     * @param {Date} segmentDateTime - The date of the segment
     * @return {Promise<ProgramsSegmentModel>}
     */
    async getPrograms(channelIds, segmentDateTime) {
        const period = EPGCache.getSegmentBorder(segmentDateTime);
        const guide = await this.getGuide(500, 1, period.startTime, period.finishTime, channelIds);
        if (!guide || !guide.items) {
            // TODO: return empty segment instead of null
            return null;
        }
        const result = {};
        guide.items.map((item) => {
            const channelId = item.recentAirTime?.channelId;
            if (channelId) {
                if (!result[`${channelId}`]) {
                    result[`${channelId}`] = new ProgramsSegmentModel(channelId, period.startTime.getTime(), [item]);
                }
                else {
                    result[`${channelId}`].programs.push(item);
                }
            }
        });
        return Object.values(result);
    }
    async searchPrograms(filter, pageSize, pageNumber) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.searchPrograms(filter, pageSize, pageNumber);
        }
        return this.guestModule.searchPrograms(filter, pageSize, pageNumber);
    }
    /**
     * Get all live programs by searchText.
     *
     * @param {GuideSearchFilter} filter
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async searchLivePrograms(filter, pageSize, pageNumber) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.searchLivePrograms(filter, pageSize, pageNumber);
        }
        return this.guestModule.searchLivePrograms(filter, pageSize, pageNumber);
    }
    /**
     * Get olympics on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getOlympicsOnTv(pageSize, pageNumber, ChannelIds) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getOlympicsOnTv(pageSize, pageNumber, ChannelIds);
        }
        return this.guestModule.getOlympicsOnTv(pageSize, pageNumber, ChannelIds);
    }
    /**
     * Get Live Series on TV.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Array<number>} ChannelIds
     * @return {Promise<ProgramGuide>}
     */
    async getLiveSeriesOnTv(pageSize, pageNumber, ChannelIds) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getLiveSeriesOnTv(pageSize, pageNumber, ChannelIds);
        }
        return this.guestModule.getLiveSeriesOnTv(pageSize, pageNumber, ChannelIds);
    }
}

class Formatter {
    static template(template, ...args) {
        for (const arg of args) {
            template = template.replace("%s", arg);
        }
        return template;
    }
}

/**
 * Guest's media module.
 */
class MediaGuestModule extends Module {
    api;
    siteId;
    applicationName;
    language;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {number} siteId Site identifier.
     * @param {string} applicationName Application identifier.
     * @param {string} language Language identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Site identifier.
     *
     * @private
     */
    siteId, 
    /**
     * Application identifier.
     *
     * @private
     */
    applicationName, 
    /**
     * Language identifier.
     *
     * @private
     */
    language) {
        super();
        this.api = api;
        this.siteId = siteId;
        this.applicationName = applicationName;
        this.language = language;
    }
    /**
     * Get image URL template.
     *
     * @return {Promise<string>}
     */
    async getImageURLTemplate() {
        const { data } = await this.api.api.v2MediaImageurltemplatesCreate({
            appName: this.applicationName,
            sLang: this.language,
            siteId: this.siteId
        });
        const url = JSON.stringify(data);
        return this.replaceOldUrlTokens(url);
    }
    /**
     * Get image URL templates.
     *
     * @return {Promise<ImageTemplateUrls>}
     */
    async getImageURLTemplates() {
        const { data } = await this.api.api.v2MediaImageurltemplatesCreate({
            appName: this.applicationName,
            sLang: this.language,
            siteId: this.siteId
        });
        const result = {
            defaults: data.default ?? null,
            imageId: data.imageId ?? null
        };
        if (result.defaults != null) {
            result.defaults = this.replaceOldUrlTokens(result.defaults);
        }
        if (result.imageId != null) {
            result.imageId = this.replaceOldUrlTokens(result.imageId);
        }
        return result;
    }
    /**
     * Get stream.
     *
     * @param {number} id
     * @param {ContentType} type
     * @return {Promise<MediaStream>}
     */
    async getStream(id, type) {
        const { data } = await this.api.api.mediaAppStreamCreate({
            appName: this.applicationName,
            mediaRequest: {
                IsRestart: false,
                item: {
                    contentType: type,
                    id
                }
            },
            sLang: this.language,
            siteId: this.siteId
        });
        return this.convertMediaStream(data);
    }
    /**
     * Replaces old placeholders in url template.
     *
     * @param {string} template
     * @return {string}
     */
    replaceOldUrlTokens(template) {
        return template
            .replace("{imageId}", "%s")
            .replace("{imageType}", "%s")
            .replace("{itemId}", "%s")
            .replace("{index}", "%s");
    }
    /**
     * Get trends.
     *
     * @return {Promise<ProgramGuide>}
     */
    async getTrends() {
        const { data } = await this.api.api.contentPopularMixedItemsAppCreate({
            appName: this.applicationName,
            sLang: this.language,
            siteId: this.siteId
        });
        return this.convertTrends(data);
    }
}

/**
 * Images repository.
 */
class ImagesRepository {
    domainsSettings;
    /**
     * Media guest's module.
     *
     * @type {MediaGuestModuleInterface}
     * @private
     */
    guestModule;
    /**
     * Service constructor.
     *
     * @param {Api<unknown>} api
     * @param {CacherInterface} cacher
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string} language
     */
    constructor(api, siteId, applicationName, language, domainsSettings) {
        this.domainsSettings = domainsSettings;
        this.guestModule = new MediaGuestModule(api, siteId, applicationName, language);
    }
    /**
     * Get actor image url from template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getActorImage(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.VodPerson);
    }
    /**
     * Get channel image url from template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getChannelImage(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.ChannelLogoTransparent36);
    }
    /**
     * Get channel image original url from template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getChannelImageOriginal(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.ChannelLogoOriginal);
    }
    /**
     * Get director image url from template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getDirectorImage(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.VodPerson);
    }
    /**
     * Get on demand background image url from template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getOnDemandBackgroundImage(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.VodWallpaper);
    }
    /**
     * Get on demand episode image url from template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getOnDemandEpisodeImage(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.VodScreenshot);
    }
    /**
     * Get on demand image original url from template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getOnDemandImage(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.VodMain);
    }
    /**
     * Get program image url from template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getProgramImage(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.TvProgram16X9);
    }
    /**
     * Get VOD genre image url from workaround template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getVodGenreImage(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.VodGenre);
    }
    /**
     * Get VOD genre white image url from workaround template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getWhiteVodGenreImage(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.VodGenreMonochrome);
    }
    /**
     * Get Crave image url from workaround template.
     *
     * @param {number} channelId
     * @return {Promise<string | null>}
     */
    async getCraveImage(channelId) {
        return this.getWorkaroundUrl(channelId, MediaImageTypes.VodGenre);
    }
    /**
     * Get Crave white image url from workaround template.
     *
     * @param {number} channelId
     * @return {Promise<string | null>}
     */
    async getWhiteCraveImage(channelId) {
        return this.getWorkaroundUrl(channelId, MediaImageTypes.VodGenreMonochrome);
    }
    /**
     * Get white channel image url from workaround template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @return {Promise<string | null>}
     */
    async getWhiteChannelImage(mediaImages) {
        return this.getUrl(mediaImages, MediaImageTypes.ChannelLogoWhiteTransparent);
    }
    /**
     * Get url from workaround template.
     *
     * @param {number} id
     * @param {MediaImageTypes} type
     * @return {Promise<string | null>}
     */
    async getWorkaroundUrl(id, type) {
        const urlTemplate = this.domainsSettings.imagesWorkaroundUrlTemplate;
        return Formatter.template(urlTemplate, id.toString(), type.toString(), "1");
    }
    /**
     * Get url from template.
     *
     * @param {Array<MediaImage> | null} mediaImages
     * @param {MediaImageTypes} type
     * @return {Promise<string | null>}
     */
    async getUrl(mediaImages, type) {
        if (mediaImages === null && mediaImages != undefined) {
            return null;
        }
        const image = mediaImages?.find((value) => value.type === type) ?? null;
        if (image === null || image.id === null) {
            return null;
        }
        const urlTemplate = this.domainsSettings.imagesUrlTemplate;
        return Formatter.template(urlTemplate, image.id.toString(), type.toString());
    }
    /**
     * Get image url/workaround template.
     *
     * @return {Promise<string | null>}
     */
    async getImageUrlTemplates() {
        return await this.guestModule.getImageURLTemplates();
    }
}

var ContentItemProps;
(function (ContentItemProps) {
    ContentItemProps["WatchedPosition"] = "pos";
    ContentItemProps["FavouriteStatee"] = "fav";
    ContentItemProps["VCloudStatee"] = "rec";
})(ContentItemProps || (ContentItemProps = {}));

/**
 * ContentProperties entity.
 */
class ContentProperties {
    id;
    isFavourite;
    streamPosition;
    isVCloud;
    /**
     * Entity constructor.
     *
     * @param {number | null} id ContentProperties identifier.
     * @param {boolean | null} isFavourite
     * @param {number | null} streamPosition
     * @param {boolean | null} isVCloud
     */
    constructor(
    /**
     * ContentProperties identifier.
     */
    id = null, 
    /**
     * IsFavorite flag.
     */
    isFavourite = null, 
    /**
     * ContentProperties watched position.
     */
    streamPosition = null, 
    /**
     * IsVCloud flag.
     */
    isVCloud = null) {
        this.id = id;
        this.isFavourite = isFavourite;
        this.streamPosition = streamPosition;
        this.isVCloud = isVCloud;
    }
}

/**
 * Client's media module.
 */
class MediaClientModule extends Module {
    api;
    domainsSettings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {string} sessionId Session identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Session identifier.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.domainsSettings = domainsSettings;
    }
    /**
     * Get restarted stream.
     *
     * @param {number} id
     * @param {ContentType} type
     * @return {Promise<MediaStream>}
     */
    async getRestartedStream(id, type) {
        const { data } = await this.api.api.mediaRestartStreamCreate({
            mediaRequest: {
                item: {
                    contentType: type,
                    id
                }
            },
            sessionID: this.domainsSettings.sessionId
        });
        return this.convertMediaStream(data);
    }
    /**
     * Get stream.
     *
     * @param {number} id
     * @param {ContentType} type
     * @return {Promise<MediaStream>}
     */
    async getStream(id, type) {
        const { data } = await this.api.api.mediaClientStreamCreate({
            mediaRequest: {
                IsRestart: false,
                item: {
                    contentType: type,
                    id
                }
            },
            sessionID: this.domainsSettings.sessionId
        });
        return this.convertMediaStream(data);
    }
    /**
     * Set watched progress.
     *
     * @param {number} id
     * @param {ContentType} type
     * @param {number} position
     * @return {Promise<boolean>}
     */
    async setWatchedProgress(id, type, position) {
        const { data } = await this.api.api.contentStreamprogressCreate({
            item: {
                item: {
                    contentType: type,
                    id
                },
                pos: position
            },
            sessionID: this.domainsSettings.sessionId
        });
        return data;
    }
    /**
     * Set watched range.
     *
     * @param {number} id
     * @param {ContentType} type
     * @param {number} start
     * @param {number} end
     * @return {Promise<void>}
     */
    async setWatchedRange(id, type, start, end) {
        const { data } = await this.api.api.contentSetwatchedrangeCreate({
            Range: {
                Start: start,
                End: end
            },
            Item: {
                contentType: type,
                id
            },
            sessionID: this.domainsSettings.sessionId
        });
        return data;
    }
    /**
     * Get watched range.
     *
     * @param {number} id
     * @param {ContentType} type
     * @return {Promise<WatchedRange>}
     */
    async getWatchedRange(id, type) {
        const { data } = await this.api.api.contentGetwatchedrangeCreate({
            request: {
                contentType: type,
                id
            },
            sessionID: this.domainsSettings.sessionId
        });
        return data;
    }
    /**
     * Get item properties
     * @param {Array<number>} itemIds
     * @param {ContentType} type
     * @param {ContentItemProps[]} props
     * @returns {Promise<ReadonlyArray<ContentProperties>>}
     */
    async getItemProperties(itemIds, type, props) {
        const { data } = await this.api.api.contentItempropertiesCreate({
            items: itemIds,
            ct: type,
            props: props,
            sessionID: this.domainsSettings.sessionId
        });
        return data
            .filter((item) => item.id && item.properties)
            .map((item) => new ContentProperties(item.id, item.properties?.find((prop) => prop.key === ContentItemProps.FavouriteStatee)?.value === "1", Number.parseInt(item.properties?.find((prop) => prop.key ===
            ContentItemProps.WatchedPosition)?.value ?? "0"), item.properties?.find((prop) => prop.key === ContentItemProps.VCloudStatee)?.value === "1"));
    }
    /**
     * Get trends.
     *
     * @return {Promise<ProgramGuide>}
     */
    async getTrends() {
        const { data } = await this.api.api.contentPopularMixedItemsClientCreate({
            request: {
                ShowType: 0,
            },
            sessionID: this.domainsSettings.sessionId
        });
        return this.convertTrends(data);
    }
}

/**
 * Media repository.
 */
class MediaRepository {
    domainsSettings;
    /**
     * Client's module.
     *
     * @type {MediaClientModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Guest's module.
     *
     * @type {MediaGuestModuleInterface}
     * @private
     */
    guestModule;
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string} language
     * @param {string | null} sessionId
     */
    constructor(api, siteId, applicationName, language, domainsSettings) {
        this.domainsSettings = domainsSettings;
        this.guestModule = new MediaGuestModule(api, siteId, applicationName, language);
        this.clientModule = new MediaClientModule(api, domainsSettings);
    }
    /**
     * Get image URL template.
     *
     * @return {Promise<string>}
     */
    async getImageURLTemplate() {
        return this.guestModule.getImageURLTemplate();
    }
    /**
     * Get restarted stream.
     *
     * @param {number} id
     * @param {ContentType} type
     * @return {Promise<MediaStream>}
     */
    async getRestartedStream(id, type) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.getRestartedStream(id, type);
    }
    /**
     * Get stream.
     *
     * @param {number} id
     * @param {ContentType} type
     * @return {Promise<MediaStream>}
     */
    async getStream(id, type) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getStream(id, type);
        }
        return this.guestModule.getStream(id, type);
    }
    /**
     * Set watched progress.
     *
     * @param {number} id
     * @param {ContentType} type
     * @param {number} position
     * @return {Promise<boolean>}
     */
    async setWatchedProgress(id, type, position) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.setWatchedProgress(id, type, position);
    }
    /**
     * Set watched range.
     *
     * @param {number} id
     * @param {ContentType} type
     * @param {number} start
     * @param {number} end
     * @return {Promise<boolean>}
     */
    async setWatchedRange(id, type, start, end) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.setWatchedRange(id, type, start, end);
    }
    /**
     * Get item properties
     * @param {Array<number>} itemIds
     * @param {ContentType} type
     * @param {string[]} props
     * @returns {Promise<WatchedRange>}
     */
    async getWatchedRange(id, type) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.getWatchedRange(id, type);
    }
    /**
     * Get item properties
     * @param {Array<number>} itemIds
     * @param {ContentType} type
     * @param {string[]} props
     * @returns {Promise<ReadonlyArray<ContentProperties>>}
     */
    async getItemProperties(itemIds, type, props) {
        if (typeof this.domainsSettings.sessionId !== "string") {
            throw new AuthorizationError();
        }
        return this.clientModule.getItemProperties(itemIds, type, props);
    }
    /**
     * Get trends.
     *
     * @return {Promise<ProgramGuide>}
     */
    async getTrends() {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getTrends();
        }
        return this.guestModule.getTrends();
    }
}

/**
 * Client's recommendations module.
 * No Guest module available.
 */
class RecommendationsClientModule extends Module {
    api;
    domainsSettings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {DomainSettings} domainsSettings
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Domain settings.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.domainsSettings = domainsSettings;
    }
    /**
     * Get movies recommendations.
     *
     * @param {number} top
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandItem[]>}
     */
    async getMoviesRecommendations(top) {
        return this.getRecommendations(ShowTypes.Movie, top);
    }
    /**
     * Get series recommendations.
     *
     * @param {number} top
     * @return {Promise<OnDemandItem[]>}
     */
    async getSeriesRecommendations(top) {
        return this.getRecommendations(ShowTypes.Series, top);
    }
    async getRecommendations(type, top) {
        const { data } = await this.api.api.recommendationsVodCreate({
            request: {
                ShowType: type,
                Top: top
            },
            sessionID: this.domainsSettings.sessionId
        });
        return data.map((item) => this.convertOnDemandItem(item));
    }
}

class RecommendationsRepository {
    /**
     * Client's module.
     *
     * @type {RecommendationsModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     * @param {CacherInterface} cacher
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string} language
     * @param {DomainSettings} domainsSettings
     */
    constructor(api, domainsSettings) {
        this.clientModule = new RecommendationsClientModule(api, domainsSettings);
    }
    /**
     * Get movies recommendations.
     *
     * @param {number} top
     * @return {Promise<OnDemandItem[]>}
     */
    async getMoviesRecommendations(top) {
        return this.clientModule.getMoviesRecommendations(top);
    }
    /**
     * Get series recommendations.
     *
     * @param {number} top
     * @return {Promise<OnDemandItem[]>}
     */
    async getSeriesRecommendations(top) {
        return this.clientModule.getSeriesRecommendations(top);
    }
}

/**
 * Clients' resource module.
 */
class ResourcesClientModule extends Module {
    api;
    domainsSettings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {DomainSettings} domainsSettings Domain configuration including session context.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Domain configuration including session context.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.domainsSettings = domainsSettings;
    }
    /**
     * Gets app resource by specified resource code.
     *
     * @param {string} resource The resource code used to receive data for application.
     * @return {Promise<string>}
     */
    async getResources(resource) {
        const { data } = await this.api.api.resourcesClientCreate({
            resourceCode: resource,
            sessionID: this.domainsSettings.sessionId
        });
        return data;
    }
}

/**
 * Guests' resources module.
 */
class ResourcesGuestModule extends Module {
    api;
    siteId;
    applicationName;
    language;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {number} siteId Site identifier.
     * @param {string} applicationName Application identifier.
     * @param {string} language Language identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Site identifier.
     *
     * @private
     */
    siteId, 
    /**
     * Application identifier.
     *
     * @private
     */
    applicationName, 
    /**
     * Language identifier.
     *
     * @private
     */
    language) {
        super();
        this.api = api;
        this.siteId = siteId;
        this.applicationName = applicationName;
        this.language = language;
    }
    /**
     * Gets app resource by specified resource code.
     *
     * @param {string} resource The resource code used to receive data for application.
     * @return {Promise<string>}
     */
    async getResources(resource) {
        const { data } = await this.api.api.resourcesAppCreate({
            appName: this.applicationName,
            lang: this.language,
            resourceCode: resource,
            siteID: this.siteId
        });
        return String(data);
    }
}

/**
 * Resources repository.
 */
class ResourcesRepository {
    domainsSettings;
    /**
     * Client's module.
     *
     * @type {ResourcesModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Guest's module.
     *
     * @type {ResourcesModuleInterface}
     * @private
     */
    guestModule;
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string} language
     * @param {string | null} sessionId
     */
    constructor(api, siteId, applicationName, language, domainsSettings) {
        this.domainsSettings = domainsSettings;
        this.guestModule = new ResourcesGuestModule(api, siteId, applicationName, language);
        this.clientModule = new ResourcesClientModule(api, domainsSettings);
    }
    /**
     * Gets app resource by specified resource code.
     *
     * @param {string} resource The resource code used to receive data for application.
     * @return {Promise<string>}
     */
    async getResources(resource) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getResources(resource);
        }
        return this.guestModule.getResources(resource);
    }
}

/**
 * Client's VOD module.
 */
class VodClientModule extends Module {
    api;
    domainsSettings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {DomainSettings} domainsSettings Domain configuration including session context.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Domain configuration including session context.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.domainsSettings = domainsSettings;
    }
    /**
     * Get CraveTV details.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVDetails(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.CraveTV, itemId, RelatedType.Details, pageSize, pageNumber, "name ASC");
    }
    /**
     * Get CraveTV items.
     *
     * @param {Genre} genre
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVItems(genre, pageSize, pageNumber) {
        return this.getOnDemand(ContentType.CraveTV, pageSize, pageNumber, undefined, VodType.CraveTV, genre, undefined, "episode_num ASC");
    }
    /**
     * Get CraveTV seasons episodes.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVSeasonEpisodes(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.CraveTV, itemId, RelatedType.Children, pageSize, pageNumber, "episode_num ASC");
    }
    /**
     * Get CraveTV seasons.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVSeasons(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.CraveTV, itemId, RelatedType.Seasons, pageSize, pageNumber, "episode_num ASC");
    }
    /**
     * Get new released movies.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Genre} genre
     * @return {Promise<OnDemandContent>}
     */
    async getNewReleasedMovies(pageSize, pageNumber, genre) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.NewlyReleased, VodType.All, genre, undefined, "name ASC", ShowTypes.Movie, true);
    }
    /**
     * Get most popular vod.
     *
     * @param {number} type
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {number} vodType
     * @param {Genre} genre
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getMostPopularVod(type, pageSize, pageNumber, vodType, genre, showType) {
        return this.getOnDemand(type, pageSize, pageNumber, OnDemandRequestType.MostPopularVod, vodType, genre, undefined, "name ASC", showType ?? ShowTypes.None, true);
    }
    /**
     * Get new released shows.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Genre} genre
     * @return {Promise<OnDemandContent>}
     */
    async getNewReleasedShows(pageSize, pageNumber, genre) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.NewlyReleased, VodType.All, genre, undefined, "name ASC", ShowTypes.Series, true);
    }
    /**
     * Get related CraveTV.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getRelatedCraveTV(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.CraveTV, itemId, RelatedType.Similar, pageSize, pageNumber, "name ASC");
    }
    /**
     * Get related SVOD.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getRelatedSVOD(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.SVOD, itemId, RelatedType.Similar, pageSize, pageNumber, "name ASC");
    }
    /**
     * Get SVOD details.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getSVODDetails(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.SVOD, itemId, RelatedType.Details, pageSize, pageNumber, "name ASC");
    }
    /**
     * Get SVOD internal items for genres
     *
     * @param {Genre} genre
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {VodType} vodType: expected VodType.SVOD or VodType.CraveTV
     * @param {number} requestType
     * @param {boolean} isAvailableOnly
     * @param {ShowTypes} showType
     * @param {string} orderBy
     * @return {Promise<OnDemandContent>}
     */
    async getSVODInternalItems(genre, pageSize, pageNumber, vodType, requestType, isAvailableOnly, showType, orderBy) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, requestType, vodType, genre, undefined, orderBy, showType, isAvailableOnly);
    }
    /**
     * Get SVOD items.
     *
     * @param {Genre} genre
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {VodType} vodType: expected VodType.SVOD or VodType.CraveTV
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getSVODItems(genre, pageSize, pageNumber, vodType = VodType.SVOD, showType) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, undefined, vodType, genre, undefined, "name ASC", showType);
    }
    /**
     * Get SVOD season episodes.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getSVODSeasonEpisodes(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.SVOD, itemId, RelatedType.Children, pageSize, pageNumber, "episode_num ASC");
    }
    /**
     * Get SVOD seasons.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getSVODSeasons(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.SVOD, itemId, RelatedType.Seasons, pageSize, pageNumber, "episode_num ASC");
    }
    /**
     * Search by All.
     *
     * @param {string} searchKeyWord
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {VodType} vodType
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async searchByAll(searchKeyWord, pageSize, pageNumber, vodType, showType) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.SearchByName, vodType, undefined, searchKeyWord, "release_date DESC", showType);
    }
    /**
     * get continue watching.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getContinueWatching(pageSize, pageNumber, showType) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.WatchingWithGrouping, undefined, undefined, undefined, "desc", showType, undefined, false);
    }
    /**
     * get recently onDemand.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getRecentlyOnDemand(pageSize, pageNumber, showType) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.NewlyReleased, undefined, undefined, undefined, undefined, showType, undefined, undefined);
    }
    /**
     * get watch again.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getWatchAgain(pageSize, pageNumber, showType) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.Watched, undefined, undefined, undefined, "desc", showType, undefined, false);
    }
    /**
     * get most popular VODs
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getMostPopular(pageSize, pageNumber, showType) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.MostPopularVod, undefined, undefined, undefined, "desc", showType ?? ShowTypes.None, undefined, false);
    }
    /**
     * Get all movies.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Genre} genre
     * @return {Promise<OnDemandContent>}
     */
    async getAllMovies(pageSize, pageNumber, genre) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.AllItems, VodType.All, genre, undefined, "name ASC", ShowTypes.Movie, true);
    }
    /**
     * Get all shows.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Genre} genre
     * @return {Promise<OnDemandContent>}
     */
    async getAllShows(pageSize, pageNumber, genre) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.AllItems, VodType.All, genre, undefined, "name ASC", ShowTypes.Series, true);
    }
    /**
     * Basic On-Demand Request.
     *
     * @param {ContentType} type
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {OnDemandRequestType} requestType
     * @param {VodType} vodType
     * @param {Genre} genre
     * @param {string} searchText
     * @param {string} orderBy
     * @param {ShowType} showType
     * @param {boolean} isAvailableOnly
     * @param {boolean} groupSeasons
     * @return {Promise<OnDemandContent>}
     * @private
     */
    async getOnDemand(type, pageSize, pageNumber, requestType, vodType, genre, searchText, orderBy, showType, isAvailableOnly, groupSeasons) {
        const { data } = await this.api.api.vodClientCreate({
            request: {
                filter: {
                    availableOnly: isAvailableOnly,
                    contentGenre: genre === undefined
                        ? undefined
                        : {
                            childrenIDs: genre.childrenIds?.concat() ?? undefined,
                            genreType: genre.genreType ?? undefined,
                            id: genre.id ?? undefined,
                            images: genre.images?.map(({ id, type }) => ({
                                Id: id ?? undefined,
                                Type: type ?? undefined
                            })) ?? undefined,
                            name: genre.name ?? undefined,
                            orderNumber: genre.orderNumber ?? undefined,
                            parentID: genre.parentId ?? undefined,
                            vodType: genre.vodType ?? undefined
                        },
                    contentType: type,
                    GroupSeasons: groupSeasons ?? true,
                    HasImagesOnly: false,
                    keyWord: searchText,
                    orderBy: orderBy ?? "name ASC",
                    ShowType: showType
                },
                paging: {
                    itemsOnPage: pageSize,
                    pageNumber: pageNumber
                },
                requestType: requestType,
                type: type,
                utcTime: true,
                vodType: vodType
            },
            sessionID: this.domainsSettings.sessionId
        });
        return this.convertOnDemandContent(data);
    }
    /**
     * Related On-Demand Request.
     *
     * @param {ContentType} type
     * @param {number} itemId
     * @param {RelatedType} relatedType
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {string} orderBy
     * @return {Promise<OnDemandContent>}
     * @private
     */
    async getRelatedOnDemand(type, itemId, relatedType, pageSize, pageNumber, orderBy) {
        const { data } = await this.api.api.vodClientrelatedCreate({
            request: {
                filter: {
                    contentGenre: undefined,
                    contentType: type,
                    GroupSeasons: true,
                    HasImagesOnly: false,
                    keyWord: undefined,
                    orderBy: orderBy
                },
                id: itemId,
                paging: {
                    itemsOnPage: pageSize,
                    pageNumber: pageNumber
                },
                relatedType: relatedType,
                type: type,
                utcTime: true
            },
            sessionID: this.domainsSettings.sessionId
        });
        return this.convertOnDemandContent(data);
    }
}

/**
 * Guest's VOD module.
 */
class VodGuestModule extends Module {
    api;
    siteId;
    applicationName;
    language;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {number} siteId Site identifier.
     * @param {string} applicationName Application identifier.
     * @param {string} language Language identifier.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Site identifier.
     *
     * @private
     */
    siteId, 
    /**
     * Application identifier.
     *
     * @private
     */
    applicationName, 
    /**
     * Language identifier.
     *
     * @private
     */
    language) {
        super();
        this.api = api;
        this.siteId = siteId;
        this.applicationName = applicationName;
        this.language = language;
    }
    /**
     * Get CraveTV details.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVDetails(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.CraveTV, itemId, RelatedType.Details, pageSize, pageNumber, "name ASC");
    }
    /**
     * Get CraveTV items.
     *
     * @param {Genre} genre
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVItems(genre, pageSize, pageNumber) {
        return this.getOnDemand(ContentType.CraveTV, pageSize, pageNumber, undefined, VodType.CraveTV, genre, undefined, "episode_num ASC");
    }
    /**
     * Get CraveTV seasons episodes.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVSeasonEpisodes(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.CraveTV, itemId, RelatedType.Children, pageSize, pageNumber, "episode_num ASC");
    }
    /**
     * Get CraveTV seasons.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVSeasons(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.CraveTV, itemId, RelatedType.Seasons, pageSize, pageNumber, "episode_num ASC");
    }
    /**
     * Get new released movies.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Genre} genre
     * @return {Promise<OnDemandContent>}
     */
    async getNewReleasedMovies(pageSize, pageNumber, genre) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.NewlyReleased, VodType.All, genre, undefined, "name ASC", ShowTypes.Movie, true);
    }
    /**
     * Get most popular vod.
     *
     * @param {number} type
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {number} vodType
     * @param {Genre} genre
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getMostPopularVod(type, pageSize, pageNumber, vodType, genre, showType) {
        return this.getOnDemand(type, pageSize, pageNumber, OnDemandRequestType.MostPopularVod, vodType, genre, undefined, "name ASC", showType ?? ShowTypes.None, true);
    }
    /**
     * Get new released shows.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Genre} genre
     * @return {Promise<OnDemandContent>}
     */
    async getNewReleasedShows(pageSize, pageNumber, genre) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.NewlyReleased, VodType.All, genre, undefined, "name ASC", ShowTypes.Series, true);
    }
    /**
     * Get related CraveTV.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getRelatedCraveTV(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.CraveTV, itemId, RelatedType.Similar, pageSize, pageNumber, "name ASC");
    }
    /**
     * Get related SVOD.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getRelatedSVOD(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.SVOD, itemId, RelatedType.Similar, pageSize, pageNumber, "name ASC");
    }
    /**
     * Get SVOD details.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getSVODDetails(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.SVOD, itemId, RelatedType.Details, pageSize, pageNumber, "name ASC");
    }
    /**
     * Get SVOD internal items for genres
     *
     * @param {Genre} genre
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {VodType} vodType: expected VodType.SVOD or VodType.CraveTV
     * @param {number} requestType
     * @param {boolean} isAvailableOnly
     * @param {ShowTypes} showType
     * @param {string} orderBy
     * @return {Promise<OnDemandContent>}
     */
    async getSVODInternalItems(genre, pageSize, pageNumber, vodType, requestType, isAvailableOnly, showType, orderBy) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, requestType, vodType, genre, undefined, orderBy, showType, isAvailableOnly);
    }
    /**
     * Get SVOD items.
     *
     * @param {Genre} genre
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {VodType} vodType: expected VodType.SVOD or VodType.CraveTV
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getSVODItems(genre, pageSize, pageNumber, vodType = VodType.SVOD, showType) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, undefined, vodType, genre, undefined, "name ASC", showType);
    }
    /**
     * Get SVOD season episodes.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getSVODSeasonEpisodes(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.SVOD, itemId, RelatedType.Children, pageSize, pageNumber, "episode_num ASC");
    }
    /**
     * Get SVOD seasons.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getSVODSeasons(itemId, pageSize, pageNumber) {
        return this.getRelatedOnDemand(ContentType.SVOD, itemId, RelatedType.Seasons, pageSize, pageNumber, "episode_num ASC");
    }
    /**
     * Search by All.
     *
     * @param {string} searchKeyWord
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {VodType} vodType
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async searchByAll(searchKeyWord, pageSize, pageNumber, vodType, showType) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.SearchByName, vodType, undefined, searchKeyWord, "release_date DESC", showType);
    }
    /**
    * get recently onDemand.
    *
    * @param {number} pageSize
    * @param {number} pageNumber
    * @param {ShowTypes} showType
    * @return {Promise<OnDemandContent>}
    */
    async getRecentlyOnDemand(pageSize, pageNumber, showType) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.NewlyReleased, undefined, undefined, undefined, undefined, showType, undefined, undefined);
    }
    /**
     * Get most popular vod.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getMostPopular(pageSize, pageNumber, showType) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.MostPopularVod, undefined, undefined, undefined, "desc", showType ?? ShowTypes.None, undefined, false);
    }
    /**
     * Get all movies.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Genre} genre
     * @return {Promise<OnDemandContent>}
     */
    async getAllMovies(pageSize, pageNumber, genre) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.AllItems, VodType.All, genre, undefined, "name ASC", ShowTypes.Movie, true);
    }
    /**
     * Get all shows.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Genre} genre
     * @return {Promise<OnDemandContent>}
     */
    async getAllShows(pageSize, pageNumber, genre) {
        return this.getOnDemand(ContentType.SVOD, pageSize, pageNumber, OnDemandRequestType.AllItems, VodType.All, genre, undefined, "name ASC", ShowTypes.Series, true);
    }
    /**
     * Basic On-Demand Request.
     *
     * @param {ContentType} type
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {OnDemandRequestType} requestType
     * @param {VodType} vodType
     * @param {Genre} genre
     * @param {string} searchText
     * @param {string} orderBy
     * @param {ShowType} showType
     * @param {boolean} isAvailableOnly
     * @param {boolean} groupSeasons
     *
     * @return {Promise<OnDemandContent>}
     * @private
     */
    async getOnDemand(type, pageSize, pageNumber, requestType, vodType, genre, searchText, orderBy, showType, isAvailableOnly, groupSeasons) {
        const { data } = await this.api.api.vodAppCreate({
            appName: this.applicationName,
            request: {
                filter: {
                    availableOnly: isAvailableOnly,
                    contentGenre: genre === undefined
                        ? undefined
                        : {
                            childrenIDs: genre.childrenIds?.concat() ?? undefined,
                            genreType: genre.genreType ?? undefined,
                            id: genre.id ?? undefined,
                            images: genre.images?.map(({ id, type }) => ({
                                Id: id ?? undefined,
                                Type: type ?? undefined
                            })) ?? undefined,
                            name: genre.name ?? undefined,
                            orderNumber: genre.orderNumber ?? undefined,
                            parentID: genre.parentId ?? undefined,
                            vodType: genre.vodType ?? undefined
                        },
                    contentType: type,
                    GroupSeasons: groupSeasons ?? true,
                    HasImagesOnly: false,
                    keyWord: searchText,
                    orderBy: orderBy ?? "name ASC",
                    ShowType: showType
                },
                paging: {
                    itemsOnPage: pageSize,
                    pageNumber: pageNumber
                },
                requestType: requestType,
                type: type,
                utcTime: true,
                vodType: vodType
            },
            sLang: this.language,
            siteId: this.siteId
        });
        return this.convertOnDemandContent(data);
    }
    /**
     * Related On-Demand Request.
     *
     * @param {ContentType} type
     * @param {number} itemId
     * @param {RelatedType} relatedType
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {string} orderBy
     * @return {Promise<OnDemandContent>}
     * @private
     */
    async getRelatedOnDemand(type, itemId, relatedType, pageSize, pageNumber, orderBy) {
        const { data } = await this.api.api.vodApprelatedCreate({
            appName: this.applicationName,
            request: {
                filter: {
                    contentGenre: undefined,
                    contentType: type,
                    GroupSeasons: true,
                    HasImagesOnly: false,
                    keyWord: undefined,
                    orderBy: orderBy
                },
                id: itemId,
                paging: {
                    itemsOnPage: pageSize,
                    pageNumber: pageNumber
                },
                relatedType: relatedType,
                type: type,
                utcTime: true
            },
            sLang: this.language,
            siteId: this.siteId
        });
        return this.convertOnDemandContent(data);
    }
}

/**
 * VOD repository.
 */
class VodRepository {
    domainsSettings;
    idbCacher;
    /**
     * Client's module.
     *
     * @type {VodModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Guest's module.
     *
     * @type {VodModuleInterface}
     * @private
     */
    guestModule;
    /**
     * Lifetime.
     *
     * @type {number}
     * @private
     */
    ttl = 24 * 60 * 60 * 1000; // 24 hours
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string} language
     * @param {string | null} sessionId
     */
    constructor(api, siteId, applicationName, language, domainsSettings, idbCacher) {
        this.domainsSettings = domainsSettings;
        this.idbCacher = idbCacher;
        this.guestModule = new VodGuestModule(api, siteId, applicationName, language);
        this.clientModule = new VodClientModule(api, domainsSettings);
    }
    /**
     * Get CraveTV details.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVDetails(itemId, pageSize, pageNumber) {
        const guestKey = `getCraveTVDetails:${itemId}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getCraveTVDetails:${this.domainsSettings.sessionId ?? ""}:${itemId}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getCraveTVDetails clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null) {
                return cachedResult;
            }
            const result = await this.clientModule.getCraveTVDetails(itemId, pageSize, pageNumber);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null) {
            return cachedResult;
        }
        const result = await this.guestModule.getCraveTVDetails(itemId, pageSize, pageNumber);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get CraveTV items.
     *
     * @param {Genre} genre
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVItems(genre, pageSize, pageNumber) {
        const guestKey = `getCraveTVItems:${genre.id ?? ""}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getCraveTVItems:${this.domainsSettings.sessionId ?? ""}:${genre.id ?? ""}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getCraveTVItems clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null) {
                return cachedResult;
            }
            const result = await this.clientModule.getCraveTVItems(genre, pageSize, pageNumber);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null) {
            return cachedResult;
        }
        const result = await this.guestModule.getCraveTVItems(genre, pageSize, pageNumber);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get CraveTV seasons episodes.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVSeasonEpisodes(itemId, pageSize, pageNumber) {
        const guestKey = `getCraveTVSeasonEpisodes:${itemId}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getCraveTVSeasonEpisodes:${this.domainsSettings.sessionId ?? ""}:${itemId}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getCraveTVSeasonEpisodes clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null) {
                return cachedResult;
            }
            const result = await this.clientModule.getCraveTVSeasonEpisodes(itemId, pageSize, pageNumber);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null) {
            return cachedResult;
        }
        const result = await this.guestModule.getCraveTVSeasonEpisodes(itemId, pageSize, pageNumber);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get CraveTV seasons.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getCraveTVSeasons(itemId, pageSize, pageNumber) {
        const guestKey = `getCraveTVSeasons:${itemId}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getCraveTVSeasons:${this.domainsSettings.sessionId ?? ""}:${itemId}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getCraveTVSeasons clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null) {
                return cachedResult;
            }
            const result = await this.clientModule.getCraveTVSeasons(itemId, pageSize, pageNumber);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null) {
            return cachedResult;
        }
        const result = await this.guestModule.getCraveTVSeasons(itemId, pageSize, pageNumber);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get new released movies.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getNewReleasedMovies(pageSize, pageNumber, genre) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getNewReleasedMovies(pageSize, pageNumber, genre);
        }
        return this.guestModule.getNewReleasedMovies(pageSize, pageNumber, genre);
    }
    /**
     * Get most popular vod.
     *
     * @param {number} type
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {number} vodType
     * @param {Genre} genre
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getMostPopularVod(type, pageSize, pageNumber, vodType, genre, showType) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getMostPopularVod(type, pageSize, pageNumber, vodType, genre, showType);
        }
        return this.guestModule.getMostPopularVod(type, pageSize, pageNumber, vodType, genre, showType);
    }
    /**
     * Get new released shows.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getNewReleasedShows(pageSize, pageNumber, genre) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getNewReleasedShows(pageSize, pageNumber, genre);
        }
        return this.guestModule.getNewReleasedShows(pageSize, pageNumber, genre);
    }
    /**
     * Get related CraveTV.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getRelatedCraveTV(itemId, pageSize, pageNumber) {
        const guestKey = `getRelatedCraveTV:${itemId}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getRelatedCraveTV:${this.domainsSettings.sessionId ?? ""}:${itemId}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getRelatedCraveTV clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null) {
                return cachedResult;
            }
            const result = await this.clientModule.getRelatedCraveTV(itemId, pageSize, pageNumber);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null) {
            return cachedResult;
        }
        const result = await this.guestModule.getRelatedCraveTV(itemId, pageSize, pageNumber);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get related SVOD.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getRelatedSVOD(itemId, pageSize, pageNumber) {
        const guestKey = `getRelatedSVOD:${itemId}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getRelatedSVOD:${this.domainsSettings.sessionId ?? ""}:${itemId}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getRelatedSVOD clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null) {
                return cachedResult;
            }
            const result = await this.clientModule.getRelatedSVOD(itemId, pageSize, pageNumber);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null) {
            return cachedResult;
        }
        const result = await this.guestModule.getRelatedSVOD(itemId, pageSize, pageNumber);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get SVOD details.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getSVODDetails(itemId, pageSize, pageNumber) {
        const guestKey = `getSVODDetails:${itemId}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getSVODDetails:${this.domainsSettings.sessionId ?? ""}:${itemId}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getSVODDetails clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null) {
                return cachedResult;
            }
            const result = await this.clientModule.getSVODDetails(itemId, pageSize, pageNumber);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null) {
            return cachedResult;
        }
        const result = await this.guestModule.getSVODDetails(itemId, pageSize, pageNumber);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get SVOD internal items for genres.
     *
     * @param {Genre} genre
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {VodType} vodType: expected VodType.SVOD or VodType.CraveTV
     * @param {ShowTypes} showType
     * @param {boolean} cashDisabled
     * @return {Promise<OnDemandContent>}
     */
    async getSVODInternalItems(genre, pageSize, pageNumber, vodType, requestType, isAvailableOnly, showType, orderBy, cashDisabled) {
        const guestKey = `getSVODInternalItems:${showType ?? ShowTypes.None}:${genre.id ?? ""}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getSVODInternalItems:${this.domainsSettings.sessionId ?? ""}:${showType ?? ShowTypes.None}:${genre.id ?? ""}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getSVODInternalItems clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null && !cashDisabled) {
                return cachedResult;
            }
            const result = await this.clientModule.getSVODInternalItems(genre, pageSize, pageNumber, vodType, requestType, isAvailableOnly, showType, orderBy);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null && !cashDisabled) {
            return cachedResult;
        }
        const result = await this.guestModule.getSVODInternalItems(genre, pageSize, pageNumber, vodType, requestType, isAvailableOnly, showType, orderBy);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get SVOD items.
     *
     * @param {Genre} genre
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {VodType} vodType: expected VodType.SVOD or VodType.CraveTV
     * @param {ShowTypes} showType
     * @param {boolean} cashDisabled
     * @return {Promise<OnDemandContent>}
     */
    async getSVODItems(genre, pageSize, pageNumber, vodType, showType, cashDisabled) {
        const guestKey = `getSVODItems:${genre.id ?? ""}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getSVODItems:${this.domainsSettings.sessionId ?? ""}:${genre.id ?? ""}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getSVODItems clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null && !cashDisabled) {
                return cachedResult;
            }
            const result = await this.clientModule.getSVODItems(genre, pageSize, pageNumber, vodType, showType);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null && !cashDisabled) {
            return cachedResult;
        }
        const result = await this.guestModule.getSVODItems(genre, pageSize, pageNumber, vodType, showType);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get SVOD season episodes.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getSVODSeasonEpisodes(itemId, pageSize, pageNumber) {
        const guestKey = `getSVODSeasonEpisodes:${itemId}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getSVODSeasonEpisodes:${this.domainsSettings.sessionId ?? ""}:${itemId}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getSVODSeasonEpisodes clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null) {
                return cachedResult;
            }
            const result = await this.clientModule.getSVODSeasonEpisodes(itemId, pageSize, pageNumber);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null) {
            return cachedResult;
        }
        const result = await this.guestModule.getSVODSeasonEpisodes(itemId, pageSize, pageNumber);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Get SVOD seasons.
     *
     * @param {number} itemId
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<OnDemandContent>}
     */
    async getSVODSeasons(itemId, pageSize, pageNumber) {
        const guestKey = `getSVODSeasons:${itemId}:${pageSize}:${pageNumber}`;
        // Client side
        if (typeof this.domainsSettings.sessionId === "string") {
            const clientKey = `getSVODSeasons:${this.domainsSettings.sessionId ?? ""}:${itemId}:${pageSize}:${pageNumber}`;
            // clear guest user cache if have
            this.idbCacher.has(guestKey).then(async (has) => {
                if (has) {
                    await this.idbCacher.del(guestKey).catch((e) => {
                        console.error(e);
                    });
                }
            }).catch((e) => {
                console.error('getSVODSeasons clear guest cache in client context', e);
            });
            const hasIsNotExpired = await this.idbCacher.has(clientKey).catch((e) => {
                console.error(e);
            });
            const cachedResult = await this.idbCacher.get(clientKey).catch((e) => {
                console.error(e);
                return null;
            });
            // return cached data for client if we have not expired
            if (hasIsNotExpired && cachedResult !== null) {
                return cachedResult;
            }
            const result = await this.clientModule.getSVODSeasons(itemId, pageSize, pageNumber);
            this.idbCacher.put(clientKey, result, { ttl: this.ttl }).catch((e) => {
                console.error(e);
            });
            return result;
        }
        // Guest side
        const hasIsNotExpired = await this.idbCacher.has(guestKey).catch((e) => {
            console.error(e);
        });
        const cachedResult = await this.idbCacher.get(guestKey).catch((e) => {
            console.error(e);
            return null;
        });
        // return cached data for guest if we have not expired
        if (hasIsNotExpired && cachedResult !== null) {
            return cachedResult;
        }
        const result = await this.guestModule.getSVODSeasons(itemId, pageSize, pageNumber);
        this.idbCacher.put(guestKey, result, { ttl: this.ttl }).catch((e) => {
            console.error(e);
        });
        return result;
    }
    /**
     * Search by All.
     *
     * @param {string} searchKeyWord
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {VodType} vodType
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async searchByAll(searchKeyWord, pageSize, pageNumber, vodType, showType) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.searchByAll(searchKeyWord, pageSize, pageNumber, vodType, showType);
        }
        return this.guestModule.searchByAll(searchKeyWord, pageSize, pageNumber, vodType, showType);
    }
    /**
     * get continue watching.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getContinueWatching(pageSize, pageNumber, showType) {
        if (typeof this.domainsSettings.sessionId === "string" && this.clientModule.getContinueWatching) {
            return this.clientModule.getContinueWatching(pageSize, pageNumber, showType);
        }
        // Continue watching requires authentication - return empty content for guest users
        return new OnDemandContent([], null);
    }
    /**
     * get recently onDemand
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getRecentlyOnDemand(pageSize, pageNumber, showType) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getRecentlyOnDemand(pageSize, pageNumber, showType);
        }
        return this.guestModule.getRecentlyOnDemand(pageSize, pageNumber, showType);
    }
    /**
     * get watch again.
     * Watch history requires authentication - returns empty content for guest users.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getWatchAgain(pageSize, pageNumber, showType) {
        if (typeof this.domainsSettings.sessionId === "string" && this.clientModule.getWatchAgain) {
            return this.clientModule.getWatchAgain(pageSize, pageNumber, showType);
        }
        // Watch history requires authentication - return empty content for guest users
        return new OnDemandContent([], null);
    }
    /**
     * get most popular VODs
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {ShowTypes} showType
     * @return {Promise<OnDemandContent>}
     */
    async getMostPopular(pageSize, pageNumber, showType) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getMostPopular(pageSize, pageNumber, showType);
        }
        return this.guestModule.getMostPopular(pageSize, pageNumber, showType);
    }
    /**
     * Get all movies.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Genre} genre
     * @return {Promise<OnDemandContent>}
     */
    async getAllMovies(pageSize, pageNumber, genre) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getAllMovies(pageSize, pageNumber, genre);
        }
        return this.guestModule.getAllMovies(pageSize, pageNumber, genre);
    }
    /**
     * Get all shows.
     *
     * @param {number} pageSize
     * @param {number} pageNumber
     * @param {Genre} genre
     * @return {Promise<OnDemandContent>}
     */
    async getAllShows(pageSize, pageNumber, genre) {
        if (typeof this.domainsSettings.sessionId === "string") {
            return this.clientModule.getAllShows(pageSize, pageNumber, genre);
        }
        return this.guestModule.getAllShows(pageSize, pageNumber, genre);
    }
}

/**
 * Guest's Search module.
 */
class SearchGuestModule extends Module {
    api;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api) {
        super();
        this.api = api;
    }
    /**
     * Get popular search words.
     *
     * @param {string | null} keyword
     * @param {number} take
     * @param {Language} language
     * @return {Promise<StringListSimpleResponse>}
     */
    async getSearchPopularWords(keyword, take, language) {
        const { data } = await this.api.api.contentPopularWordsCreate({
            Keyword: keyword,
            Take: take,
            Language: language,
        });
        return data;
    }
}

/**
 * Search repository.
 */
class SearchRepository {
    /**
     * Guest's module.
     *
     * @type {SearchModuleInterface}
     * @private
     */
    guestModule;
    /**
     * Repository constructor.
     *
     * @param {Api<unknown>} api
     */
    constructor(api) {
        this.guestModule = new SearchGuestModule(api);
    }
    /**
     * Get popular search words.
     *
     * @param {string | null} keyword
     * @param {number} take
     * @param {Language} language
     * @return {Promise<StringListSimpleResponse>}
     */
    async getSearchPopularWords(keyword, take, language) {
        return this.guestModule.getSearchPopularWords(keyword, take, language);
    }
}

var HomeContentType;
(function (HomeContentType) {
    HomeContentType[HomeContentType["Movies"] = 1] = "Movies";
    HomeContentType[HomeContentType["Sports"] = 2] = "Sports";
    HomeContentType[HomeContentType["Kids"] = 3] = "Kids";
    HomeContentType[HomeContentType["News"] = 4] = "News";
    HomeContentType[HomeContentType["Trends"] = 5] = "Trends";
    HomeContentType[HomeContentType["Olympics"] = 6] = "Olympics";
    HomeContentType[HomeContentType["LiveSeries"] = 7] = "LiveSeries";
})(HomeContentType || (HomeContentType = {}));

/**
 * Model of program guide.
 */
class ProgramGuide {
    items;
    filter;
    paging;
    /**
     * Entity constructor.
     *
     * @param {ReadonlyArray<ProgramGuideItem> | null} items Stored ProgramGuideItem items collection.
     * @param {ContentFilter | null} filter A ContentFilter object for search parameters.
     * @param {ItemPaging | null} paging Paging specification of the search result set.
     */
    constructor(
    /**
     * Stored ProgramGuideItem items collection.
     */
    items = null, 
    /**
     * A ContentFilter object for search parameters.
     */
    filter = null, 
    /**
     * Paging specification of the search result set.
     */
    paging = null) {
        this.items = items;
        this.filter = filter;
        this.paging = paging;
    }
}

/**
 * Model of media stream.
 */
class MediaStream {
    url;
    trickModeRestriction;
    mediaFormatId;
    drm;
    dar;
    /**
     * Entity constructor.
     *
     * @param {string | null} url Stream URL if Playlist is empty.
     * @param {TrickModeRestriction | null} trickModeRestriction Trick mode restriction.
     * @param {number | null} mediaFormatId Identifier of the media format of the stream.
     * @param {Drm | null} drm The data structure for DRM token storing.
     */
    constructor(
    /**
     * Stream URL if Playlist is empty.
     */
    url = null, 
    /**
     * Trick mode restriction.
     */
    trickModeRestriction = null, 
    /**
     * Identifier of the media format of the stream.
     */
    mediaFormatId = null, 
    /**
     * The data structure for DRM token storing.
     */
    drm = null, 
    /**
     * The video aspect ratio
     */
    dar = null) {
        this.url = url;
        this.trickModeRestriction = trickModeRestriction;
        this.mediaFormatId = mediaFormatId;
        this.drm = drm;
        this.dar = dar;
    }
}

/**
 * WathcedRange entity.
 */
class WatchedRange {
    Result;
    /**
     * Entity constructor.
     *
     * @param {RangeProperties[] | null} Result
     */
    constructor(
    /**
     * ContentProperties identifier.
     */
    Result) {
        this.Result = Result;
    }
}

/**
 * WathcedRange entity.
 */
class RangeProperties {
    Start;
    End;
    /**
     * Entity constructor.
     *
     * @param {number} Start
     * @param {number} End
     */
    constructor(
    /**
     * ContentProperties identifier.
     */
    Start, End) {
        this.Start = Start;
        this.End = End;
    }
}

/**
 * Model of proto item.
 */
class ProtoItem {
    id;
    contentType;
    /**
     * Entity constructor.
     *
     * @param {ProtoItemId | null} id Item unique identifier.
     * @param {ContentType | null} contentType Type of the item's content.
     */
    constructor(
    /**
     * Item unique identifier.
     */
    id = null, 
    /**
     * Type of the item's content.
     */
    contentType = null) {
        this.id = id;
        this.contentType = contentType;
    }
}

class ChannelsData {
    availableChannels;
    notAvailableChannels;
    outOfHomeChannels;
    constructor(availableChannels, notAvailableChannels, outOfHomeChannels) {
        this.availableChannels = availableChannels;
        this.notAvailableChannels = notAvailableChannels;
        this.outOfHomeChannels = outOfHomeChannels;
    }
}

/**
 * Model of client message.
 */
class ClientMessage {
    id;
    subject;
    body;
    sent;
    isRead;
    expires;
    type;
    /**
     * Entity constructor.
     *
     * @param {number | null} id Message identifier.
     * @param {string | null} subject Message subject matter.
     * @param {string | null} body Message text.
     * @param {string | null} sent Date and time when the message was sent.
     * @param {boolean | null} isRead Flag indicating that the message was read by a user.
     * @param {string | null} expires Message expiration date.
     * @param {ClientMessageType | null} type The type of the command.
     */
    constructor(
    /**
     * Message identifier.
     */
    id = null, 
    /**
     * Message subject matter.
     */
    subject = null, 
    /**
     * Message text.
     */
    body = null, 
    /**
     * Date and time when the message was sent.
     */
    sent = null, 
    /**
     * Flag indicating that the message was read by a user.
     */
    isRead = null, 
    /**
     * Message expiration date.
     */
    expires = null, 
    /**
     * The type of the command.
     */
    type = null) {
        this.id = id;
        this.subject = subject;
        this.body = body;
        this.sent = sent;
        this.isRead = isRead;
        this.expires = expires;
        this.type = type;
    }
}

/**
 * Credit entity.
 */
class Credit {
    person;
    role;
    characterName;
    images;
    image;
    /**
     * Entity constructor.
     *
     * @param {Person | null} person Person entity.
     * @param {Role | null} role Person's role entity.
     * @param {string | null} characterName Person's character name in the content item.
     * @param {Array<MediaImage> | null} images Array of media images assigned to the item.
     */
    constructor(
    /**
     * Person entity.
     */
    person = null, 
    /**
     * Person's role entity.
     */
    role = null, 
    /**
     * Person's character name in the content item.
     */
    characterName = null, 
    /**
     * Array of media images assigned to the item.
     */
    images = null, image = null) {
        this.person = person;
        this.role = role;
        this.characterName = characterName;
        this.images = images;
        this.image = image;
    }
    static getId(credit) {
        let character = (credit.characterName ?? "").replace(/[^a-zA-Z]/gm, "");
        return `${credit.person?.id}-${character}-${credit.role?.id}`;
    }
}

/**
 * Model of client's settings.
 */
class ClientSettings {
    language;
    clientServices;
    settings;
    streamPreference;
    /**
     * Entity constructor.
     *
     * @param {string | null} language Client's user interface language preference ('eng','fra','rus', etc.).
     * @param {ReadonlyArray<ClientSubscriptionService> | null} clientServices The list of available subscription services.
     * @param {ReadonlyArray<KeyValue> | null} settings Collection of key-value pairs used for passing additional client specific parameters in
     *     login process.
     * @param {StreamSettings | null} streamPreference Parameter that contains data structure that determines content delivery parameters.
     */
    constructor(
    /**
     * Client's user interface language preference ('eng','fra','rus', etc.).
     */
    language = null, 
    /**
     * The list of available subscription services.
     */
    clientServices = null, 
    /**
     * Collection of key-value pairs used for passing additional client specific parameters in login process.
     */
    settings = null, 
    /**
     * Parameter that contains data structure that determines content delivery parameters.
     */
    streamPreference = null) {
        this.language = language;
        this.clientServices = clientServices;
        this.settings = settings;
        this.streamPreference = streamPreference;
    }
}

class CreditsPage {
    items;
    paging;
    constructor(items, paging) {
        this.items = items;
        this.paging = paging;
    }
}

class GuideSearchFilter {
    searchText;
    dateFrom;
    dateTill;
    constructor(searchText, dateFrom, dateTill) {
        this.searchText = searchText;
        this.dateFrom = dateFrom;
        this.dateTill = dateTill;
    }
}

var PlayItemType;
(function (PlayItemType) {
    PlayItemType["Program"] = "program";
    PlayItemType["Channel"] = "channel";
})(PlayItemType || (PlayItemType = {}));

/**
 * Model of favorite channels.
 */
class FavoriteChannels {
    items;
    paging;
    /**
     * Entity constructor.
     *
     * @param {ReadonlyArray<ProtoItem> | null} items Stored ProtoItem items collection.
     * @param {ItemPaging | null} paging Paging specification of the search result set.
     */
    constructor(
    /**
     * Stored ProtoItem items collection.
     */
    items = null, 
    /**
     * Paging specification of the search result set.
     */
    paging = null) {
        this.items = items;
        this.paging = paging;
    }
}

/**
 * Model of PlayerTracks
 */
class PlayerTracks {
    id;
    kind;
    lang;
    language;
    label;
    /**
     * Entity constructor.
     *
     * @param {string | number} id
     * @param {string} kind
     * @param {string} lang
     * @param {string} language
     * @param {string} label
     */
    constructor(id = '', kind = '', lang = '', language = '', label = '') {
        this.id = id;
        this.kind = kind;
        this.lang = lang;
        this.language = language;
        this.label = label;
    }
}

/**
 * Model of AdultPin
 */
class AdultPin {
    title;
    type;
    /**
     * Entity constructor.
     *
     * @param {string} title
     * @param {number | Array<number> | null} type
     */
    constructor(title = '', type = null) {
        this.title = title;
        this.type = type;
    }
}

/**
 * Model of Counter
 */
class Counter {
    vod;
    mytv;
    search;
    home;
    genre;
    detail;
    /**
     * Entity constructor.
     *
     * @param {number} vod
     * @param {number} mytv
     * @param {number} search
     * @param {number} home
     * @param {number} genre
     * @param {number} detail
     *
     */
    constructor(vod = 0, mytv = 0, search = 0, home = 0, genre = 0, detail = 0) {
        this.vod = vod;
        this.mytv = mytv;
        this.search = search;
        this.home = home;
        this.genre = genre;
        this.detail = detail;
    }
}

/**
 * Model of user alert.
 */
class UserAlert {
    id;
    infoId;
    updated;
    expiration;
    caption;
    text;
    auxMessage;
    messageSoundUrl;
    backgroundColor;
    textColor;
    textSize;
    signalSoundUrl;
    severity;
    /**
     * Entity constructor.
     *
     * @param {string | null} Id
     */
    constructor(id = null, infoId = null, updated = null, expiration = null, caption = null, text = null, auxMessage = null, messageSoundUrl = null, backgroundColor = null, textColor = null, textSize = null, signalSoundUrl = null, severity = null) {
        this.id = id;
        this.infoId = infoId;
        this.updated = updated;
        this.expiration = expiration;
        this.caption = caption;
        this.text = text;
        this.auxMessage = auxMessage;
        this.messageSoundUrl = messageSoundUrl;
        this.backgroundColor = backgroundColor;
        this.textColor = textColor;
        this.textSize = textSize;
        this.signalSoundUrl = signalSoundUrl;
        this.severity = severity;
    }
}

const PublisherType = {
    VMEDIA: "VMEDIA",
    RIVERTV: "RIVERTV",
    FIZZTV: "FIZZTV",
    HEALTHUB: "HEALTHUB",
    FREEDOM: "FREEDOM"
};
const Domain = {
    VMEDIA: "Vmedia.ca",
    RIVERTV: "RiverTV.ca",
    FIZZTV: "Fizz.ca",
    HEALTHUB: "...",
    FREEDOM: "Freedommobile.ca"
};
const publisher = import.meta.env.VITE_PUBLISHER;
const applicationPlatform = import.meta.env.VITE_APPLICATION_PLATFORM;
const isSamsung = applicationPlatform === "SAMSUNG";
const isAmazon = applicationPlatform === "AMAZON";
const isTabletDevice = applicationPlatform === "TABLET";
const isTvDevice = applicationPlatform === "SAMSUNG" || applicationPlatform === "LG" || applicationPlatform === "AMAZON";
const isRiverTV = import.meta.env.VITE_PUBLISHER === PublisherType.RIVERTV;
const isVMedia = import.meta.env.VITE_PUBLISHER === PublisherType.VMEDIA;
const isFizzTV = import.meta.env.VITE_PUBLISHER === PublisherType.FIZZTV;
const isFreedom = import.meta.env.VITE_PUBLISHER === PublisherType.FREEDOM;
const brand = import.meta.env.VITE_PUBLISHER;
const domain = Domain[brand];
const swaggerUrl = import.meta.env.VITE_SWAGGER_URL;
const enableLog = import.meta.env.VITE_ENABLE_LOG === 'true' ? true : false;
const encryptionKey = import.meta.env.VITE_ENCRYPTION_KEY;
const oktaClientId = import.meta.env.VITE_OKTA_CLIENT_ID;
const oktaLoginEnabled = oktaClientId ? true : false;

var ApiTypes;
(function (ApiTypes) {
    ApiTypes["PROD"] = "production-api";
    ApiTypes["PREVIEW"] = "preview-api";
})(ApiTypes || (ApiTypes = {}));
var OktaApiEnvironment;
(function (OktaApiEnvironment) {
    OktaApiEnvironment["PROD"] = "PROD";
    OktaApiEnvironment["PREVIEW"] = "PREVIEW";
})(OktaApiEnvironment || (OktaApiEnvironment = {}));
/**
 * Model of DebugSettings.
 */
class DebugSettings {
    /**
     * Entity constructor.
     *
     * @param {Partial<DebugSettings>} options The options object.
     */
    constructor({ api = ApiTypes.PROD, oktaApi = OktaApiEnvironment.PROD } = {}) {
        this.api = api;
        this.oktaApi = oktaApi;
    }
    /**
     * The string represents which API is enabled.
     */
    api = null;
    oktaApi = null;
}

const excludedURLs$1 = [
    '/api/client/login'
];

const setupInterceptorDevMode = (config) => {
    const lsCacher = new LocalStorageCacher();
    const settings = lsCacher.get('debug-settings');
    const isPreviewApi = settings?.api === ApiTypes.PREVIEW;
    if (isPreviewApi) {
        if (!excludedURLs$1.some(url => config.url?.includes(url))) {
            const baseURL = `https://a2-preview.vmedia.ca`;
            config.baseURL = baseURL;
        }
        return config;
    }
    return config;
};

const IvParameter = 'nLUyB8%3I@qR27*Z'; //Length 16
const key = CryptoJS.enc.Utf8.parse(encryptionKey);
const iv = CryptoJS.enc.Utf8.parse(IvParameter);
/*-- Encryption --*/
const encrypt = (text) => {
    const cipherText = CryptoJS.AES.encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString();
    return cipherText;
};
/*-- Decryption --*/
const decrypt = (text) => {
    const decrypted = CryptoJS.AES.decrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};

var _excludedURLs;
(function (_excludedURLs) {
    _excludedURLs["restartStream"] = "/api/media/restartStream";
    _excludedURLs["clientStream"] = "/api/media/clientStream";
})(_excludedURLs || (_excludedURLs = {}));
var _errorMessages;
(function (_errorMessages) {
    _errorMessages["isNotValidAnymore"] = "is not valid anymore";
    _errorMessages["ipAddressHasChanged"] = "ip address has changed";
})(_errorMessages || (_errorMessages = {}));
const excludedURLs = [
    _excludedURLs.restartStream,
    _excludedURLs.clientStream,
];
const errorMessages = [
    _errorMessages.isNotValidAnymore,
    _errorMessages.ipAddressHasChanged
];
const SilentLogin = async ({ domains, SilentLoginOkta, fetchSettings, fetchFavChannelsIds, Login, setDisableSentry }) => {
    setDisableSentry();
    if (oktaLoginEnabled) {
        await SilentLoginOkta();
    }
    else {
        let loginParams = await domains.getLogin();
        if (loginParams.password) {
            loginParams.password = decrypt(loginParams.password);
            domains.lsCacher.purge();
            await Login({
                username: loginParams.username,
                password: loginParams.password
            });
        }
    }
    await fetchSettings();
    await fetchFavChannelsIds();
};

class MaintenanceApiHandler {
    static _numberOfAttempts = 0;
    static _brokenRequest = null;
    static _requestIsLocked = false;
    static _retryTimer = null;
    static _ApplicationStoreModule;
    static _router;
    static _preRetriesCount = 3;
    static resetRequestOffset = () => {
        this._numberOfAttempts = 0;
    };
    static getRandomMilliseconds = (min, max) => {
        const minSeconds = min * 60;
        const maxSeconds = max * 60;
        const randomSeconds = Math.floor(Math.random() * (maxSeconds - minSeconds + 1)) + minSeconds;
        return randomSeconds * 1000;
    };
    static retryIntervals = [
        this.getRandomMilliseconds(4, 6),
        this.getRandomMilliseconds(9, 11),
        this.getRandomMilliseconds(13, 17),
        this.getRandomMilliseconds(25, 35)
    ];
    static setBrokenRequest = (callback) => {
        this._brokenRequest = callback;
    };
    static isRequestIsLocked = () => {
        return this._requestIsLocked;
    };
    static setRequestLock = (lock) => {
        if (this._requestIsLocked && !lock) {
            this.resetRequestOffset();
            this.setBrokenRequest(null);
        }
        this._requestIsLocked = lock;
        this._ApplicationStoreModule.setIsRequestIsLocked(lock);
    };
    static showGlobalMaintenanceModal = (flag) => {
        const isShownGlobalMaintenanceModal = this._ApplicationStoreModule.getIsGlobalMaintenanceModalShow;
        if (this._router.currentRoute.value.name !== 'player' && isShownGlobalMaintenanceModal !== flag) {
            this._ApplicationStoreModule.showGlobalMaintenanceModal(flag);
        }
    };
    static showPlayerMaintenanceModal = (flag) => {
        this._ApplicationStoreModule.showPlayerMaintenanceModal(flag);
    };
    static getRandomOffset = () => {
        return this.retryIntervals[this._numberOfAttempts];
    };
    static isMaintenanceError = (error) => {
        if (!error) {
            return false;
        }
        const status = error.response?.status;
        return status !== undefined && status >= 500 && status < 600 && status !== 500 && status !== 507;
    };
    static makeRequestWithRetry = async () => {
        if (!this._brokenRequest) {
            return;
        }
        for (let attempt = 1; attempt <= this._preRetriesCount; attempt++) {
            try {
                const response = await this._brokenRequest();
                this.resetAll();
                return response;
            }
            catch (error) {
                if (axios.isAxiosError(error) && this.isMaintenanceError(error)) {
                    if (attempt === this._preRetriesCount) {
                        await this.autoRetry();
                        this.showGlobalMaintenanceModal(true);
                    }
                }
            }
        }
    };
    static resetAll = () => {
        const isShownGlobalMaintenanceModal = this._ApplicationStoreModule.getIsGlobalMaintenanceModalShow;
        this.setRequestLock(false);
        this.showGlobalMaintenanceModal(false);
        this.showPlayerMaintenanceModal(false);
        if (this._retryTimer) {
            clearInterval(this._retryTimer);
            this._retryTimer = null;
        }
        if (isShownGlobalMaintenanceModal) {
            window.location.href = window.location.origin;
        }
    };
    static manualRetry = async () => {
        if (this._brokenRequest) {
            try {
                this._ApplicationStoreModule.setManualRetryLoading(true);
                await this._brokenRequest();
                this.resetAll();
            }
            catch (error) {
                console.error("Manual retry failed", error);
                throw error;
            }
            finally {
                this._ApplicationStoreModule.setManualRetryLoading(false);
            }
        }
    };
    static autoRetry = async () => {
        let totalTime = this.getRandomOffset() / 1000;
        if (this._numberOfAttempts < this.retryIntervals.length) {
            this._retryTimer = setInterval(async () => {
                totalTime -= 1;
                this._ApplicationStoreModule.setMaintenanceTimerInSeconds(totalTime);
                if (totalTime <= 0) {
                    clearInterval(this._retryTimer);
                    this._retryTimer = null;
                    try {
                        if (this._brokenRequest) {
                            await this._brokenRequest();
                            this.resetAll();
                        }
                    }
                    catch (error) {
                        if (this.isMaintenanceError(error)) {
                            this._numberOfAttempts++;
                            this.autoRetry();
                        }
                        else {
                            console.error("Auto retry failed", error);
                        }
                    }
                }
            }, 1000);
        }
    };
    static initAppContext = (appContext) => {
        this._ApplicationStoreModule = appContext.$pinia._s.get("Application");
        this._router = appContext.$router;
    };
}

const isSessionExpired = (error) => {
    return (!!error.response?.data?.Message && errorMessages.some(message => error.response?.data.Message?.toLowerCase()?.includes(message))) || error.response?.status == 401;
};

const setupInterceptors = (appContext, proxyContext) => {
    proxyContext.instance.interceptors.request.use(async (_config) => {
        const { $router } = appContext;
        const config = setupInterceptorDevMode(_config);
        if (MaintenanceApiHandler.isRequestIsLocked()) {
            if ($router.currentRoute.value.name === 'player') {
                try {
                    await MaintenanceApiHandler.manualRetry();
                    return config;
                }
                catch (error) {
                    console.error('Error in the player', error);
                    MaintenanceApiHandler.showPlayerMaintenanceModal(true);
                }
            }
            MaintenanceApiHandler.showGlobalMaintenanceModal(true);
            // Always reject with an Error instance to avoid unhandled rejection with `undefined`
            return Promise.reject(new Error('Request is locked by maintenance'));
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    proxyContext.instance.interceptors.response.use((response) => {
        return response;
    }, async (error) => {
        const { $pinia, $domains } = appContext;
        const AccountStoreModule = $pinia._s.get("Account");
        const FavoriteChannelsStoreModule = $pinia._s.get("FavoriteChannels");
        const UserSettingsStoreModule = $pinia._s.get("UserSettings");
        const PlayerStoreModule = $pinia._s.get("Player");
        const ApplicationStore = $pinia._s.get("Application");
        const SearchPageStore = $pinia._s.get("SearchPage");
        ApplicationStore.setEnableSentry();
        MaintenanceApiHandler.initAppContext(appContext);
        if (MaintenanceApiHandler.isRequestIsLocked()) {
            // Always reject with an Error instance to avoid unhandled rejection with `undefined`
            return Promise.reject(new Error('Request is locked by maintenance'));
        }
        if (error.response) {
            if (MaintenanceApiHandler.isMaintenanceError(error)) {
                MaintenanceApiHandler.setBrokenRequest(async () => {
                    await axios.request({ ...error.config });
                });
                MaintenanceApiHandler.setRequestLock(true);
                MaintenanceApiHandler.makeRequestWithRetry();
                return Promise.reject(error);
            }
            if (isSessionExpired(error)) {
                if (!excludedURLs.some(url => error.config?.url?.includes(url))) {
                    if (!proxyContext.isReloginInProgress) {
                        proxyContext.isReloginInProgress = true;
                        try {
                            console.warn('Session expired. Attempting to relogin...');
                            const params = {
                                domains: $domains,
                                SilentLoginOkta: AccountStoreModule.SilentLoginOkta,
                                fetchSettings: UserSettingsStoreModule.fetchSettings,
                                fetchFavChannelsIds: FavoriteChannelsStoreModule.fetchFavChannelsIds,
                                Login: AccountStoreModule.Login,
                                setDisableSentry: ApplicationStore.setDisableSentry
                            };
                            await SilentLogin(params);
                            const playerAvailability = PlayerStoreModule?.playerAvailability;
                            // reload application if player is not available
                            if (!playerAvailability) {
                                SearchPageStore.clearQuery();
                                AccountStoreModule.SetStatus();
                                window.location.href = window.location.origin;
                            }
                        }
                        catch (error) {
                            console.error(`Error in proxy api relogin: ${error}; Reload application`);
                            localStorage.clear();
                            window.location.href = window.location.origin;
                        }
                        finally {
                            proxyContext.isReloginInProgress = false;
                        }
                    }
                }
            }
        }
        return Promise.reject(error);
    });
};
class ProxyApi extends Api {
    instance;
    isReloginInProgress = false;
    constructor(axiosConfig, context) {
        super(axiosConfig);
        this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
        setupInterceptors(context, this);
    }
}
class ProxyApiV3 extends Api$1 {
    instance;
    isReloginInProgress = false;
    constructor(axiosConfig, context) {
        super(axiosConfig);
        this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
        setupInterceptors(context, this);
    }
}

/**
 * Client's client module.
 */
class OktaClientModule extends Module {
    apiOkta;
    api;
    deviceInformation;
    siteId;
    applicationName;
    domainsSettings;
    settings;
    /**
     * Module constructor.
     *
     * @param {ApiOkta<unknown>} apiOkta Okta API client interface.
     * @param {Api<unknown>} api API client interface.
     * @param {DeviceInformation} deviceInformation Device information.
     * @param {number} siteId Site identifier.
     * @param {string} applicationName Application identifier.
     * @param {DomainSettings} domainsSettings Domain configuration including session context.
     * @param {ReadonlyArray<KeyValue>} settings Account settings.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    apiOkta, 
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Device information.
     */
    deviceInformation, 
    /**
    * Site identifier.
    *
    * @private
    */
    siteId, 
    /**
    * Application identifier.
    *
    * @private
    */
    applicationName, 
    /**
     * Domain configuration including session context.
     *
     * @private
     */
    domainsSettings, 
    /**
     * Account settings.
     *
     * @private
     */
    settings) {
        super();
        this.apiOkta = apiOkta;
        this.api = api;
        this.deviceInformation = deviceInformation;
        this.siteId = siteId;
        this.applicationName = applicationName;
        this.domainsSettings = domainsSettings;
        this.settings = settings;
    }
    /**
     * Get device settings.
     *
     * @return {Promise<OktaDevice>}
     */
    async getDevice() {
        const value = 'client_id=' + `${oktaClientId}` +
            '&scope=' + "openid profile offline_access";
        const { data } = await this.apiOkta.apiOkta.getDevice(value);
        return this.convertOktaDevice(data);
    }
    /**
     * Get device settings.
     *
     * @return {Promise<any>}
     */
    async getToken(deviceCode) {
        const value = 'client_id=' + `${oktaClientId}` +
            '&grant_type=' + "urn:ietf:params:oauth:grant-type:device_code" + '&device_code=' + deviceCode;
        const { data } = await this.apiOkta.apiOkta.getToken(value);
        return this.convertOktaToken(data);
    }
    async loginOkta(accessToken) {
        const { data } = await this.api.api.clientLoginOktaCreate({
            AccessToken: accessToken,
            cc: {
                appSettings: {
                    appName: this.applicationName,
                    settings: this.settings.map((element) => ({
                        description: element.description ?? undefined,
                        key: element.key ?? undefined,
                        value: element.value ?? undefined
                    })),
                    siteID: this.siteId
                },
                clientCredentials: {
                    StbMacAddress: this.deviceInformation.macAddress ?? undefined,
                }
            },
            deviceInformation: {
                DeviceId: this.deviceInformation.deviceId ?? undefined,
                model: this.deviceInformation.model ?? undefined
            }
        });
        return this.convertOktaClientAppSettings(data);
    }
    async silentLoginOkta(refreshToken) {
        const { data } = await this.api.api.clientLoginOktaCreate({
            RefreshToken: refreshToken,
            cc: {
                appSettings: {
                    appName: this.applicationName,
                    settings: this.settings.map((element) => ({
                        description: element.description ?? undefined,
                        key: element.key ?? undefined,
                        value: element.value ?? undefined
                    })),
                    siteID: this.siteId
                },
                clientCredentials: {
                    StbMacAddress: this.deviceInformation.macAddress ?? undefined,
                }
            },
            deviceInformation: {
                DeviceId: this.deviceInformation.deviceId ?? undefined,
                model: this.deviceInformation.model ?? undefined
            }
        });
        return this.convertOktaClientAppSettings(data);
    }
    async logoutOkta(refreshToken) {
        await this.api.api.clientLogoutOktaCreate({
            RefreshToken: refreshToken,
            cc: {
                clientCredentials: {
                    sessionID: this.domainsSettings.sessionId
                }
            },
            deviceInformation: {}
        });
        this.domainsSettings.sessionId = null;
    }
}

class OktaRepository {
    /**
     * Client's module.
     *
     * @type {OktaModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Repository constructor.
     *
     * @param {ApiOkta<unknown>} apiOkta
     * @param {Api<unknown>} api
     * @param {CacherInterface} cacher
     * @param {number} siteId
     * @param {string} applicationName
     * @param {string} language
     * @param {DeviceInformation} deviceInformation
     */
    constructor(apiOkta, api, deviceInformation, siteId, applicationName, domainsSettings, settings) {
        this.clientModule = new OktaClientModule(apiOkta, api, deviceInformation, siteId, applicationName, domainsSettings, settings);
    }
    /**
     * Get movies recommendations.
     *
     * @param {number} top
     * @return {Promise<any>}
     */
    async getAuthenticationLink() {
        return this.clientModule.getDevice();
    }
    async getToken(deviceCode) {
        return this.clientModule.getToken(deviceCode);
    }
    async loginOkta(accessToken) {
        return this.clientModule.loginOkta(accessToken);
    }
    async logoutOkta(refreshToken) {
        return this.clientModule.logoutOkta(refreshToken);
    }
    async silentLoginOkta(refreshToken) {
        return this.clientModule.silentLoginOkta(refreshToken);
    }
}

/**
 * Model of OktaDevice
 */
class OktaDevice {
    deviceCode;
    expiresIn;
    interval;
    userCode;
    verificationUri;
    verificationUriComplete;
    /**
     * Entity constructor.
     *
     * @param {string | null} deviceCode
     * @param {number | null} expiresIn
     * @param {number | null} interval
     * @param {string | null} userCode
     * @param {string | null} verificationUri
     * @param {string | null} verificationUriComplete
     *
     */
    constructor(deviceCode = null, expiresIn = null, interval = null, userCode = null, verificationUri = null, verificationUriComplete = null) {
        this.deviceCode = deviceCode;
        this.expiresIn = expiresIn;
        this.interval = interval;
        this.userCode = userCode;
        this.verificationUri = verificationUri;
        this.verificationUriComplete = verificationUriComplete;
    }
}

/**
 * Model of OktaToken
 */
class OktaToken {
    tokenType;
    expiresIn;
    accessToken;
    scope;
    refreshToken;
    idToken;
    /**
     * Entity constructor.
     *
     * @param {string} tokenType
     * @param {number} expiresIn
     * @param {string} accessToken
     * @param {string} scope
     * @param {string} refreshToken
     * @param {string} idToken
     *
     */
    constructor(tokenType = "", expiresIn = 0, accessToken = "", scope = "", refreshToken = "", idToken = "") {
        this.tokenType = tokenType;
        this.expiresIn = expiresIn;
        this.accessToken = accessToken;
        this.scope = scope;
        this.refreshToken = refreshToken;
        this.idToken = idToken;
    }
}

/**
 * Range Progress.
 */
class RangeProgress {
    start;
    width;
    /**
     * Entity constructor.
     *
     * @param {number} start beginning of progress
     * @param {number} width Person full name.
     */
    constructor(
    /**
     * beginning of progress.
     */
    start = 0, 
    /**
     * Person full name.
     */
    width = 0) {
        this.start = start;
        this.width = width;
    }
}

/**
 * Model of client app settings.
 */
class RegisterTrialResponse {
    registrationStatus;
    session;
    constructor(registrationStatus = null, session = null) {
        this.registrationStatus = registrationStatus;
        this.session = session;
    }
}

/**
 * Client's client module.
 */
class NpasClientModule extends Module {
    api;
    domainsSettings;
    /**
     * Module constructor.
     *
     * @param {Api<unknown>} api API client interface.
     * @param {DomainSettings} domainsSettings Domain configuration including session context.
     */
    constructor(
    /**
     * API client interface.
     *
     * @private
     */
    api, 
    /**
     * Domain configuration including session context.
     *
     * @private
     */
    domainsSettings) {
        super();
        this.api = api;
        this.domainsSettings = domainsSettings;
    }
    /**
     * Get alert check message.
     *
     * @return {Promise<number[]>}
     */
    async getMessageAlertCheck() {
        const sessionId = this.domainsSettings.sessionId;
        const { data } = await this.api.api.alertCheckDetail(sessionId);
        return data;
    }
    /**
     * Get alerts by ids
     *
     * @return {Promise<number[]>}
     */
    async getAlertRetrieve(alerts) {
        const { data } = await this.api.api.alertRetrieveCreate(alerts);
        return this.convertAlertRetrieve(data);
    }
    /**
     * Marks user alerts as read
     *
     * @return {Promise<number[]>}
     */
    async setAlertAck(alerts) {
        const sessionId = this.domainsSettings.sessionId;
        const { data } = await this.api.api.alertAckCreate({
            sessionId: sessionId,
            alerts: alerts
        });
        return data;
    }
}

class NpasRepository {
    /**
     * Client's module.
     *
     * @type {NpasModuleInterface}
     * @private
     */
    clientModule;
    /**
     * Repository constructor.
     *
     * @param {ApiNpas<unknown>} apiNpas
     * @param {DomainSettings} domainsSettings
     */
    constructor(apiNpas, domainsSettings) {
        this.clientModule = new NpasClientModule(apiNpas, domainsSettings);
    }
    /**
     * Get alert check message.
     *
     * @return {Promise<number[]>}
     */
    async getMessageAlertCheck() {
        return this.clientModule.getMessageAlertCheck();
    }
    /**
     * Get alerts by ids
     *
     * @param {number[]} alerts
     * @return {Promise<UserAlert[]>}
     */
    async getAlertRetrieve(alerts) {
        return this.clientModule.getAlertRetrieve(alerts);
    }
    /**
     * Marks user alerts as read
     *
     * @param {number[]} alerts
     * @return {Promise<boolean>}
     */
    async setAlertAck(alerts) {
        return this.clientModule.setAlertAck(alerts);
    }
}

/**
 * The app error class
 */
class AppError {
    code;
    message;
    constructor(code = null, message = null) {
        this.code = code;
        this.message = message;
    }
}

/**
 * Enum for application error codes
 */
var AppErrorCode;
(function (AppErrorCode) {
    AppErrorCode["OK"] = "OK";
    AppErrorCode["NOT_SUPPORTED_PLATFORM"] = "NOT_SUPPORTED_PLATFORM";
    AppErrorCode["CHUNK_ERROR"] = "CHUNK_ERROR";
    AppErrorCode["FATAL_ERROR"] = "FATAL_ERROR";
    AppErrorCode["LOGIN_NOT_FOUND"] = "NOT_FOUND";
    AppErrorCode["LOGIN_LOCATION_DENIED"] = "ERRGEO";
    AppErrorCode["LOGIN_NETWORK_ERROR"] = "NETWORK_ERROR";
    AppErrorCode["LOGIN_NO_USER"] = "NO_USER";
    AppErrorCode["LOGIN_TOKEN_ERROR"] = "LOGIN_TOKEN_ERROR";
    AppErrorCode["SETTINGS_NO_SUBSCRIPTION_ERROR"] = "NO_SUBSCRIPTION_ERROR";
    AppErrorCode["OKTA_INVALID_REFRESH_TOKEN"] = "INVALID_REFRESH_TOKEN";
    AppErrorCode["OKTA_INVALID_ACCESS_TOKEN"] = "INVALID_ACCESS_TOKEN";
})(AppErrorCode || (AppErrorCode = {}));

/**
 * Model of verification code.
 */
class VerificationCode {
    verificationCode;
    deviceId;
    activeTillDate;
    activationUrl;
    /**
     * Entity constructor.
     *
     * @param {string | null} verificationCode
     * @param {string | null} deviceId
     * @param {string | null} activeTillDate
     * @param {string | null} activationUrl
     */
    constructor(verificationCode = null, deviceId = null, activeTillDate = null, activationUrl = null) {
        this.verificationCode = verificationCode;
        this.deviceId = deviceId;
        this.activeTillDate = activeTillDate;
        this.activationUrl = activationUrl;
    }
}

class VodPagingRequestData {
    itemsCount;
    pageNumber;
    constructor(itemsCount, pageNumber) {
        this.itemsCount = itemsCount;
        this.pageNumber = pageNumber;
    }
}

/**
 * Model of client app settings.
 */
class ClientAppSettings {
    clientCredentials;
    appSettings;
    /**
     * Entity constructor.
     *
     * @param {AccessCredentials | null} clientCredentials Data structure containing data used for identification of the application and for providing
     *     application settings.
     * @param {AppSettings | null} appSettings Data structure containing data used for authentication of a user and for providing user settings.
     */
    constructor(
    /**
     * Data structure containing data used for identification of the application and for providing application settings.
     */
    clientCredentials = null, 
    /**
     * Data structure containing data used for authentication of a user and for providing user settings.
     */
    appSettings = null) {
        this.clientCredentials = clientCredentials;
        this.appSettings = appSettings;
    }
}

/**
 * Credit entity.
 */
class MedioGraphy {
    person;
    personImage;
    mediographySections;
    /**
     * Entity constructor.
     *
     * @param {Person | null} person Person entity.
     * @param {MediaImage | null} personImage Media images assigned to the item.
     * @param {MedioGraphySection[] | null} mediographySections Mediography sections
     */
    constructor(
    /**
     * Person entity.
     */
    person = null, 
    /**
     * Media images assigned to the item.
     */
    personImage = null, 
    /**
     * Mediography sections
     */
    mediographySections = null) {
        this.person = person;
        this.personImage = personImage;
        this.mediographySections = mediographySections;
    }
}

/**
 * Credit entity.
 */
class MedioGraphySection {
    category;
    items;
    /**
     * Entity constructor.
     *
     * @param {Person | null} person Person entity.
     * @param {Role | null} role Person's role entity.
     * @param {string | null} characterName Person's character name in the content item.
     * @param {MediaImage | null} personImage Media images assigned to the item.
     */
    constructor(
    /**
     * Category of mediography.
     */
    category = null, 
    /**
     * Titles
     */
    items = null) {
        this.category = category;
        this.items = items;
    }
}

class ProxyApiNpas extends Api$2 {
    instance;
    constructor(axiosConfig) {
        super(axiosConfig);
        this.instance = axios.create({ ...axiosConfig });
        this.setupInterceptors();
    }
    setupInterceptors() {
        this.instance.interceptors.request.use((_config) => {
            const config = setupInterceptorDevMode(_config);
            return config;
        }, (error) => {
            return Promise.reject(error);
        });
    }
}

/**
* Restrictions for a media stream.

0 = None

1 = FastForward

2 = Rewind

3 = Rewind and FastForward

4 = Pause

5 = Pause and FastForward

6 = Pause and Rewind

7 = FastForward, Rewind and Pause

* @format int32
*/
var TrickModeRestriction;
(function (TrickModeRestriction) {
    TrickModeRestriction[TrickModeRestriction["None"] = 0] = "None";
    TrickModeRestriction[TrickModeRestriction["FastForward"] = 1] = "FastForward";
    TrickModeRestriction[TrickModeRestriction["Rewind"] = 2] = "Rewind";
    TrickModeRestriction[TrickModeRestriction["RewindFastForward"] = 3] = "RewindFastForward";
    TrickModeRestriction[TrickModeRestriction["Pause"] = 4] = "Pause";
    TrickModeRestriction[TrickModeRestriction["PauseFastForward"] = 5] = "PauseFastForward";
    TrickModeRestriction[TrickModeRestriction["RewindPause"] = 6] = "RewindPause";
    TrickModeRestriction[TrickModeRestriction["FastForwardRewindPause"] = 7] = "FastForwardRewindPause";
})(TrickModeRestriction || (TrickModeRestriction = {}));

const oktaSettings = {
    PREVIEW: {
        getDevice: '/oauth2/aus6vnd01nucYl1VX1d7/v1/authorize',
        getToken: '/oauth2/aus6vnd01nucYl1VX1d7/v1/token',
        baseURL: 'https://ppx-auth-fizz.videotron.com',
        clientID: {
            LG: '0oa7g3nlfvp0l74SV1d7',
            SAMSUNG: '0oa7g3n1rrv2guAog1d7'
        }
    },
    PROD: {
        getDevice: '/oauth2/aus4ah1q96x2bjArV697/v1/device/authorize',
        getToken: '/oauth2/aus4ah1q96x2bjArV697/v1/token',
        baseURL: 'https://auth.fizz.ca',
    },
};
class ProxyApiOkta extends ApiOkta {
    instance = {};
    constructor(axiosConfig) {
        super(axiosConfig);
        this.initializeInstance(axiosConfig);
    }
    initializeInstance(axiosConfig) {
        const lsCacher = new LocalStorageCacher();
        const settings = lsCacher.get('debug-settings');
        const isPreview = settings?.oktaApi === OktaApiEnvironment.PREVIEW;
        const baseURL = isPreview ? oktaSettings.PREVIEW.baseURL : oktaSettings.PROD.baseURL;
        this.instance = axios.create({ ...axiosConfig, baseURL });
        this.instance.interceptors.request.use((config) => {
            if (isPreview) {
                if (config.method?.toUpperCase() === 'POST' && config.data) {
                    try {
                        const params = new URLSearchParams(config.data);
                        // Set params client_id
                        params.set('client_id', oktaSettings.PREVIEW.clientID?.[applicationPlatform]);
                        config.data = params.toString();
                    }
                    catch (error) {
                        console.error('Error parsing data:', error);
                    }
                }
                // Set endpoint URLs
                switch (config.url) {
                    case oktaSettings.PROD.getDevice:
                        config.url = oktaSettings.PREVIEW.getDevice;
                        break;
                    case oktaSettings.PROD.getToken:
                        config.url = oktaSettings.PREVIEW.getToken;
                        break;
                }
            }
            return config;
        }, (error) => {
            return Promise.reject(error);
        });
    }
}

/**
 * Model of the settings of the device.
 */
class DeviceSettings {
    languageCode;
    hasTrial;
    settings;
    /**
     * Entity constructor.
     *
     * @param {string | null} languageCode The language code for a user ('eng','fra','rus', etc.).
     * @param {boolean | null} hasTrial The flag indicating whether a user has trial packages or not.
     * @param {KeyValue[] | null} settings Custom device settings
     */
    constructor(
    /**
     * The language code for a user ('eng','fra','rus', etc.).
     */
    languageCode = null, 
    /**
     * The flag indicating whether a user has trial packages or not.
     */
    hasTrial = null, 
    /**
    * Custom device settings
    */
    settings = null) {
        this.languageCode = languageCode;
        this.hasTrial = hasTrial;
        this.settings = settings;
    }
}

/**
 * Model of channels content.
 */
class ChannelsContent {
    items;
    type;
    filter;
    paging;
    UseUtcTime;
    /**
     * Entity constructor.
     *
     * @param {ReadonlyArray<Channel> | null} items Stored Channel items collection.
     * @param {OnDemandRequestType | null} requestType Defines search range for the content.
     * @param {ContentType | null} contentType Request type of items.
     * @param {ContentFilter | null} filter Contains filters to be used in content item requests.
     * @param {ItemPaging | null} paging Data structure for specifying the set of items sent during information retreival method calls.
     * @param {Boolean | null} UseUtcTime Request and response DateTime values will be in UTC time.
     */
    constructor(
    /**
     * Stored Channel items collection
     */
    items = null, 
    /**
     * Request type of items.
     */
    type = null, 
    /**
     * Contains filters to be used in content item requests
     */
    filter = null, 
    /**
     * Data structure for specifying the set of items sent during information retreival method calls.
     */
    paging = null, 
    /**
     * Request and response DateTime values will be in UTC time
     * */
    UseUtcTime = null) {
        this.items = items;
        this.type = type;
        this.filter = filter;
        this.paging = paging;
        this.UseUtcTime = UseUtcTime;
    }
}

/**
 * Model of client app settings.
 */
class OktaClientAppSettings {
    refreshToken;
    clientCredentials;
    appSettings;
    /**
     * Entity constructor.
     *
     * @param {string | null} refreshToken
     * @param {AccessCredentials | null} clientCredentials Data structure containing data used for identification of the application and for providing
     *     application settings.
     * @param {AppSettings | null} appSettings Data structure containing data used for authentication of a user and for providing user settings.
     */
    constructor(refreshToken = null, 
    /**
     * Data structure containing data used for identification of the application and for providing application settings.
     */
    clientCredentials = null, 
    /**
     * Data structure containing data used for authentication of a user and for providing user settings.
     */
    appSettings = null) {
        this.refreshToken = refreshToken;
        this.clientCredentials = clientCredentials;
        this.appSettings = appSettings;
    }
}

/**
 * Domain class.
 */
class Domains {
    deviceInformation;
    settings;
    applicationName;
    language;
    sessionId;
    siteId;
    baseURL;
    npasURL;
    context;
    /**
     * API interface.
     *
     * @type {Api<unknown>}
     */
    api;
    /**
     * API V3 interface.
     *
     * @type {Api<unknown>}
     */
    apiV3;
    /**
     * API Okta interface.
     *
     * @type {Api<unknown>}
     */
    apiOkta;
    /**
    * API NPAS interface.
    *
    * @type {Api<unknown>}
    */
    apiNpas;
    /**
     * Cacher interface.
     *
     * @type {CacherInterface}
     */
    lsCacher;
    /**
     * IDBCacher interface.
     *
     * @type {IDBCacherInterface}
     */
    idbCacher;
    /**
     * Channels repository.
     *
     * @type {ChannelsRepositoryInterface}
     */
    channelsRepository;
    /**
     * Client repository.
     *
     * @type {ClientRepositoryInterface}
     */
    clientRepository;
    /**
     * Credits repository.
     *
     * @type {CreditsRepositoryInterface}
     */
    creditsRepository;
    /**
     * Favorites repository.
     *
     * @type {FavoritesRepositoryInterface}
     */
    favoritesRepository;
    /**
     * Genres repository.
     *
     * @type {GenresRepositoryInterface}
     */
    genresRepository;
    /**
     * Guides repository.
     *
     * @type {GuidesRepositoryInterface}
     */
    guidesRepository;
    /**
     * Media repository.
     *
     * @type {MediaRepositoryInterface}
     */
    mediaRepository;
    /**
     * Resources repository.
     *
     * @type {ResourcesRepositoryInterface}
     */
    resourcesRepository;
    /**
     * VOD repository.
     *
     * @type {VodRepositoryInterface}
     */
    vodRepository;
    /**
     * Search repository.
     *
     * @type {SearchRepositoryInterface}
     */
    searchRepository;
    /**
     * Recommendations repository.
     *
     * @type {RecommendationsRepositoryInterface}
     */
    recommendationsRepository;
    /**
     * Images repository.
     *
     * @type {ImagesRepositoryInterface}
     */
    imagesRepository;
    /**
     * Recommendations repository.
     *
     * @type {RecommendationsRepositoryInterface}
     */
    oktaRepository;
    /**
    * Recommendations repository.
    *
    * @type {RecommendationsRepositoryInterface}
    */
    npasRepository;
    /**
     * Library settings.
     */
    domainsSettings;
    /**
     * Save user data in localstore for auto-login
     * @param username The logged user's username
     * @param sessionId The logged user's sessionId
     * @param StbMacAddress The logged user's mac addres
     * @param LoginCountry The logged user's country
     * @param UserSystemID The logged user's user system id
     * @param RefreshToken The logged user's refresh token
     */
    // TODO: move this method to repository
    async saveUserInfo(username, password, sessionId, StbMacAddress, LoginCountry, UserSystemID, RefreshToken, UserEmail, adultPin, vcloudDelay, IsOnNet) {
        const encryptedPassword = await encrypt(password);
        this.lsCacher.put("username", username);
        this.lsCacher.put("password", encryptedPassword);
        if (sessionId !== null) {
            this.lsCacher.put("sessionId", sessionId);
        }
        this.lsCacher.put("StbMacAddress", StbMacAddress);
        this.lsCacher.put("LoginCountry", LoginCountry);
        this.lsCacher.put("UserSystemID", UserSystemID);
        this.lsCacher.put("AdultPin", adultPin);
        this.lsCacher.put("VcloudDelay", vcloudDelay);
        this.lsCacher.put("RefreshToken", RefreshToken);
        this.lsCacher.put("UserEmail", UserEmail);
        this.lsCacher.put("isOutOfHome", IsOnNet === null ? null : !IsOnNet);
        this.domainsSettings.sessionId = sessionId;
    }
    /**
     * Load user data from localstore for auto-login
     * @returns {username, sessionId, StbMacAddress, LoginCountry, UserSystemID}
     */
    // TODO: move this method to repository
    async loadUserInfo() {
        const UserEmail = this.lsCacher.get("UserEmail");
        const username = this.lsCacher.get("username");
        const sessionId = this.lsCacher.get("sessionId");
        const StbMacAddress = this.lsCacher.get("StbMacAddress");
        const LoginCountry = this.lsCacher.get("LoginCountry");
        const UserSystemID = this.lsCacher.get("UserSystemID");
        const RefreshToken = this.lsCacher.get("RefreshToken");
        const isOutOfHome = this.lsCacher.get("isOutOfHome");
        this.domainsSettings.sessionId = sessionId;
        return { username, sessionId, StbMacAddress, LoginCountry, UserSystemID, RefreshToken, UserEmail, isOutOfHome };
    }
    async getLogin() {
        const username = this.lsCacher.get("username");
        const password = this.lsCacher.get("password");
        return { username, password };
    }
    /**
     * Specifies if the application is RiverTV app
     * @param isRiverTV - app is RiverTV if true, else false
     */
    // TODO: move this method to repository
    setIsRiverTV(isRiverTV) {
        this.domainsSettings.isRiverTV = isRiverTV;
    }
    /**
     * Specifies if the application is VmediaTV app
     * @param isVmediaTV - app is VmediaTV if true, else false
     */
    // TODO: move this method to repository
    setIsVmediaTV(isVmediaTV) {
        this.domainsSettings.isVmediaTV = isVmediaTV;
    }
    /**
     * Get device information
     */
    getDeviceInformation() {
        return this.deviceInformation;
    }
    /**
     * Domain constructor.
     *
     * @param {DeviceInformation} deviceInformation
     * @param {ReadonlyArray<KeyValue>} settings
     * @param {string} applicationName
     * @param {string} language
     * @param {string | null} sessionId
     * @param {number} siteId
     * @param {string} baseURL
     * @param {string} npasURL
     * @param {any} context
     */
    constructor(deviceInformation, settings, applicationName, language, sessionId, siteId, baseURL, npasURL, context) {
        this.deviceInformation = deviceInformation;
        this.settings = settings;
        this.applicationName = applicationName;
        this.language = language;
        this.sessionId = sessionId;
        this.siteId = siteId;
        this.baseURL = baseURL;
        this.npasURL = npasURL;
        this.context = context;
        this.api = new ProxyApi({ baseURL }, context);
        this.apiV3 = new ProxyApiV3({ baseURL }, context);
        this.apiOkta = new ProxyApiOkta({ baseURL });
        this.apiNpas = new ProxyApiNpas({ baseURL: npasURL });
        this.lsCacher = new LocalStorageCacher();
        this.idbCacher = new IndexedDbCacher();
        this.domainsSettings = new DomainSettings();
        this.domainsSettings.sessionId = sessionId;
        this.channelsRepository = new ChannelsRepository(this.api, siteId, applicationName, language, this.domainsSettings);
        this.clientRepository = new ClientRepository(this.api, deviceInformation, siteId, applicationName, this.domainsSettings, settings);
        this.creditsRepository = new CreditsRepository(this.api, siteId, applicationName, language, this.domainsSettings, this.idbCacher);
        this.favoritesRepository = new FavoritesRepository(this.api, this.domainsSettings);
        this.genresRepository = new GenresRepository(this.api, siteId, applicationName, language, this.domainsSettings);
        this.guidesRepository = new GuidesRepository(this.api, this.apiV3, siteId, applicationName, language, this.domainsSettings);
        this.mediaRepository = new MediaRepository(this.api, siteId, applicationName, language, this.domainsSettings);
        this.resourcesRepository = new ResourcesRepository(this.api, siteId, applicationName, language, this.domainsSettings);
        this.vodRepository = new VodRepository(this.api, siteId, applicationName, language, this.domainsSettings, this.idbCacher);
        this.searchRepository = new SearchRepository(this.api);
        this.imagesRepository = new ImagesRepository(this.api, siteId, applicationName, language, this.domainsSettings);
        this.recommendationsRepository = new RecommendationsRepository(this.api, this.domainsSettings);
        this.oktaRepository = new OktaRepository(this.apiOkta, this.api, deviceInformation, siteId, applicationName, this.domainsSettings, settings);
        this.npasRepository = new NpasRepository(this.apiNpas, this.domainsSettings);
    }
}

export { AdultPin, ApiTypes, AppError, AppErrorCode, Channel, Channels, ChannelsContent, ChannelsData, ClientAppSettings, ClientMessage, ClientSettings, ContentItemProps, ContentProperties, Counter, Credit, CreditsPage, DebugSettings, DeviceSettings, Domains, EPGCache, FavoriteChannels, Genre, GuideConstants, GuideSearchFilter, HomeContentType, ItemPaging, KeyValue, MaintenanceApiHandler, MediaImage, MediaStream, MedioGraphy, MedioGraphySection, OktaApiEnvironment, OktaClientAppSettings, OktaDevice, OktaToken, OnDemandContent, OnDemandData, OnDemandItem, PlayItem, PlayItemType, PlayerTracks, ProgramGuide, ProgramGuideItem, ProgramsSegmentModel, ProtoItem, PublisherType, RangeProgress, RangeProperties, RegisterTrialResponse, SilentLogin, TrickModeRestriction, TypesUtils, UserAlert, VerificationCode, VodContentType, VodPagingRequestData, WatchedRange, brand, decrypt, domain, enableLog, encrypt, encryptionKey, errorMessages, isAmazon, isFizzTV, isFreedom, isRiverTV, isSamsung, isSessionExpired, isTabletDevice, isTvDevice, isVMedia, oktaClientId, publisher, swaggerUrl };
//# sourceMappingURL=index.esm.min.js.map
